// eslint-disable-next-line
export default {
  translation: {
    CustomErrorMsg: "Something Went Wrong. Please Try Again In Sometime",
    BackToHome: "Back to Home",
    today: "Today",
    helpGuide: "Help Guide",
    howItWorks: "How it works",
    somethingWentWrong: "Something went wrong",
    multipleSelected: "Multiple Selected",
    timesheetDashboard: "Timesheet Dashboard",
    patientDashboard: "Patient Dashboard",
    dentist: "Dentist",
    clickHere: "Click here",
    forSuppliers: "For Suppliers",
    supplier: "Supplier",
    homePagePatient: "Patient",
    okayGotIt: "Okay, Got it",
    features: "Features",
    accountTerminated: "Account Terminated",
    saveCardDetails: "Save Credit Card Details",
    needApproval: "Need Approval",
    dentist_plural: "Dentists",
    AppsFeatures: "Apps & Features",
    unPaidOrders: "UNPAID ORDERS",
    all: "All",
    accountUnderReview: "Account under review",
    accountUnderReviewContent:
      "Your account needs to be reviewed and approved by Miraxis Admin Team. If needed, Admin will contact you to receive more information about your company. It may take a few days to complete the approval process.",
    Currency: "Currency",
    changeSubscription24: "You can change subscription after 24 hours",
    selectOfficeIds: "Please select at least one office.",
    selectRoleIds: "Please select at least one Role.",
    currentlyUsingPackage:
      "You are currently using the ‘{{field}}’ subscription package.",
    perMonthperOffice: "/per month/per office",
    perMonthperStaff: "/per month/per staff",
    perStaff: "/per staff",
    schedulingEmptyMsg: "Please select staff member(s) to view the schedule",
    physician: "Physician",
    physician_plural: "Physicians",
    pharmacist: "Pharmacist",
    pharmacist_plural: "Pharmacists",
    personnel: "Personnel",
    vendor: "Vendor",
    md: "MD",
    md_plural: "MDs",
    aboutUs: "About Us",
    AboutMiraxis: "About Miraxis",
    contactUs: "Contact Us",
    login: "Log in",
    signup: "Signup",
    logoSubtitle: "Healthcare Technology Solutions",
    company: "Company",
    policies: "Policies",
    support: "Support",
    blog: "Blog",
    termsOfService: "Terms of Service",
    termsConditionsWithSymbol: "Terms & Conditions",
    termsAndConditions: "Terms and Conditions",
    termsAndConditionsPatient: "Terms and Conditions For Patient",
    termsAndConditionsSuppliers: "Terms and Conditions For Suppliers",
    privacyPolicy: "Privacy Policy",
    privacyPolicyPatient: "Privacy Policy  For Patient",
    privacyPolicySuppliers: "Privacy Policy  For Suppliers",
    scheduleADemo: "Schedule a Demo",
    scheduleADemoText: "Please complete the form and we'll get back to you.",
    miraxisSolutionsEmpowering: "Miraxis Solutions Empowering {{type}}",
    feature: "Feature",
    feature_plural: "Features",
    enterpriseSubscriptionContactTitle: "Enterprise Plan",
    enterpriseSubscriptionContactText:
      "Please contact our sales team to receive the information about Enterprise Subscription and Pricing option. Our team will provide a customized subscription plan that fits your organization structure. We will also support you in setting up all accounts for your offices and staff.",
    close: "Close",
    supportText:
      "Having any questions or query? <1/> Drop an email or call us.",
    yes: "Yes",
    nodetailsadded: "No Details Added",
    accept: "Accept",
    export: "Export",
    cancel: "Cancel",
    call: "Call",
    decline: "Decline",
    edit: "Edit",
    rejectAppointment: "Reject Appointment",
    acceptAppointment: "Accept Appointment",
    confirmAppointment: "Confirm Appointment",
    markAsCompleted: "Mark as Completed",
    recall: "Recall",
    reminders: "Reminders",
    activate: "Activate",
    deactivate: "Deactivate",
    continue: "Continue",
    back: "Back",
    fileNotSupported: "File not supported",
    submit: "Submit",
    save: "Save",
    ok: "Ok",
    delete: "Delete",
    YesDelete: "Yes, delete",
    confirmDelete: "Do you really want to delete?",
    send: "Send",
    clickHereToUploadPicture: "Click here to upload picture.",
    next: "Next",
    confirm: "Confirm",
    remove: "Remove",
    change: "Change",
    accountAdmin: "Account Admin",
    adminControls: "Admin Controls",
    previous: "Previous",
    staffMembers: "Staff Members",
    officeManagers: "Office Managers",
    noStaffMemberFound: "No staff member available for your selection",
    noContractFound: "No contracts available for your selection",
    noRecordFound: "No Record Found",
    currentSubscription: "Current Subscription",
    cad: "CAD",
    usd: "USD",
    vendorSubEnd: "The subscription cannot be terminated until {{field}}",
    paidOnline: "Paid Online",
    perMonth: "per month",
    perActivePermanentStaffMember: "Per Active Permanent Staff Member",
    featurecannotUnselected: "Default feature cannot be unselected.",
    featurecannotUnselectedProfessionalplan:
      "A linked feature cannot be unselected in a professional plan.",
    featurecannotUnselectedBasicPlan:
      "The feature cannot be unselected as it is selected under Basic Plan",
    featurecannotUnselectedAdvancedPlan:
      "Feature cannot be unselected as it is selected under Advanced Plan",
    perActiveTemporaryStaffMember: "Per Active Temporary Staff Member",
    perEachPlacement: "Placement Charges",
    subscription: "Subscription",
    add: "Add",
    update: "Update",
    isActive: "Is Active",
    isMandatory: "Is Mandatory",
    addNew: "Add New",
    name: "Name",
    active: "Active",
    inactive: "Inactive",
    fieldNotEmpty: "The field cannot be empty.",
    patientCta: "Click here If you are a Patient and looking for Doctors",
    patientLogin: "Log in as Patient",
    patientSignup: "Sign up as Patient",
    signUp: "Sign Up",
    signup1: "Sign up",
    myOffices: "My Offices",
    status: "Status",
    patientAppointments: "Patient Appointments",
    appointmentType: "Appointment Type",
    bookedFor: "Booked For",
    recallStatus: "Recall Status",
    recallType: "Recall Type",
    appointments: "Appointments",
    actions: "Actions",
    confirmation: "Confirmation",
    emailAddress: "Email Address",
    staffRoleDeleteConfirmationText:
      "Are you sure you want to delete the staff role?",
    title: "Title",
    dateAndTime: "Date and Time",
    noDoctorFound: "No Doctors Found!",
    role: "Role",
    doctors: "Doctors",
    viewAll: "View all",
    notAdded: "Not Added.",
    activeStaffs: "Active Staffs",
    noCodesAvailable: "No Promo Codes Available For Selection",
    approvedHours: "Approved Hours",
    requestAndApproval: "Requests & Approvals",
    requestAndInvitations: "Requests & Invitations",
    officeProduction: "Office Production MTD",
    staffCharges: "Staff Charges MTD",
    newPendingTimesheets: "New Pending Timesheets",
    pendingLeaves: "Pending Leaves",
    newApplicantsToday: "New Applicants Today",
    covidAlertsToday: "Covid Alerts Today",
    tasksUpdatedToday: "Tasks Updated Today",
    areYouSure: "Are you sure you want to",
    start: "Start",
    end: "End",
    location: "Location",
    writeReason: "Write reason",
    repeat: "Repeat",
    roles: "Roles",
    reject: "Reject",
    apply: "Apply",
    reset: "Reset",
    offices: "Offices",
    noOffices: "No Office",
    allEvents: "All Events",
    rejected: "Rejected",
    pending: "Pending",
    accepted: "Accepted",
    cancelled: "Cancelled",
    from: "From",
    to: "To",
    loadMore: "Load More",
    shipped: "Shipped",
    delivered: "Delivered",
    bookNow: "Book Now",
    timeOfAppointment: "Time of Appointment",
    phoneNumber: "Phone Number",
    unknown: "Unknown",
    appointmentRequestsList: "Appointment-Requests-List",
    view: "View",
    details: "Details",
    permanent: "Permanent",
    temporary: "Temporary",
    findInPage: "Find in Page",
    resultFound: "results found",
    Com: "Assign Customer Order Manager Role",
    appointmentConfirmed: "Appointment is Confirmed",
    newPatientsMtd: "New Patients MTD",
    newPatientsYtd: "New Patients YTD",
    productionChargesMtd: "Production MTD",
    productionChargesYtd: "Production YTD",
    staffHoursWorkedMtd: "Staff Hours Worked MTD",
    staffHoursWorkedYtd: "Staff Hours Worked YTD",
    assignedEmployees: "Assigned Employees",
    requestTojoin: "Request to Join",
    officeMangementCategory: "Office Management",
    staffManagementCategory: "Staff Management",
    pateintManagementCategory: "Patient Management",
    officeCategory: "Office",
    myRecordsCategory: "My Records",
    showEnterpriseEvents: "Show Company-Wide Events",
    networkResponseNotOk: "Network response was not ok",
    availableSlots: "Available Slots",
    availableSlot: "Available Slot",
    previousAvailableSlot: "Previous day's Available Slot",
    resumeAvailableSlot: "Resume to first available slot",
    nextAvailableSlot: "Next day's Available Slot",
    continueEvent: "Continue to create {{eventOrShift}}",
    noSymptoms: "No symptoms",
    rename: "Rename",
    covidTooltipText:
      "New Onset of Cough, Worsening Chronic Cough, Headache, Runny Nose, Shortness of Breath, Difficulty Swallowing, Sneezing (Not Allergy Related), Nasal Congestion, New Loss or Decrease in Sense of Taste or Smell, Chills, Sore Throat, Unexplained Fatigue or Malaise, Hoarse Voice, Difficulty Breathing, Nausea/Vomiting, Diarrhea, Abdominal Pain",
    noDataAvaliableForSelectoion: "No data available for your selection.",
    appointmentStatus: {
      Pending: "Pending",
      Accepted: "Accepted",
      Rejected: "Rejected",
      Cancelled: "Cancelled",
      Completed: "Completed",
      NoShow: "No Show",
      Confirmed: "Confirmed",
      Overdue: "Overdue",
      Upcoming: "Upcoming",
      Converted: "Converted",
    },
    UpdateGeofencing: "Update Geo fencing",
    fileDownloaded: "File Downloaded Successfully.",
    SeeMore: "See more",
    deactivatedOffice: "Deactivated Office",
    everyDay: "Every Day",
    everyWeek: "Every Week",
    every2Week: "Every 2 weeks",
    everyMonth: "Every Month",
    everyYear: "Every Year",
    custom: "Custom",
    "Event/Shift": "Event/Shift",
    eventStatus: "Event Status",
    drafted: "Drafted",
    published: "Published",
    navbar: {
      home: "Home",
      globalStaffList: "Global Staff List",
      solutions: "Solutions",
      editProfile: "Edit Profile",
      scheduler: "Scheduler",
      appointment: "Appointment",
      patientAppointments: "Patient Appointments",
      manageOffices: "Manage Offices",
      manageVendors: "Vendors",
      manageSubscription: "Manage Subscription",
      staffRoles: "Staff Roles",
      holidays: "Holidays",
      blogAndResources: "Blogs and Resources",
      events: "Events",
      changePassword: "Change My Password",
      chooseSubscription: "Choose Subscription",
      myProfile: "My Profile",
      companyDirectory: "Company Directory",
      accountSetting: "Account Settings",
      subscriptionPlans: "Subscription Plans",
      demoRequests: "Demo Requests",
      appVersions: "App Versions",
      manageTestimonials: "Testimonials",
      manageContent: "Content",
      manageAccountOwners: "Account Owners",
      managePersonnel: "Personnel Users",
      managePatients: "Patients Users",
      logout: "Logout",
      viewProfile: "View Profile",
      setLocation: "Set Location",
      noNotificationsRightNow: "No Notifications Right Now!",
      notificationsDesc: "You’re up-to-date!",
      overview: "Overview",
      products: "Products",
      features: "Apps & Features",
      pricing: "Pricing",
      fAQ: "FAQ",
      industry: "Industry",
      healthcare: "Healthcare",
      ourCustomers: "Our Customers",
      aboutUs: "About Us",
      supplier: "Supplier",
      healthcareEnterprise: "Healthcare Enterprise",
      enterprise: "Enterprise",
      blog: "Blog",
      newsRoom: "News Room",
      help: "Help",
      feedback: "Feedback & Suggestion",
      support: "Support & Helpdesk",
      taxManagement: "Tax Management",
      VendorDetails: "Vendor Details",
      manageSalesRep: "Manage Sales",
      manageCategories: "Categories",
      MyOffices: "My Offices",
      dashBoard: "DashBoard",
      viewMyProfile: "My Profile",
      addstaffRoles: "Staff Roles",
      addholidays: "Holidays",
      integrateOfficeWithPms: "Connect to a PMS/EMR",
      reviewsAndRatings: "Reviews and Ratings",
      appointmentRequests: "Appointment Requests",
      specialtiesOrServices: "Specialties/Services",
      manageCommissions: "Commissions",
      manageSalesRepresentatives: "Sales Representatives",
      manageTopUp: "Top-Up Promotions",
      familyMembers: "Family Members",
      vendorSubscriptionPlans: "Vendor Subscription Plans",
      accountPreferences: "Account Preferences",
      taskManagement: "Task Management",
      officePolicyManagement: "Office Policy",
      credentialsAndLicensing: "Credentials And Licensing",
      policyManagement: "Office Policy",
      doctorChat: "Doctor Chat",
      notifications: "Notifications",
      AISettings: "AI Settings",
      staffAttendance: "Staff Attendance",
    },
    mfaAuthenticate: {
      emiltTitle: "Multi-Factor Authentication",
      phoneTitle: "Enter Verification Code",
      emailSubTitle:
        "Enter the verification code sent to your email : {{email}}",
      phoneSubTitle:
        "Enter the verification code sent to your mobile : {{mobileNo}}",
      submit: "Submit",
      resend: "Resend",
      verifcationCode: "Verification Code in",
      attemptLeft: "attempts left",
      unableToAccessEmail: "Unable to access your email?",
      tryAlternateMethod: "Try alternate method",
      enterMobileNo: "Enter Mobile Number",
      mobileMsg:
        "We will send a verification code to your mobile number for authentication",
      enterOtp: "Enter Verification Code",
      enterNumber: "Enter your mobile no",
      sendCode: "Send Code",
      backToLogin: "Back to Login",
      back: "Back",
      otpLength: "Otp must be 6 digit",
      rememberMe: "Remember me for 90 days",
      sessionExpiredResend:
        "Verification session expired. Please resend the code.",
    },
    aiAssistant: {
      aiSettings: "AI Settings",
      search: "Search",
      document: "document",
      prompt: "prompt",
      showingAiManagement: "Showing Manage Documents for",
      aiAssistSubheading: "Miraxis AI Assist",
      managementInstruction: "Manage System Instructions",
      manageDocument: "Manage Documents",
      managePrompt: "Manage Prompts",
      documentName: "Document Name",
      description: "Description",
      modalHeading: "Upload Documents",
      fileSizeExceeded: "File size exceeds maximum limit",
      fileNotSupported: "File type not supported",
      fileIcon: "file-icon {{value}}",
      chatBotHeading: "Miraxis AI Assist",
      hello: "Hello!",
      needHelp: "Need help? Ask Miraxis AI Assist",
      onlineHelp: "Online Help Assistant",
      newChat: "New Chat",
      uploaded: "uploaded successfully!",
      modalTitle: "Choose a file or drag & drop it here",
      ModalSubTitle: "PDF, DOCX, TXT | Max. 512MB",
      extentions: ".pdf,.docx,.txt",
      browseFile: "Browse Files",
      fileType: "File Type",
      uploadedOn: "Uploaded On",
      updatedOn: "Updated On",
      noRecord: "No {{item}} available for your selection",
      uploadDocument: "Upload Document",
      searchDocument: "Search document",
      ongoing: "Ongoing",
      archive: "Archive",
      archived: "Archived",
      unarchive: "Unarchive",
      deleteMessage:
        "If you delete this document, the future responses will not include any information from this document. Are you sure you want to delete the document?",
      deleteModalTitle: "Delete Document",
      viewPrompt: "View Prompt",
      ratingReview: "Ratings and Reviews",
      chatHistory: "Chat History",
      noChats: "No chats available.",
      renameChat: "Rename Chat",
      deleteChat: "Delete Chat?",
      deleteConfirmation: "Are you sure you want to delete this Chat?",
      threadValidationMsg: "Thread name cannot be empty.",
      agreementText:
        "To give you the content requested, we may need to store and process your personal data. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please review our {{policyLink}}.",
      agreeBtn: "I Agree",
      aiChatAssistant: "AI Chat Assistant",
      aiAssist: "AI Assist",
      ratingRequired: "Rating is required",
      seen: "Seen",
      archiveTitle: "Archive Rating and Response",
      archiveContent:
        "Are you sure you want to archive this rating and response?",
      archiveSubContent:
        "Once archived, the review will be removed from the Ongoing list and moved to the Archived list.",
      archiveBtn: "Archive",
      unarchiveTitle: "Unarchive Rating and Response",
      unarchiveContent:
        "Are you sure you want to unarchive this rating and response?",
      unarchiveSubContent:
        "Once unarchived, the review will be removed from the Archived list and moved to the Ongoing list.",
      unarchiveBtn: "Unarchive",
      archiveChatTitle: "Archive Chat",
      archiveChatContent: "Are you sure you want to archive this chat?",
      archiveChatSubContent:
        "Once archived, the chat will be removed from the Ongoing list and moved to the Archived list.",
      unarchiveChatTitle: "Unarchive Chat",
      unarchiveChatContent: "Are you sure you want to unarchive this chat?",
      unarchiveChatSubContent:
        "Once unarchived, the chat will be removed from the Archived list and moved to the Ongoing list.",
      archiveReportTitle: "Archive Reported Response",
      archiveReportContent: "Are you sure you want to archive this response?",
      archiveReportSubContent:
        "Once archived, the response will be removed from the Ongoing list and moved to the Archived list.",
      unarchiveReportTitle: "Unarchive Reported Response",
      unarchiveReportContent:
        "Are you sure you want to unarchive this response?",
      unarchiveReportSubContent:
        "Once unarchived, the response will be removed from the Archived list and moved to the Ongoing list.",
      responseReport: "Reported Responses",
      version: "Version",
      expirationDate: "Expiration Date",
      forOffices: "For Offices",
      forRoles: "For Roles",
      filters: "Filters",
      manageAiDocuments: "Manage Documents",
      download: "Download",
      edit: "Edit",
      delete: "Delete",
      downloadedSuccessfully: "Document downloaded successfully",
      failedToDownloadDocument: "Failed to download document",
      documentPathNotAvailable: "Document path not available",
      failedToFetchDocument: "Failed to fetch document",
      fileDownloadedSuccessfully: "File downloaded successfully",
      exportCompleted: "Export completed",
      rating: "Rate Response",
      ratedResponse: " View Rated Response",
      export: "Export Response",
      report: "Report Response",
      reportedResponse: "View Reported Response",
      fileDownloadError: "File download failed",
      invalidFile: "Invalid file data or filename",
      SystemInstructionForm: {
        temperatureControl: "Temperature Control",
        systemInstruction: "System Instructions",
        historyNotes: "Super Admin History Notes",
        instructionEmptyErrorMsg: "System instructions cannot be empty.",
        temperatureEmptyErrorMsg: "Temperature cannot be empty.",
        validTemperatureValue: "Please enter value between 0.1 to 1.0",
      },
      manageDocuments: {
        fileTypeErrorMsg:
          "Invalid file format. Please upload a document in .pdf, .docx, .txt format.",
        maxFileSizeErrorMsg: "File size exceeds the maximum limit of 512 MB.",
        duplicateFileErrorMsg: "A file with this name already exists",
        attachments: "Attachments",
        selectRoles: "Select Roles",
      },
      managePrompts: {
        promptName: "Prompts Name",
        addNewPrompt: "Add New Prompt",
        deleteMessage:
          "Once deleted, the prompt cannot be retrieved. Are you sure you want to delete the prompt?",
        deleteModalTitle: "Delete Prompt",
      },
      manageAISettings: {
        manageAISettings: "Manage AI Settings",
        enableAISettings: "Enable AI Settings",
        apiKey: "API Keys",
        assignToken: "Assign Tokens",
        tokenUsed: "Tokens used: ",
      },
      addPrompt: {
        heading: "Add New Prompt",
        promptName: "Prompt Name",
        describePrompt: "Describe Prompt",
        characterLimit: "Character limit: 500",
        editPrmopt: "Edit Prompt",
      },
      onlineChat: {
        warningText:
          "You have used all your allocated tokens. No further responses can be generated.",
        recordingError: "Speech recognition error: ",
        startRecordingError: "Error starting recognition:",
        faliedRecordingError: "Failed to start speech recognition",
        recognitionNotWorking: "Speech recognition not available",
        startVoiveRecording: "Start voice recording",
        credsError:
          "Azure Speech credentials not found. Please check your environment variables.",
        speechError: "Azure Speech error: ",
        speechRecognitionNotInitialized: "Speech recognizer not initialized",
        showAiSetting: "Show Miraxis AI Assist",
        showAiSettingSubHeading:
          "Your intelligent assistant for scheduling, help, and operations",
        mediaAndDocument: "Media",
        camera: "Camera",
        capture: "Capture",
        takePhoto: "Take Photo",
        unableToAccessCamera:
          "Unable to access camera. Please check permissions.",
        removeFile: "Remove file",
        messageRequiredWithImages:
          "Please add a message to send with the images.",
        typeMessageToSend: "Type a message to send with your images...",
        pleaseTypeMessage: "Please type a message to send with your images",
      },
      ratingReviews: {
        username: "Username",
        accountOwner: "Account Owner",
        emailAddresss: "Email Address",
        threadName: "Thread Name",
        date: "Date",
        reviewStatus: "Review Status",
        actions: "Actions",
        ratingGiven: "Rating Given",
        ratingGivenByUser: "Rating Given by the User",
        addedComments: "Added Comments",
        email: "Email Address",
        accountOwneradmin: "Account Owner Name",
        officeName: "Office Name",
        date: "Date",
        queryAsked: "Query Asked by the User",
        responseReceived: "Response Received From AI Assistant ",
        additionalComment: "Additional Comment Added by the User (if Any)",
        addComment: "Add Comment",
        commentNotVisible: "This will not be visible to the user",
        ratingResponse: "Ratings & Responses",
        aiAssistSubheading: "Miraxis AI Assist",
        characterRemaining: "Characters Remaining: ",
        reason: "Reason",
      },
      feedbackModal: {
        title: "How would you rate this response?",
        rating: "Rating",
        comment: "Comment",
      },
      reportModal: {
        title: "Report Response",
        reportedResponse: "Reported Response",
        subContent:
          "Help us improve safety by flagging any inappropriate, offensive or inaccurate AI content.",
        reason: "Reason for report",
        comment: "Comment",
        addComment: "Add Comment",
        reportRequired: "Please select an option",
        commentRequired: "This field is required",
      },
      uploadModal: {
        version: "Version No.",
      },
    },
    taskManagement: {
      ongoingTasks: "Ongoing Tasks",
      archivedNotes: "Go to Archived Tasks",
      taskPerformance: "Task Performance",
      addNewTask: "Add New Task",
      priority: "Priority",
      filters: "Filters",
      offices: "Offices",
      roles: "Roles",
      staffMembers: "Staff Members",
      assigonr: "Assignors",
      apply: "Apply",
      reset: "Reset",
      close: "Close",
      taskOverdue: "This task is Overdue.",
      officeName: "Office Name",
      assignedTo: "Assigned To",
      assignedBy: "Assigned By",
      comments: "Comments",
      due: "Due:",
      edit: "Edit",
      archive: "Archive Task",
      cancel: "Cancel",
      delete: "Delete",
      completedonTime: "Completed On Time",
      from: "From",
      to: "To",
      taskDetails: "Task Details",
      startDate: "Start Date",
      description: "Description",
      notifyAssigneesabouttheTask: "Notify Assignees About The Task",
      notifyAssigneesabouttheUpdates: "Notify Me About The Updates",
      assignees: "Assignees",
      reasonOfRejection: "Reason of Rejection",
      reassignTask: "Reassign Task",
      taskDescrition: "Task Description",
      dueDate: "Due Date",
      assginStaffMemeber: "Assign Staff Members",
      attachFile: "Attach a File",
      deleteMsg:
        "Deleting the task would permanently delete it for you and for the assignees",
      deleteConfirmation: "Do you still want to delete?",
      enterTitle: "Enter Title",
      enterDescription: "Enter Description",
      accept: "Accept",
      reject: "Reject",
      start: "Start",
      assignedToYou: "Assigned To You",
      assignedByYou: "Assigned By You",
      taskNotFound: "No tasks available for your selection",
      selectOwnerMember: "Select Account Owner",
      member: "member",
      members: "members",
      noMember: "No Member",
      searchPlaceHolder: "Search by Task Title",
      add: "Add",
      allStaff: "All Staff",
      cancelTask: "Cancel Task?",
      cancelConfirmation:
        "If you cancel the task, the assignees can no longer work on the task. Do you still want to cancel?",
      yesCancel: "Cancel Task I Know",
      noCancel: "Do Not Cancel Task",
      onGoingTasks: "Go to Ongoing Tasks",
      archiveTask: "Archive Tasks",
      unarchive: "Unarchive Task",
      completedtime: "Completed time",
      update: "Update",
      markComplete: "Mark As Complete",
      completionTime: "Completion Time",
      editNewTask: "Edit Task",
      assigneNotFound: "No Staff Member Available For Your Selection",
      errorMsgOfRejection: "Please enter reason for rejection",
      commentNotFound: "No comment available",
      taskAssigned: "Task Assigned",
      totalTimeTaken: "Total Time Taken",
      completedOn: "Completed on Time",
      completedBefore: "Completed Before Time",
      notCompletedOntime: "Not Completed on Time",
      notCompletedAtAll: "Not Completed at All",
      tasksAssigned: "tasks assigned",
      commentError: "Please  add comment 1 to 256 words",
      showTaskfor: "Showing task for",
      office: "office",
      change: "Change",
      creationDate: "Creation Date",
      addComment: "Add Comment",
      dueDateGreaterThanStartDate:
        "Due date should be greater than or equal to the start date.",
    },
    officePolicyManagement: {
      ownerAdminHeadingForOfficePolicy: "Showing Office Policy for",
      policyRenewedSuccessfully: "Policy renewed successfully.",
      deletePolicyVersion: "Delete Policy Version?",
      deletePolicyVersionMessage:
        "This action will permanently remove the selected record from the list. Once deleted, it cannot be recovered. Are you sure you want to delete?",
      deletePolicyVersionBtn: "Delete",
      policyRenewedFailed: "Failed to renew policy",
      archive: "Archive",
      showCredentialsAndLicensing: "Show Credentials and Licensing for",
      staffTrackingUnarchive: "Unarchive",
      historyLogs: "History Logs",
      pleaseSelectAtLeastOneAssignee: "Please select at least one assignee.",
      archiveSuccess: "Policy archived successfully",
      unarchiveSuccess: "Policy unarchived successfully",
      archiveFailed: "Failed to archive policy",
      unarchiveFailed: "Failed to unarchive policy",
      policiesAndProcedures: "Policies & Procedures",
      officePolicies: "Office Policies",
      noAnalyticsData: "No analytics data available",
      officePoliciesNotFound: "No office policies available for your selection",
      ongoingPolicies: "Ongoing Office Policies",
      archivePolicies: "Go to Archived Office Policies",
      policyPerformance: "Office Policy Performance",
      filtersApplied: "Filters applied",
      addPolicy: "Add Policy",
      addPolicyFolder: "Add Policy Folder",
      addNewPolicy: "Add New Policy",
      completePolicy: "Complete Policy",
      noCategories: "No categories available for your selection.",
      policyAcknowledgeByStaff:
        "This policy has been acknowledged by the staff member",
      staffAcknowledgement: "Staff Acknowledgement",
      approvedBy: "Approved By",
      acknowledgedBy: "Acknowledged By",
      date: "Date",
      priority: "Priority",
      filters: "Filters",
      offices: "Offices",
      staffMembers: "Staff Members",
      assigonr: "Assignors",
      viewLogs: "View Logs",
      selectAtLeastOnePolicy: "Please select at least one policy",
      policiesAddedSuccessfully: "Policies added successfully",
      deletePolicyMessage:
        "This action will permanently remove this policy. Are you sure you want to delete?",
      failedToAddPolicies: "Failed to add policies",
      apply: "Apply",
      reset: "Reset",
      close: "Close",
      policyOverdue: "The policy is Overdue.",
      officeName: "Office Name",
      assignedTo: "Assigned To",
      assignedBy: "Assigned By",
      comments: "Comments",
      due: "Due:",
      edit: "Edit",
      exporting: "Exporting...",
      archivePolicy: "Archive Policy",
      unarchivePolicy: "Unarchive Policy",
      cancel: "Cancel",
      delete: "Delete",
      completedonTime: "Completed On Time",
      from: "From",
      to: "To",
      policyDetails: "Policy Details",
      startDate: "Start Date",
      description: "Description",
      notifyAssigneesaboutthePolicy: "Notify Assignees About The Office Policy",
      notifyAssigneesabouttheUpdates: "Notify Me About The Updates",
      assignees: "Assignees",
      reasonOfRejection: "Reason of Rejection",
      reassignPolicy: "Reassign Office Policy",
      policyDescrition: "Office Policy Description",
      dueDate: "Due Date",
      assginStaffMemeber: "Assign Staff Members",
      attachFile: "Attach a File",
      deleteMsg:
        "This action will permanently remove the selected record(s) from the list. Once deleted, it cannot be recovered. Are you sure you want to delete?",
      deleteConfirmation: "Do you still want to delete?",
      enterTitle: "Enter Title",
      enterDescription: "Enter Description",
      accept: "Accept",
      reject: "Reject",
      start: "Start",
      assignedToYou: "Assigned To You",
      assignedByYou: "Assigned By You",
      policyNotFound: "No office policies available for your selection",
      selectOwnerMember: "Select Account Owner",
      member: "member",
      members: "members",
      noMember: "No Member",
      searchPlaceHolder: "Search by Policy Title",
      searchByPolicyName: "Search by Policy Name",
      searchByName: "Search by Name",
      add: "Add",
      allStaff: "All Staff",
      cancelPolicy: "Cancel Policy?",
      cancelConfirmation:
        "If you cancel the policy, the assignees can no longer work on the policy. Do you still want to cancel?",
      yesCancel: "Cancel Policy",
      noCancel: "No, Don’t Cancel Policy",
      onGoingPolicies: "Go to Ongoing Office Policies",
      archivePolicies: "Archive Office Policies",
      unarchive: "Unarchive Office Policy",
      completedtime: "Completed time",
      update: "Update",
      markComplete: "Mark As Complete",
      completionTime: "Completion Time",
      editNewPolicy: "Edit Office Policy",
      assigneNotFound: "No Staff Member Available For Your Selection",
      errorMsgOfRejection: "Please enter reason for rejection",
      commentNotFound: "No comment available",
      policyAssigned: "Office Policy Assigned",
      totalTimeTaken: "Total Time Taken",
      completedOn: "Completed on Time",
      completedBefore: "Completed Before Time",
      notCompletedOntime: "Not Completed on Time",
      notCompletedAtAll: "Not Completed at All",
      policiesAssigned: "policies assigned",
      commentError: "Please  add commment 1 to 256 words",
      yourComment: "Your comment",
      showPolicyfor: "Showing office policy for",
      office: "office",
      change: "Change",
      creationDate: "Creation Date",
      attachment: "Attachment",
      downloadFile: "Download File",
      uploadFile: "Upload File(s)",
      noMemberSelected: "No Member Selected",
      selectAprrover: "Select Approver",
      complianceDashboard: "Compliance Dashboard",
      staffTracking: "Staff Tracking",
      currentPolicies: "Current Policies",
      archivedPolicies: "Archived Policies",
      complianceAnalytics: "Compliance Analytics",
      selectCategory: "Select Category",
      selectOffices: "Select Offices",
      category: "Category",
      addCategory: "Add Category",
      pleaseAddCategoryName: "Please add category name.",
      categoryNameMaxLength:
        "Category name cannot be more than 100 characters.",
      categoryNamePlaceholder: "E.g. Category 6",
      categoryAdded: "Category added successfully.",
      categoryUpdated: "Category updated successfully.",
      categoryDeleted: "Category deleted successfully.",
      addCategoryFailed: "Failed to add category.",
      editCategoryFailed: "Failed to update category.",
      deleteCategoryFailed: "Failed to delete category.",
      noDataAvailableForSelection: "No data available for selection.",
      noVersionsAvailableForSelection:
        "No versions available for your selection.",
      endDateMustBeAfterStart: "End date must be greater than start date.",
      policyWithSameNameAlreadyExists:
        "The policy with same name already exists.",
      titleRequired: "Title is required.",
      titleMaxLength: "Title should not be more than {{max}} characters.",
      noOfficeSelected: "No office selected",
      noCategorySelected: "No category selected",
      categoryRequired: "Category is required.",
      officeRequired: "Office is required.",
      more: "more",
      selected: "selected",
      selectAll: "Select All",
      search: "Search",
      allRoles: "All Roles",
      policyManagementHelpGuide:
        "The Policy Management module allows users to create policy folders and manage multiple versions within each folder before assigning them to staff members. From this screen, users can also multi-select policies and perform bulk actions such as archiving, deleting, or re-notifying.",
      thisPolicyAppliesTo: "This policy applies to: ",
      fileNotSupported: "File type not supported.",
      fileSizeValidation: "Each file must be 5 MB or less.",
      selectAtLeastOneAssignee: "Please select at least one staff member.",
      noOfficeAvailable: "No office available for your selection.",
      select: "Select",
      policyFolderCreated: "Policy folder created successfully.",
      policyFolderUpdated: "Policy folder updated successfully.",
      deletePolicy: "Delete Policy",
      viewDetails: "View Details",
      updatePolicy: "Update",
      failedToLoadPolicyFolder: "Failed to load policy folder",
      failedToLoadLatestPolicy: "Failed to load the latest policy.",
      categoryName: "Category Name",
      policyName: "Policy Name",
      lastUpdatedOn: "Last Updated On",
      actions: "Actions",
      status: "Status",
      exportSuccessful: "Export successful",
      exportFailed: "Export failed",
      quickPolicySetup: "Quick Policy Setup",
      renewAcknowledgement: "Renew Acknowledgement",
      policyLogs: "Policy Logs",
      export: "Export",
      exportSuccess: "Export started.",
      documentName: "Document Name",
      noHistoryLogsForSelection: "No history logs available for your selection",
      addNewPolicyDocument: "Add New Policy Document",
      editPolicy: "Edit Policy",
      editPolicyDocument: "Edit Policy Document",
      noArchivedPolicyAvailableForSelection:
        "No archived policy available for selection",
      noPolicyAvailableForSelection: "No policy available for selection",
      addAssignee: "Add Assignee",
      url: "URL",
      startDateSmallerThanDueDate:
        "Start date should be smaller than the due date.",
      dueDateGreaterThanStartDate:
        "Due date should be greater than the start date.",
      policyVersionAlreadyExists: "Policy version already exists",
      documentNameRequired: "Policy document name is required.",
      notesRequired: "Notes are required.",
      notesMaxLength: "Notes should not be more than 500 characters.",
      documentNameMaxLength:
        "Document name should not be more than 200 characters.",
      versionNumberMaxLength:
        "Version number should not be more than 10 characters.",
      urlInvalidFormat: "Please enter a valid URL format.",
      addUrl: "Add URL",
      noOfDays: "No. of days",
      noAttachments: "No attachments",
      policyDocumentName: "Policy Document Name",
      versionNumber: "Version Number",
      attachFiles: "Attach File(s)",
      addUrls: "Add URL(s)",
      saveAsDraft: "Save as Draft",
      assignStaffMembers: "Assign Staff Members",
      noMembers: "No members",
      allMembers: "All members",
      pleaseEnterInitials: "Please enter Initials",
      selectedMembers: "Selected members",
      notifyAssignees: "Notify Assignees",
      notifyManagement: "Notify Management",
      remindAfterPublish: "Remind After Publish",
      remindBeforeDueDate: "Remind Before Due Date",
      noHistoryLogs: "No history logs available",
      remindAssigneesAfterPublish:
        "Remind Assignees {{count}} day(s) after publishing if not completed",
      remindAssigneesBeforeDue:
        "Remind Assignees {{count}} day(s) before due date if not completed",
      createTaskForAssignees: "Create Task for Assignees",
      notifyAssigneesTooltip:
        "Select the checkbox to send notifications to the assignees when there are updates to the policy. If the checkbox is not selected, the assignees will not receive notifications for policy updates.",
      notifyManagementTooltip:
        "Select the checkbox to send notifications to the owner and admin when the policy status is updated by the assignees. You can choose to send the notification to all owners and admins or only to the selected ones.",
      remindAfterPublishTooltip:
        "Select this option to notify assignees if the policy is published but not accepted. The notification can be sent 1 to 5 days after the policy is shared and will only go to assignees who have not accepted it.",
      remindBeforeDueDateTooltip:
        "Select this option to notify assignees if the policy is not accepted before the due date. You can set the notification to be sent 1 to 5 days before the due date. Notifications will only be sent to assignees who have not accepted the policy.",
      createTaskForAssigneesTooltip:
        "Select the checkbox to create a task for assignees along with the policy. The task will appear in their task list and can be completed once the policy is acknowledged.",
      noOfDaysReminder: "No. of days",
      notes: "Notes",
      note: "Note",
      createdBy: "Created by",
      attachments: "Attachments",
      download: "Download",
      versionNo: "Version No.",
      uploadedBy: "Uploaded By",
      dateUploaded: "Date Uploaded",
      staffAssigned: "Staff Assigned",
      showAnalytics: "Show Analytics",
      staffMembersCount: "{{count}} Staff Members",
      renotify: "Re-notify",
      view: "View",
      reviewHistory: "Review History",
      justStarted: "Just Started",
      pendingNotAssigned: "Pending (Not Assigned Yet)",
      completed: "completed",
      staffMemberName: "Staff Member Name",
      policyVersion: "Policy Version",
      assignedOn: "Assigned On",
      officePolicyIdNotFound: "Office policy ID not found",
      renotifySent: "Re-notify sent.",
      failedToSendRenotify: "Failed to send re-notify.",
      issueDate: "Issue Date",
      credentialStatus: "Credential Status",
      noStaffTrackingAvailable:
        "No staff tracking available for your selection",
      pending: "Pending",
      accepted: "Accepted",
      started: "Started",
      mustAcknowledgePolicyToContinue:
        "You must acknowledge the policy to continue.",
      pleaseEnterName: "Please enter name",
      pleaseEnterFirstName: "Please enter first name",
      pleaseEnterLastName: "Please enter last name",
      inProgress: "In Progress",
      rejected: "Rejected",
      cancelled: "Cancelled",
      selectPolicy: "Select Policy",
      low: "Low",
      medium: "Medium",
      high: "High",
      all: "All",
      analyticsChart: "Analytics Chart",
      allCategories: "All Categories",
      allPolicies: "All Policies",
      noPoliciesFound: "No policies found",
      policy: "Policy",
      noPoliciesSelected: "no policies selected",
      noMembersSelected: "No members selected",
      pleaseSelectAtLeastOnePolicy: "Please select at least one policy",
      pleaseSelectAtLeastOneManagementMember:
        "Please select at least one management member",
      remindAfterPublishDaysShouldBeSelected:
        "Remind after publish days should be selected from list.",
      remindAfterPublishShouldBeSelected:
        "Remind after publish should be selected.",
      remindBeforeDueDateDaysShouldBeSelected:
        "Remind before due date days should be selected from list.",
      notifyAllManagementMember: "Notify All Management Member",
      policyDocumentUrls: "Policy Document URLs",
      policyNotifyManagementMembers: "Policy Notify Management Members",
      title: "Title",
    },
    staffAttendance: {
      staffAttendance: "Staff Attendance",
      showingStaffAttendanceFor: "Showing staff attendance for",
      exportTimesheetData: "Export Timesheet Data",
      currentDay: "Current Day",
      holiday: "Holiday",
      leave: "Leave",
      pendingForApproval: "Pending for Approval",
      approved: "Approved",
      rejected: "Rejected",
      paid: "Paid",
      mixed: "Mixed",
      lightBlue: "Light Blue",
      white: "White",
      goToCurrentDate: "Go to Current Date",
      previous: "Previous",
      next: "Next",
      selectAll: "Select All",
      approve: "Approve",
      reject: "Reject",
      markAsPaid: "Mark as Paid",
      approveTimesheet: "Approve Timesheet",
      youAreOnTheCurrentDate: "You are on the current date",
      markTimesheetAsPaid: "Mark Timesheet as Paid",
      onlyTimesheetsWithPendingStatusWillBeApproved:
        "Only timesheets with Pending status will be approved. Timesheets with any other status will remain unchanged. Are you sure you want to approve the timesheet?",
      onlyTimesheetsWithAcceptedStatusWillBeMarkedAsPaid:
        "Only timesheets with Accepted status will be marked as Paid. Timesheets with any other status will remain unchanged. Are you sure you want to mark the timesheet as Paid?",
      onlyTimesheetsWithPendingStatusWillBeRejected:
        "Only timesheets with Pending status will be rejected. Timesheets with any other status will remain unchanged. Are you sure you want to reject the timesheet?",
      areYouSureYouWantToRejectTheTimesheet:
        "Are you sure you want to reject the timesheet?",
      rejectTimesheet: "Reject Timesheet",
      noTimesheetDataAvailable: "No timesheet data available",
      areYouSureYouWantToApproveTheTimesheet:
        "Are you sure you want to approve the timesheet?",
      areYouSureYouWantToMarkTheTimesheetAsPaid:
        "Are you sure you want to mark the timesheet as paid?",
      dateRange: "Date Range",
      holidaysInThisPeriod: "Holidays in this period:",
      offices: "Offices",
      staffMembers: "Staff Members",
      staffRoles: "Staff Roles",
      timesheetStatus: "Timesheet Status",
      staffStatus: "Staff Status",
      selectAtLeastOneStaffMember: "Please select at least one staff member.",
    },
    notes: {
      note: "Notes",
      allOffices: "All Offices",
      onGoingNote: "Ongoing Notes",
      archivedNotes: "Go to Archived Notes",
      onGoingNotes: "Go to Ongoing Notes",
      addNewNote: "Add New Note",
      myNotes: "My Notes",
      transferredNotes: "Transferred Notes",
      delete: "Delete Note",
      transfer: "Transfer Note",
      archive: "Archive Note",
      archiveNote: "Archived Notes",
      unarchive: "Unarchive Note",
      changeReminder: "Change Reminder",
      officeName: "Office Name",
      assignedBy: "Assigned By",
      you: "You",
      transferredTo: "Transferred To",
      noReminderSet: "No Reminder Set",
      change: "Change",
      deleteNote: "Delete Note?",
      deleteNodeMessage:
        "Deleting the note would permanently remove it from your list.",
      deleteConfirmationMessage: "Do you still want to remove?",
      yesDelete: "Yes, Delete",
      cancel: "Cancel",
      filters: "Filters",
      offices: "Offices",
      staffMembers: "Staff Members",
      status: "Status",
      apply: "Apply",
      reset: "Reset",
      close: "Close",
      patientWardList: "Submit list of patient of Ward",
      description: " Description",
      fileAttached: "File Attached",
      download: "Download",
      reminder: "Reminder",
      wantToReceiveReminder: "Do you want to receive reminder?",
      date: "Date",
      time: "Time",
      noteDescription: "Note Description",
      selectOffice: " Select Office ",
      assignNoteTo: "Assign this Note to",
      mySelf: "Myself",
      toStaff: "To Staff",
      selectStaff: "Select Staff",
      selectedStaff: "Selected Staff",
      selectedOffice: "Selected office",
      noOfficeSelected: "No Office Selected",
      attachment: "Attachment",
      uploadFile: "Upload File",
      noAttachments: "No attachments",
      addNote: "Add Note",
      nextStep: "Next Step",
      previousStep: "Previous Step",
      assignStaffMember: "Assign Staff Member",
      selectStaffMember: "Select Staff Member",
      title: "Title",
      notesNotFound: "No notes available for your selection",
      noStaffMemberFound: "No staff member available for your selection",
      searchPlaceHolder: "Search By Note Title",
      allFilters: "All Offices",
      new: "new",
      seen: "seen",
      delivered: "delivered",
      resetFilter: "Reset Filters",
      reminderErrorMessage:
        "Reminder date and time should be greater than to current date and time",
      transferMessage:
        "If you transfer the note, it will be added to the list of selected staff. You can view this note in transferred by you list. Are you sure you want to transfer note to this staff?",
      doNotShowMessage: "Do not show this message again",
      confirm: "Confirm",
      ok: "Ok",
      newReminder: "New Reminder",
      noStaff: "No Staff Selected",
    },
    discussionNote: {
      selectNote: "Please select a note to view the details",
      discussionNote: "Discussion Notes",
      addNote: "Add Note",
      description: "Description",
      save: "Save",
      noteDetail: "Note Details",
      deleteNote: "Delete Note",
      deleteMessagse:
        "Deleting the note would permanently delete it for your list.",
      stillDelete: "Do you still want to delete?",
      edit: "Edit",
      delete: "Delete",
      noteAvailable: "No discussion notes available for your selection",
      noOfnotes: "{{assignedNoteCount}} Notes",
    },
    performanceReview: {
      whatNew: "What’s new in Performance Review?",
      dontShowMsg: "Don’t show this message again",
      previewForm: "Preview Form",
      addNewReview: "Add New Performance Review",
      initiatedByYou: "Initiated By You",
      initiatedByAdmin: "Initiated By Admin",
      performanceReview: "Performance Review",
      onGoingperformanceReview: "Ongoing Performance Review",
      archivedPerformaceReview: "Archieved Performace Review",
      selectStaff: "Select Staff",
      selected: "Selected",
      selectAll: "Select All",
      sendReview: "Send Review",
      cancelReview: "Cancel Performance Review",
      archive: "Archive Review",
      unarchive: "Unarchive Review",
      delete: "Delete",
      reviewSentBy: "Review Sent By",
      reviewSent: "Review Sent",
      searchByStaffName: "Search By Staff Name",
      goToArchive: "Go to Archived Reviews",
      ongoingReview: "Go to Ongoing Reviews",
      noStaffMemberFound: "No Staff Member Available For Your Selection",
      pending: "Pending",
      submitted: "Submitted",
      completed: "Completed",
      cancelled: "Cancelled",
      finalized: "Finalized",
      general: "General",
      probationPeriod: "Probation Period",
      monthlyReview: "Monthly Review",
      quarterlyReview: "Quarterly Review",
      yearlyReview: "Yearly Review",
      others: "Others",
      errorMsg: "Please Select Staff",
      noPerformanceReviewAvailable:
        "No performance review available for your selection",
      deleteModelTitle: "Delete Performance Review?",
      deletModelDes:
        "If you delete the performance review you will not be to review it later as it will be permanently deleted from the list. You can rather archive the review for future reference.",
      deleteModalMsg:
        "Are you sure you want to permanently delete it from the list?",
      yes: "Yes",
      cancel: "Cancel",
      submit: "Submit",
      apply: "Apply",
      reset: "Reset",
      close: "Close",
      cancelledOn: "Cancelled On",
      finalizedOn: "Finalized On",
      sumbmittedOn: "Submitted On",
      completedOn: "Completed On",
      finalize: "Finalize",
      finalizeFeedback: "Finalize Feedback",
      update: "Update",
      fillPerformanceReview: "Fill Performance Review",
      cancelTitle: "Cancel Performance Review?",
      viewPerformanceReview: "View Performance Review",
      viewFeedback: "View Feedback",
      cancelDes:
        "You have a few filled responses. Do you want to save them as Draft?",
      cancelPendingDes:
        "The assigned staff cannot fill the cancelled performance review. Are you sure you want to cancel?",
      saveAsDraft: "Save as Draft",
      exitWithoutSaving: "Exit Without Saving",
      confirmation: "Confirmation",
      confirmDes:
        "This action will send an empty Performance Review form to the staff to fill it in; when form is submitted back by the staff, you will be able to provide your feedback and finalize it.",
      confirmMessage:
        "Are you sure you want to send the performance review form now?",
      form: {
        employeeName: "Employee Name",
        position: "Position",
        dateOfEmployment: "Date Of Employment",
        beginningSalary: "Beginning Salary (in CAD)",
        presentSalary: "Present Salary (in CAD)",
        amountOfLastRaise: "Amount of Last Raise (in CAD)",
        lastRaiseDate: "Last Raise Date",
        proposedIncrease: "Proposed Increase",
        proposedIncreaseDate: "Proposed Increase Date",
      },
      expandAll: "Expand All",
      collapseAll: "Collapse All",
      comments: "Comments",
      staffReview: "Staff’s Review",
      employerFeedback: "Employer's Feedback",
      seeRating: "See Rating Criteria",
      ratingCriteria: "Rating Criteria",
      pleaseSelect: "Please select the ratings",
      noComments: "No Comments",
      giveFeedback: "Give Feedback",
      yourFeedback: "Your Feedback",
      amount: "Amount",
    },
    notices: {
      notice: "Notices",
      myPerformanceNotoces: "My Performance Notices",
      noticeDetails: "Notice Details",
      nameTitle: "Name & Job Title",
      sentBy: "Sent By",
      reasonOfCorrectivection: "Reason of Corrective Action",
      DescriptionProblem: "Description of Problems and Circumstances",
      companyExpectation: "Company Expectations",
      addNotice: "Add Notice",
      viewDetails: "View Details",
      receivedOn: "Received On",
      noNotice: "No notices available for your selection",
      selectStaff: "Select Staff",
      select: "Select",
      sendNotice: "Send Notice",
      cancel: "Cancel",
      apply: "Apply",
      noticeAlert: "Notice Alert",
      confirmationQuestion: "Are you sure you want to send the notice?",
      confirmationMsg: "The sent notice will be visible to the selected staff.",
      selectMemberError: "Please Select Member",
      selectDescriptionError:
        "Please Enter Description of Problem and Circumstances",
      compandeyExpectationError: "Please Enter Company Expectation",
      correctiveReasonError: "please select any reason",
      correctiveOtherReasonError: "please enter other reason",
      emptyMsg: "No staff member available for your selection",
      emptyMsgOffice: "No office available for your selection",
    },
    waitingList: {
      waitingList: "Waiting List",
      patientName: "Patient Name",
      appointmentDate: "Appointment Date",
      doctorName: "Doctor Name",
      requestedFor: "Requested For",
      status: "Status",
      action: "Action",
      doctors: "Doctors",
      pending: "Pending",
      cancelled: "Cancelled",
      converted: "Converted",
      notFound: "No request for appointments available for your selection",
      recallNotFound: "No recall reminder plan available for your selection",
      patientAndAppointmentDetail: "Patient and Appointment Request Details",
      patientEmailAddress: "Patient Email Address",
      doctor: "Doctor",
      clinicName: "Clinic Name",
      dateOfAppointment: "Date of Appointment Request",
      startDate: "Start Date",
      endDate: "End Date",
      startTime: "Start Time",
      endTime: "End Time",
      reason: "Reason",
      view: "View",
      createAppointment: "Create Appointment",
      cancelRequest: "Cancel Request",
      delete: "Delete",
      patientAppointmentDetails: "Patient Appointment Details",
      booked: "Booked",
      available: "Available",
      blocked: "Blocked",
      typeOfAppointment: "Type of Appointment",
      noTypeSelected: "No Type Of Appointment Selected",
      selectType: "Select Type",
      changeType: "Change Type",
      ReminderPlan: "Reminder Plan",
      noReminderSelect: "No Reminder Plan Selected",
      slectReminder: "Select Reminder Plan",
      changeReminderPlan: "Change Reminder Plan",
      notFoundType: "No Type For Appointments Found For Your Selection",
      selectedDateMsg1: "The selected day is an non-working day.",
      selectedDateMsg2: "Please select another day to manage the schedule.",
      allDoctor: "All Doctors",
      slotContinous:
        "The selected timeslots must be in continuation for selection.",
      slotMustBeAnHour: "You can select timeslot maximum of an hour.",
      slotBreak: "Removing this slot breaks the continuous selection.",
      name: "Name",
      email: "Email",
      contact: "Contact No",
    },
    employmentProof: {
      employmentProof: "Employment Proof",
      ongoing: "Ongoing",
      archived: "Archived",
      reason: "Reason",
      fillEmploymentProof: "Fill Employment Proof",
      archive: "Archive",
      unarchive: "Unarchive",
      delete: "Delete",
      requestEmploymentProof: "Request Employment Proof",
      form: {
        selectTemplate: "Which template do you want to use?",
        defaultTemplate: "Default Template",
        recentlySavedTemplate: "Recently Saved Template",
        salutation: "Salutation",
        subject: "Subject",
        heading: "Heading",
        date: "Date",
        name: "Name",
        position: "Position",
        dateHired: "Date Hired",
        typeOfEmployment: "Type Of Employment",
        rateOfPay: "Rate Of Pay",
        annualSalary: "Annual Salary",
        officePhoneNumber: "Office Phone Number",
        accountOWnerEmail: "Account Owner's Email Address",
        sincerely: "Sincerely",
        accountOwnerAdminName: "Account Owner/Account Admin Name",
        officeName: "Office Name",
        description: "Description",
        review: "Review",
        cancel: "Cancel",
        send: "Send",
        export: "Export",
        exportEmploymentProof: "Export Employment Proof",
      },
      dear: "Dear",
      backToEmploymentProofFoam: "Back To Employment Proof Form",
      noRecentSavedFoam: "No recently saved form",
      send: "Send",
      sendTitle: "Send Employment Proof",
      sendConfirmMsg: "Do you want to send this Employment proof?",
      request: "Request",
      requestHeading: "Request Employment Proof",
      notFound: "No employment proof available for your selection",
      saveTemplateTitle: "Save Template?",
      saveTemplateMsg: "Do you want to save this template for future use?",
      save: "Save",
      deleteTitle: "Delete Employment Proof?",
      deleteMsg: "Are you sure you want to delete this employment proof?",
    },
    subscriptionPlanTypes: {
      basic: "Basic",
      advanced: "Advanced",
      professional: "Professional",
      free: "Free",
      trial: "Trial",
      enterprise: "Enterprise",
    },

    help: {
      faqs: `FAQ's`,
      onlineHelp: "Online Help",
    },

    feedback: {
      title: "Feedback & Suggestion",
    },

    footer: {
      text: "MIRAXIS Technology Solutions Inc. All rights reserved.",
      copyrightReserved: "Copyright {{year}}. All rights reserved.",
    },

    form: {
      fields: {
        date: "Date",
        firstName: "First Name",
        lastName: "Last Name",
        firstNameRequired: "First Name*",
        lastNameRequired: "Last Name*",
        emailAddress: "Email Address",
        phoneNumber: "Phone Number",
        officeName: "Office Name",
        officeAddress: "Office Address",
        contactNumber: "Contact Number",
        country: "Country",
        currency: "Currency",
        provinceOrState: "Province/State",
        province: "Province",
        city: "City",
        postalCode: "Postal Code",
        selectGooglePredection: "Please select one option",
        staffType: "Staff Type",
        designation: "Designation",
        schedule: "Schedule",
        street: "Street",
        streetName: "Barton Street",
        roleName: "Role Name",
        holidayName: "Holiday Name",
        holidayDate: "Holiday Date",
        newPassword: "New Password",
        confirmPassword: "Confirm Password",
        confirmLocation: "Confirm Location",
        name: "Name",
        fullName: "Full Name",
        companyName: "Company Name",
        companyEmail: "Company Email",
        officeLogo: "Company Logo",
        companyPhonenumber: "Company Phone number",
        category: "Category",
        content: "Content",
        officeCharges: "Office Charges",
        SetUpFee: "Setup Fee",
        placementCharges: "Placement Charges",
        packageName: "Package Name",
        setUpfee: "Setup fee",
        address: "Address",
        leaves: "Leaves",
        versionNumber: "Version Number",
        appURL: "App URL",
        deviceType: "Device Type",
        appType: "App Type",
        appDescriptione: "App Description",
        yearsOfExperience: "Years of Experience",
        licenseId: "License ID",
        socialSecurityNumber: "Social Security Number",
        specialtiesAndServices: "Specialties / Services",
        linkHourlyRate: "Link Hourly Rate with Performance Review",
        selectPerformanceReview: "Select Performance Review",
        description: "Description",
        office: "Office",
        staff: "Staff",
        reason: "Reason",
        egJohn: "E.g. John",
        egSmith: "E.g. Smith",
        egEmail: "E.g. johnsmith@gmail.com",
        egPhone: "E.g. 1 (123) 456-7890",
        pageStep2: "Step 2 of 5",
        pageStep3: "Step 3 of 5",
        setUpFree: "Setup Fee",
        perEachPlacement: "Per Each Placement",
        permanentStaffCharges: "Permanent Staff Charges",
        temporaryStaffCharges: "Temporary Staff Charges",
        streetAddress: "Street Address",
        cad: "CAD",
        usd: "USD",
      },

      values: {
        permanent: "Permanent",
        temporary: "Temporary",
      },

      errors: {
        emptyField: "Please enter {{field}}.",
        emptySelection: "Please select {{field}}.",
        invalidValue: "Please enter a valid {{field}}.",
        invalidValue2: "Please enter a valid value.",
        endGreater: "End date must be greater than starting date.",
        promotionstartDate:
          "Expiry date should be greater than the Launch date",
        invalidURL: "Please enter a valid URL.",
        passwordConfirm: "Please confirm password.",
        passwordCriteria:
          "Password should be between 8 to 16 characters and contain at least 1 number, 1 small, 1 capital alphabet and 1 special character.",
        passwordMismatch: "Your password not match please enter again.",
        contentLength: "Please enter content 300 characters max.",
        officeAddressLimit: "Please enter address 150 characters max.",
        streetAddressLimit: "Please enter street 100 characters max.",
        fileSize: "File too Big, please select a file less than 5mb.",
        invalidFile: "Please select valid file.",
        numericValue: "Please enter numeric value only.",
        minLeaveCount: "Leaves should be 0 or greater days.",
        maxLeaveCount: "Leaves should be less than or equal to 366 days.",
        versionNumberFormat:
          "Version number must be a numeric value between 0 and 1000 with upto 3 decimal places.",
        invalidIP: "Please enter a valid IP Address",
        yearsOfExperienceFormat:
          "Years of Experience must be a numeric value less than 100 with upto 2 decimal places.",
        socialSecurityNumberMaxLength:
          "Social Security Number should not be more than 20 characters.",
        socialSecurityNumberInvalid:
          "Social Security Number should allow numeric and alphanumeric characters only.",
        acceptTerms:
          "Please indicate that you have read and agree to the Terms and Conditions",
        maxLimit: "Please enter less than {{limit}} characters",
        endDate: "End date cannot be less than the start date",
        pastDate: "Past date not allowed",
        imageUpload: "Image not uploaded",
        notEmpty: "Please, enter some text",
        atleastOneUser: "Please select atleast one user",
        minimumGap: "Start and End time should have gap of atleast {{time}}",
        endTimeShouldBeGreater:
          "End time should be greater than the start time",
        maximumTags: "Maximum of {{limit}} tags can be added",
        contentLengthFourHundred: "Please enter content 400 characters max.",
        reasonOfRejection: "Please add reason for rejection",
        pastTime: "Time cannot be in past",
        noDaySelected: "Please, select atleast one day.",
        fieldrequired: "The field is required",
        dueDate: "please enter due date",
      },

      ctas: {
        bookDemo: "Book a Demo",
      },

      placeholder1: "Enter {{field}}",
      placeholder2: "Your {{field}}",
      placeholderConfirmPassword: "Confirm Password",
    },

    homePage: {
      patient: "Patient",
      bannerText1: "Empowering Healthcare Professionals",
      bannerText2: "Practice Smarter",
      bannerText3:
        "A cloud-based platform to connect healthcare community, <1 /> integrate and automate their workflows",
      dentistText:
        "Make more time for your patients by automating your practice operation.",
      simplifyTitle: "Simplify",
      simplifyText: "the business of healthcare management.",
      increaseTitle: "Increase",
      increaseText: "productivity and efficiency of daily operations.",
      reduceTitle: "Reduce",
      reduceText: "costs and save time to focus more on what matters most.",
      reduceList1: "Accelerate growth of your practice",
      reduceList2: "Deliver superior patient care",
      reduceList3: "Achieve personal well-being",
      everythingYouNeedAllInOnePlace: "Everything you need, all in one place.",
      homeHexagonTitle: "Ready to transform the business of your practice?",
      homeHexagonDesc1:
        "Discover how Miraxis automates, simplifies, and expedites business workflows for ",
      homeHexagonDesc2: "and",
      dentists: "dentists",
      physicians: "physicians",
      pharmacists: "pharmacists",
      healthcarePersonnel: "healthcare personnel",
      suppliers: "suppliers",
      patients: "patients",
      physicianText:
        "Focus on treating your patients and spend less time on managing your staff.",
      pharmacistText:
        "Connect your multiple pharmacies and manage the staff operation using your mobile phone.",
      personnelText:
        "Connect with your work place using your mobile phone and manage your timesheets.",
      productAndServices: "Product & Services",
      platform: "Platform",
      platformText:
        "A Cloud-based Platform for Dentists, Physicians, <1 /> Pharmacists & Staff.",
      itAndBusinessServices: "IT & Business Services",
      itAndBusinessServicesText:
        "IT & Business Management Services for growing <1 /> Dental & Healthcare Practices.",
      practiceApplications: "Practice Applications",
      practiceApplicationsText:
        "Cloud-based Practice Operation Apps and Utilities.",
      comingSoon: "Coming soon",
      reachUs: "Reach Us",
      areYouLookingTo: "Are you looking to:",
      bannerList1: "Reduce costs and grow your practice?",
      bannerList2: "Focus more on improving patient care? and",
      bannerList3: "Focus more on improving patient care? and",
      dentistCaptionText: "Smile more by automating practice operations",
      physicianCaptionText:
        "Heal the pain points by automating practice operations",
      pharmacistCaptionText: "It’s a prescription to better connections",
      personnelCaptionText: "Join, find jobs, post jobs and more",
      patientsCaptionText:
        "Find a practitioner, schedule appointments, feel better",
      vendorCaptionText: "Fulfill orders and reduce confusion",
      aboutUsText1: "The Miraxis Platform",
      aboutUsText2:
        "and its innovative cloud-based applications empower healthcare professionals to connect, collaborate, and thrive by",
      aboutUsText3: "automating day-to-day workflows",
      aboutUsText4: "and",
      aboutUsText5: "creating a connected healthcare community.",
      aboutUsText6:
        "Whether you have one or multiple clinics, enjoy a wide array of fully-integrated solutions, all-in-one platform.",
      readyTitle: "See Miraxis products in action!",
      readyTitle2: "Not sure where to start?",
      readyDesc1: "Request a personalized demo",
      readyDesc2:
        "or contact us directly. We are excited to show you what we can do to help you unlock your practice productivity to its full potential.",
      ourProducts: "Our Products",
      readyPersonnalDesc1: "Schedule a demo",
      readyPersonnalDesc2:
        "We're excited to show you how we can simplify your work life.",
      readyPharmacyDesc2:
        "or contact us directly. We are excited to show you what we can do to help you unlock your pharmacy productivity to its full potential.",
      readySupplierDesc:
        "or contact us directly. We are excited to show you what we can do to help you win more sales and unlock your sales productivity to its full potential.",
      readyHealthcareDesc:
        "or contact us directly. We are excited to show you what we can do to help you unlock your practices' productivity to their full potential.",
      ourProductsTitle1:
        "For Dentists, Physicians, Pharmacists, Office Managers and More.",
      ourProductsTitle2: "Connecting Patients to Doctors and Dentists",
      ourProductsTitle3: "For Vendors & Healthcare Suppliers",
      ourProductsDesc1:
        "Apply Practice Optimization Solutions. Manage your practices and staff remotely. Connect them to patients, personnel, peers, and vendors with a full array of features that streamline collaboration and simplify your day-to-day operations.",
      ourProductsDesc2:
        "Help patients find the right doctor while allowing for two-way communication, appointment rescheduling, and access to important health records.",
      ourProductsDesc3:
        "Streamline and simplify order fulfillment across product catalogs, purchase orders, deliveries, tracking, and invoicing. Connect directly to your client's supply needs to keep sales orders flowing.",
    },
    blogsAndResources: {
      blogsAndResources: "Blogs and Resources",
      blog1: "9 Reasons Why Dentists Are Automating Their Practice",
      blog2: "Top 9 Ways for You and Your Staff to Avoid Burnout",
      blog3:
        "Top 9 Benefits of Streamlining and Automating Workflows in Your Dental Practice",
      blog4:
        "Communication With Your Team: How to Be Hands Off and Still Be Hands On",
      blog5:
        "3 Effective Ways Technology Can Help You Efficiently Manage Staff in Your Practice",
      blog6: "8 Ways Leading Dental Practices Enhance Their Staff Experience",
      blog7: "6 Ways to Recruit and Retain Practice Employees",
      ebookDownload: "13 Dental Practice Challenges and How to Overcome Them",
      guideDownload:
        "The Ultimate Guide to Creating Order From Chaos in Your Dental Practice",
      blog8: "Top 8 Benefits of an Integrated Practice Management Solution",
      blog9: "Top 10 Ways to Improve Your Practice’s Patient Retention Rates",
      blog10:
        "The Importance of Digital Transformation in the Dental Industry in 2024",
    },

    userPages: {
      bannerText1:
        "Spending Too Much Time on Managing your Staff, Not Your Practice?",
      bannerText2: "We Can Fix That.",
      bannerText3:
        "We can help you focus on your practice by simplifying your daily staff management.",
      bannerText4:
        "Keep Track of Your Working Hours and Find Your Next Job in One Place",
      bannerText5:
        "Connect with your work place using your mobile phone and manage your timesheets & availability.",
      cta: "Try Free for 30 days",
      cta1: "Signup for FREE",
      text1:
        "Make more time for your patients by automating your practice operation; start with managing your staff timesheet & availability and search for full/part time staff using Miraxis mobile and web applications.",
      text2:
        "Focus on treating your patients and spend less time on managing your staff. Managing your practice staff can be automated using Miraxis Staff Management. Connect your multiple offices using your mobile phone; and search for full/part time staff.",
      text3:
        "Connect with your work place using your mobile phone and manage your timesheets & availability; and find new jobs or temporary positions.",
      text4:
        "Create a Free Account Signup for a free account and start managing your timesheet and finding new jobs.",
      testimonialTitle: "Trusted by Fellow Doctors & Practitioners",
      aboutMiraxis: "About Miraxis",
      signupForStaff: "Signup for Staff",
      free: "FREE!",
      createAccount: "Create Account",
      createFreeAccount: "Create a FREE account",
      forDentist: "For Dentist",
      currentrlUsingProffessionalText:
        "You are currently using the ‘{{field}}’ subscription package.",
      featuresAddediInProfessionalPlan: "Features Included in {{field}} Plan",
      yourPracticeSimplified: "Your Practice. Simplified.",
      pharmacybannerList1:
        "Reduce costs and accelerate the growth of your pharmacy",
      dentistbannerList1:
        "Reduce costs and accelerate the growth of your practice",
      dentistbannerList2: "Connect, recruit and retain your personnel",
      dentistbannerList3: "Attract and engage new & existing patients",
      dentistbannerList4:
        "Achieve better work-life balance for you and your team",
      dentistbannerText: "Everything you need, all in one place.",
      featuresForDentists: "Features for Dentists",
      featuresForDentistsDesc:
        "Miraxis Practice gives you and your office management team a full suite of tools to save time, reduce costs, and alleviate stress.",
      dentistHexaDesc1: "Start a free trial",
      pharmacyHexaDesc2:
        "and discover how Miraxis can streamline business workflows for your pharmacy to save money, boost productivity, and achieve true work-life balance.",
      dentistHexaDesc2:
        "and discover how Miraxis can streamline business workflows for your practice to save money, boost productivity, and achieve true work-life balance.",
      productHexaDesc1:
        "Whether you’re a practice owner, healthcare professional, supplier, or patient, the Miraxis platform transforms the healthcare experience.",
      productHexaDesc2:
        "today or contact us directly and discover how Miraxis's products can help change the way you work and live.",
      testimonialPatientTitle: "Trusted by Fellow Patients",
      forPatients: "For Patients",
      forPhysician: "For Physician",
      forSupply: "For Supply",
      forPharmacists: "For Pharmacist",
      aHealthierApproachToYourCare: "A Healthier Approach To Your Care",
      miraxisPatientAllowsYouTo: "Miraxis Patient enables you to:",
      patientbannerList1: "Seamless search for the right doctor for your needs",
      patientbannerList2: "Schedule and communicate with office",
      patientbannerList3:
        "Know you’re getting the best care by reviewing profile and ratings",
      patientbannerList4: "Get instant access to your appointment records",
      itsAllFree: "It’s all free!",
      downloadYourFreeAppHere: "Download Your Free App",
      additionalFeatures: "Additional Features",
      puttingPatientsFirst: "Putting Patients First",
      miraxisPatientHelpsYouNavigateYourHealthcareJourneyWithEase:
        "Miraxis Patient helps you navigate your healthcare journey with ease.",
      getStartedForFree: "Get started for free",
      getStartedForFreeDesc:
        "Sign up for a free account now! Start searching for family doctors, dentists, and specialists and book appointments at your convenience.",
      createAFreeAccountDescPersonnel:
        "Sign up for a free account and start managing your timesheet, automating your invoices and finding new jobs",
      featuresForPhysicians: "Features for Physicians",
      featuresForPhysiciansDesc:
        "Miraxis Practice gives you and your office management team a full suite of tools to save time, reduce costs, and alleviate stress.",
      aboutUsTitle: "We empower healthcare professionals.",
      aboutUsSliderDesc1:
        "We are a healthcare technology company. We’ve walked in your shoes. We understand how hard it can be to manage practice operations effectively without sacrificing work/life balance or compromising the patient experience.",
      aboutUsSliderDesc2:
        "We’ve witnessed office managers and personnel stretched beyond capacity, grappling with disparate systems and applications that don’t address their challenges. We’ve seen practitioners paying more attention to paperwork than their patients, and patients frustrated with their healthcare experience.",
      aboutUsSliderDesc3:
        " We wanted to bring order to the chaos by simplifying the business of healthcare, helping healthcare professionals take control of their practice to scale and grow with ease.",
      ourMission: "Our Mission",
      ourMissionDesc:
        "We’re committed to helping healthcare professionals focus on what matters most: patient care, business growth, and personal wellness. Our platform streamlines and simplifies the business of healthcare management to create an integrated healthcare ecosystem that connects and empowers all stakeholders: doctors, dentists, pharmacists, suppliers, healthcare personnel, and patients.",
      connectingToSolutions: "Connecting to Solutions",
      howWeHelp: "How We Help",
      howWeHelpDesc1: "It’s the business of healthcare, connected at a click.",
      howWeHelpDesc2:
        "The Miraxis platform is an integrated, automated workflow solution that connects stakeholders in the healthcare ecosystem to the resources and tools they need, when they need it: Doctors to managing Staff, Staff to scheduling their availability or leaves, Office Managers to managing inventory, Job seekers to opportunities, Patients to appointment calendars, and more!",
      howWeHelpDesc3:
        "By simplifying and automating workflows, healthcare professionals can optimize patient care and boost productivity to grow their business, while reclaiming time for self-care and health-promoting activities outside of the practice.",
      howWeHelpDesc4: "Everyone wins.",
      theTeam: "The Team ",
      diverseAccomplishedPragmatic: "Diverse. Accomplished. Pragmatic.  ",
      aboutText1:
        "Our team at Miraxis takes to heart the idea that the business of healthcare can be dramatically improved and simplified for those who practice it. We designed the Miraxis platform to help ourselves practice smarter and want to help others who are struggling with disjointed business processes and disconnected healthcare management workflows.",
      aboutText2:
        "Whether we hail from the healthcare community, application development, finance, or programming, we’re all problem solvers at heart, working together to provide our customers with intuitive, cloud-based solutions that help them create order from chaos in their practice.",
      founder: "Founder",
      yourPharmacySimplified: "Your Pharmacy. Simplified.",
      readyToTransformTheBusinessOfYourPharmacy:
        "Ready to transform the business of your pharmacy?",
      featuresForPharmacists: "Features for Pharmacists",
      forPersonnel: "For Personnel",
      personnelBannerText1:
        "It’s Time For a Better Solution for Healthcare Personnel",
      personnelbannerList1:
        "Are you frustrated trying to manage time sheets, invoices, and payments?",
      personnelbannerList2:
        "Do you struggle to keep track of where you’re working and when?",
      personnelbannerList3: "Tired of searching for forms and HR documents? ",
      personnelbannerList4:
        "Where do you start searching new opportunities and compare job posts? ",
      personnelbannerBtn:
        "Sign up for FREE to discover how Miraxis can help you",
      featuresForHealthcarePersonnel: "Features For Healthcare Personnel",
      featuresForHealthcarePersonnelDesc:
        "Miraxis Practice gives you a full suite of tools—all in one place—to connect with your workplace using your mobile phone.",
      signupForPersonnelAccount: "Sign up for a Personnel account",
      readyToTakeControl: "Ready to take control?",
      readyToTakeControlDesc1:
        "Save time, reduce stress, and grow your career with Miraxis Practice. It’s free for Healthcare Personnel! ",
      readyToTakeControlDesc2: "Sign up for FREE",
      findDoctorsInYourArea: "Find doctors in your area",
      forVendors: "For Vendors",
      featuresForVendorTitle: "Features For Suppliers",
      featuresForVendorDesc:
        "Miraxis Supply streamlines and simplifies order fulfillment across product catalogs, purchase orders, deliveries, tracking, and invoicing.",
      vendorBannerText1: "Smarter Order Management to Maximize Profitability",
      vendorbannerList1:
        "Connect directly to your clients’ supply requirements to streamline fulfillment",
      vendorbannerList2:
        "Proactively manage your customers’ needs to drive consistent revenue",
      vendorbannerList3:
        "Gain instant visibility into your client’s supply issues to improve customer service",
      readyToTransformYourBusiness: "Ready to transform your business?",
      readyToTransformYourBusinessDesc1: "Start a free trial",
      readyToTransformVendorDesc1: "Contact us directly",
      readyToTransformVendorDesc2:
        "and discover how Miraxis can streamline your online sales process and boost your revenue.",
      forHealthcareEnterprise: "For Healthcare Enterprise",
      healthcareBannerHeading1: "How do you maximize",
      healthcareBannerHeading2: "profits as you scale and grow?",
      healthcareBannerHeading3: "Miraxis can help.",
      healthcareBannerDesc:
        "Miraxis automates and streamlines operational workflows for Healthcare Enterprises to increase efficiency, reduce costs, and improve the patient experience.",
      healthcareHexagonDesc1: "Contact us",
      healthcareHexagonDesc2:
        "directly to build a custom subscription plan for your company, and discover how Miraxis can streamline business workflows for your members to save money, boost productivity, and maximize profitability.",
      featuresForHealthcareEnterprises: "Features for Healthcare Enterprises",
      featuresForHealthcareEnterprisesDesc:
        "Miraxis Platform gives your management team a full suite of tools to save time, reduce costs, and alleviate stress in managing the operation of all practices.",
      everythingYouNeedAllInOnePlace: "Everything you need, all in one place.",
      everythingYouNeedAllInOnePlaceDesc1: "Miraxis Platform",
      everythingYouNeedAllInOnePlaceDesc2:
        "simplifies the business of healthcare management, helping Healthcare Enterprises scale and grow faster by consolidating the tools their members need to run their practice(s)—all in one place, from a single integrated platform.",
      everythingText1:
        "Miraxis Platform helps Healthcare Enterprises optimize administrative functions for their members, helping them simplify the business of healthcare management. Additionally, the centralized portal of the platform will bring instant visibility on the performance of all members, assisting Enterprise’s management team to be more proactive to the business / operational issues that may arise by members.",
      everythingText2:
        "Miraxis Platform enables Healthcare Enterprises to centralize non-clinical functions and systematically bring a beneficial organizational structure for many practice owners so that they can enhance their profits, increase their operational efficiencies, increase their quality of life (by freeing them from managing business issues, and empowering the practice owners to focus on their practice and create a better work-life balance).",
      productBannerTitle:
        "It’s the business of healthcare, connected at a click.",
      productPracticeText:
        "For Healthcare Providers, Practice Owners, Office Managers, Personnel, and More.",
      productPatientText:
        "Connecting Patients to Healthcare Providers for Superior Patient Engagement.",
      producSupplyText:
        "Saving Vendors & Healthcare Suppliers Time and Money with Automated Order and Delivery Management.",

      findNewPatientText:
        "Find new patients online and see their appointment requests",
      viewFeatureBtn: " View Features",
      getStartedBtn: "Get Started",
      successfulSignupText:
        "After successful signup and one month free trial, your account will be charged with one time setup fee and monthly office charges based on the number of offices you have created. The Temporary Staff Monthly Charges and Permanent Staff Monthly Charges will be added in the billing whenever you add/invite a new staff member and they actively use the app. The Placement Charges occur when the actual personnel search & hiring is done through Miraxis Platform's job board.",
      getStartedFreeTrial: "Start Free Trial",
      viewFeature: "View Features",

      productPracticeFeatures: [
        {
          title: "Collaborate and communicate easily",
          listText1: "Manage timesheets, vacation & payroll",
          listText2: "Assign and track tasks and share notes",
          listText3: "Schedule personnel shifts and availability",
        },
        {
          title: "Optimize office workforce",
          listText1: "Automate referral and hiring workflow",
          listText2: "Post jobs for open positions",
          listText3: "Manage staff availability across multiple practices",
        },
        {
          title: "Streamline HR processes",
          listText1: "Conduct performance reviews",
          listText2: "Onboard & offboard employees",
          listText3: "Automate online legal forms & contracts",
        },
        {
          title: "Deliver outstanding patient experience ",
          listText1:
            "Simplify booking, rescheduling and recalling patients’ appointments",
          listText2: "Send automatic reminders with customized messaging",
          listText3: "Easily access patient history for efficient service",
        },
        {
          title: "Ensure tight inventory control",
          listText1: "Track inventory in real-time",
          listText2: "Automate SKU ordering when low",
          listText3: "Easily manage billing and payments",
        },
        {
          title: "We go the extra mile",
          listText1:
            "Enjoy real-time support and virtual or in-person training",
          listText2: "Feel confident your data is secure and protected",
          listText3:
            "Integrate your account seamlessly with other Miraxis apps",
        },
      ],
      productPatientFeatures: [
        {
          title: "Doctor Search",
          listText1:
            "Find doctors in your area at your convenience, from your phone or computer",
          listText2:
            "Read doctors’ professional profiles and reviews before booking",
          listText3:
            "Book, reschedule appointments or register on the waitlist anywhere, anytime",
          listText4:
            "Receive appointment reminders via text, email, or the Miraxis Patient mobile app",
          listText5:
            "Complete detailed intake questionnaires online to help doctors better understand your needs",
        },
        {
          title: "Optimize patient experience",
          listText1:
            "Provide patients with real-time view of physician availability + waitlist option",
          listText2:
            "Enable patients to book appointments from any location or device",
          listText3: "Offer patients a view of current and past appointments",
        },
        {
          title: "Manage schedule with ease",
          listText1:
            "Simplify booking, rescheduling, and recalling patients’ appointments",
          listText2:
            "Automate patient reminders to avoid no-show gaps in schedule",
        },
        {
          title: "Improve patient care",
          listText1: "Easily access patient history for efficient service",
          listText2: "Communicate and collaboratse seamlessly with specialists",
          listText3:
            "Customize screening questionnaires so patients can provide detailed information prior to booking",
        },
        {
          title: "Grow your practice",
          listText1:
            "Register your professional profile & office specialty in Miraxis Platform to help new patients find you easily",
          listText2: "Leverage positive ratings from current patients",
        },
        {
          title: "Build great patient relationships",
          listText1:
            "Take advantage of intelligent, data-driven engagement tools",
          listText2:
            "Connect and communicate with patients in a meaningful way",
          listText3:
            "Use communication tools patients prefer (text, email, Miraxis patient mobile app)s",
        },
      ],
      productSupplyFeatures: [
        {
          title: "Increase efficiency and productivity",
          listText1: "Streamline and accelerate order fulfillment process",
          listText2:
            "Expedite customers’ search results with online product catalog",
          listText3: "Consolidate all order status in one integrated dashboard",
        },
        {
          title: "Maximize profitability",
          listText1:
            "Connect directly to your clients’ supply needs to keep sales orders flowing",
          listText2:
            "Improve sales forecasting by automating order fulfillment",
          listText3: "Reduce warehouse and/or fulfillment labor costs",
        },
        {
          title: "Deliver superior customer service",
          listText1: "Gain instant visibility into your client’s supply issues",
          listText2: "Proactively manage your customers’ needs",
          listText3:
            "Manage your clients’ issues using a support and helpdesk portal",
        },
      ],
      vendorFeatures: [
        {
          title: "Product Catalog",
          listText1:
            "Help customers search quickly and efficiently with comprehensive product details",
          listText2:
            "Easily customize and update product catalog with minimal effort and time",
          listText3:
            "Ensure accuracy and completeness of your product information with real-time listing updates",
        },
        {
          title: "Purchase Orders",
          listText1: "Complete phase-based order management",
          listText2: "Consolidate all order status in a single dashboard",
          listText3: "Seamlessly manage product promotions",
        },
        {
          title: "Delivery",
          listText1:
            "Ensure customers receive the right product in a timely manner with automated fulfillment workflow",
          listText2: "Track deliveries statuses",
          listText3:
            "Manage your clients’ issues using a support and helpdesk portal",
        },
        {
          title: "Invoices",
          listText1:
            "Generate Invoice Reports for comprehensive tracking and customer reference",
          listText2: "Create VIP customer profiles",
          listText3: "Seamlessly manage promotions and discount codes",
        },
        {
          title: "Sales Rep",
          listText1: "Manage your sales representatives’ tasks and activities",
          listText2:
            "Give your sales reps the tools they need, including access to product catalog and customer order history",
          listText3:
            "Provide mobile access to place orders online when visiting clients",
        },
        {
          title: "And More",
          listText1:
            "Enjoy real-time Miraxis support and virtual or in-person training",
          listText2: "Feel confident your data is secure and protected",
          listText3:
            "Integrate your account seamlessly with other Miraxis apps",
        },
      ],
      healthcareFeatures: [
        {
          title: "Members Management",
          listText1:
            "Easily create accounts for each practice and configure tools aligning with the practice’s day-to-day operations",
          listText2: "Add or remove personnel for each practice",
          listText3:
            "Define different roles for staff within the practice, e.g. admin, receptionist, clinical staff, and more",
          listText4:
            "Collaborate & communicate with your member staff in a centralized messaging system and task management app",
          listText5:
            "Gain instant visibility into portal and reports to detect issues or improvements",
        },
        {
          title: "Staff Management",
          listText1: "Manage timesheets, vacation & payroll",
          listText2: "Assign and track tasks and share notes",
          listText3: "Schedule personnel shifts and availability",
        },
        {
          title: "Jobs &  Personnel",
          listText1: "Automate referral and hiring workflow",
          listText2: "Post jobs for open positions (temp or full-time)",
          listText3: "Manage staff availability across multiple practices",
        },
        {
          title: "Virtual HR Manager",
          listText1: "Conduct performance reviews",
          listText2: "Onboard & offboard employees",
          listText3: "Automate online legal forms & contracts",
        },
        {
          title: "Online Patient Services",
          listText1:
            "Integrate with physicians’ Miraxis platform to simplify Rx dispensing",
          listText2: "Send automatic reminders with customized messaging",
          listText3:
            "Easily access patient history for quick, personalized service",
        },
        {
          title: "Inventory & Supply Management",
          listText1: "Track inventory in real-time",
          listText2: "Automate SKU ordering when low",
          listText3: "Easily manage billing and payments",
        },
        {
          title: "And More",
          listText1:
            "Enjoy real-time support and virtual or in-person training",
          listText2: "Feel confident your data is secure and protected",
          listText3:
            "Integrate your account seamlessly with other Miraxis apps",
        },
      ],
      dentistFeatures: [
        {
          title: "Staff Management",
          subTitle: "Collaborate and communicate easily",
          listText1: "Manage timesheets, vacation & payroll",
          listText2: "Assign and track tasks and share notes",
          listText3: "Schedule personnel shifts and availability",
        },
        {
          title: "Jobs & Personnel",
          subTitle: "Optimize office workforce",
          listText1: "Automate referral and hiring workflow",
          listText2: "Post jobs for open positions (temp or full-time)",
          listText3: "Manage staff availability across multiple practices",
        },
        {
          title: "Virtual HR Manager",
          subTitle: "Streamline HR processes",
          listText1: "Conduct performance reviews",
          listText2: "Onboard & offboards employees",
          listText3: "Automate online legal forms & contracts",
        },
        {
          title: "Online Patient Services",
          subTitle: "Deliver outstanding patient experience",
          listText1:
            "Simplify booking, rescheduling, and recalling patients’ appointments",
          listText2: "Send automatic reminders with customized messaging",
          listText3: "Easily access patient history for efficient service",
        },
        {
          title: "Inventory & Supply Management",
          subTitle: "Ensure tight inventory control",
          listText1: "Track inventory in real-time",
          listText2: "Automate SKU ordering when low",
          listText3: "Easily manage billing and payments",
        },
        {
          title: "And More",
          subTitle: "We go the extra mile",
          listText1:
            "Enjoy real-time support and virtual or in-person training",
          listText2: "Feel confident your data is secure and protected",
          listText3:
            "Integrate your account seamlessly with other Miraxis apps",
        },
      ],
      physicianFeatures: [
        {
          title: "Staff Management",
          subTitle: "Collaborate and communicate easily",
          listText1: "Manage timesheets, vacation & payroll",
          listText2: "Assign and track tasks and share notes",
          listText3: "Schedule personnel shifts and availability",
        },
        {
          title: "Jobs & Personnel",
          subTitle: "Optimize office workforce",
          listText1: "Automate referral and hiring workflow",
          listText2: "Post jobs for open positions (temp or full-time)",
          listText3: "Manage staff availability across multiple practices",
        },
        {
          title: "Virtual HR Manager",
          subTitle: "Streamline HR processes",
          listText1: "Conduct performance reviews",
          listText2: "Onboard & offboards employees",
          listText3: "Automate online legal forms & contracts",
        },
        {
          title: "Online Patient Services",
          subTitle: "Deliver outstanding patient experience",
          listText1:
            "Simplify booking, rescheduling, and recalling patients’ appointments",
          listText2: "Send automatic reminders with customized messaging",
          listText3: "Easily access patient history for efficient service",
        },
        {
          title: "Inventory & Supply Management",
          subTitle: "Ensure tight inventory control",
          listText1: "Track inventory in real-time",
          listText2: "Automate SKU ordering when low",
          listText3: "Easily manage billing and payments",
        },
        {
          title: "And More",
          subTitle: "We go the extra mile",
          listText1:
            "Enjoy real-time support and virtual or in-person training",
          listText2: "Feel confident your data is secure and protected",
          listText3:
            "Integrate your account seamlessly with other Miraxis apps",
        },
      ],
      pharmacistFeatures: [
        {
          title: "Staff Management",
          subTitle: "Collaborate and communicate easily",
          listText1: "Manage timesheets, vacation & payroll",
          listText2: "Assign and track tasks and share notes",
          listText3: "Schedule personnel shifts and availability",
        },
        {
          title: "Jobs & Personnel",
          subTitle: "Optimize office workforce",
          listText1: "Automate referral and hiring workflow",
          listText2: "Post jobs for open positions (temp or full-time)",
          listText3: "Manage staff availability across multiple pharmacies",
        },
        {
          title: "Virtual HR Manager",
          subTitle: "Streamline HR processes",
          listText1: "Conduct performance reviews",
          listText2: "Onboard & offboards employees",
          listText3: "Automate online legal forms & contracts",
        },
        {
          title: "Online Patient Services",
          subTitle: "Deliver outstanding patient experience",
          listText1:
            "Integrate with physicians’ Miraxis platform to simplify Rx dispensing",
          listText2: "Send automatic reminders with customized messaging",
          listText3:
            "Easily access patient history for quick, personalized service",
        },
        {
          title: "Inventory & Supply Management",
          subTitle: "Ensure tight inventory control",
          listText1: "Track inventory in real-time",
          listText2: "Automate SKU ordering when low",
          listText3: "Easily manage billing and payments",
        },
        {
          title: "And More",
          subTitle: "We go the extra mile",
          listText1:
            "Enjoy real-time support and virtual or in-person training",
          listText2: "Feel confident your data is secure and protected",
          listText3:
            "Integrate your account seamlessly with other Miraxis apps",
        },
      ],
      patientFeatures: [
        {
          title: "Doctor Search ",
          subTitle: "Quickly find a doctor for your unique needs",
          listText1:
            "Easily search for family doctors, dentists, and specialists online via Miraxis platform ",
          listText2:
            "Find doctors in your area at your convenience, from your phone or computer",
          listText3:
            "Read doctors’ professional profiles and reviews before booking",
        },
        {
          title: "Appointment  Booking",
          subTitle: "Schedule appointments with ease",
          listText1: "View real-time availability of doctors before booking",
          listText2:
            "Book or reschedule appointments anywhere, anytime, using smartphone, computer, or tablet",
          listText3:
            "Register on the waitlist of the doctor of your choice if their availability doesn’t match yours",
        },
        {
          title: "Personalized Communication ",
          subTitle: "Communicate efficiently and meaningfully with your doctor",
          listText1: `Receive appointment reminders via text, email, or the Miraxis Patient mobile app`,
          listText2:
            "Stay informed with in-app notifications and personal messages",
          listText3:
            "Complete detailed intake questionnaires online to help doctors better understand your needs",
        },
        {
          title: "Optimal  Care ",
          subTitle: "Know you’re getting the best care",
          listText1: "View a record of your current and past appointments",
          listText2:
            "Review ratings from current patients to feel confident in your choice of doctor",
          listText3:
            "Enjoy peace of mind knowing your personal data is secure and protected",
        },
      ],
      personnelFeatures: [
        {
          title: "Team & Workplace",
          subTitle: "Collaborate and communicate easily",
          listText1:
            "Connect to all offices you work at and update your availability",
          listText2:
            "Update assigned tasks and share important notes with your colleague and employer",
        },
        {
          title: "Work  Management",
          subTitle: "Reduce your stress",
          listText1:
            "See your schedule at all offices and keep track of your working hours",
          listText2: "Simplify managing your tasks and daily reminders",
          listText3: "Organize all work-related documents, forms and contracts",
        },
        {
          title: "Timesheet & Leave Management",
          subTitle: "Save time and optimize your work",
          listText1: "Connect with your workplace using mobile phone",
          listText2: "Submit & manage your timesheets & availability",
          listText3: "Request employee-related forms seamlessly",
        },
        {
          title: "Invoice & Payment",
          subTitle: "Temping made easy",
          listText1: "Automate invoice creation and manage them in one place",
          listText2: "Share your invoices with your employers",
          listText3: "Track payments and manage overdue invoices",
        },
        {
          title: "Job Search Tools",
          subTitle: "Find your next job",
          listText1:
            "Create your profile and post your resume for viewing by prospective employers",
          listText2: "Indicate your availability for job opportunities",
          listText3:
            "Set several intelligent search options for internal and external job opportunities",
        },
        {
          title: "And More",
          subTitle: "We go the extra mile",
          listText1:
            "Enjoy real-time support and virtual or in-person training",
          listText2: "Feel confident your data is secure and protected",
          listText3:
            "Integrate your account seamlessly with other Miraxis apps",
        },
      ],
      features: [
        {
          title: "Manage Staff Timesheet, Leave and Vacation",
          description:
            "Easy access to timesheet for entry and approval for both staff and manager from any smart phone",
        },
        {
          title: "Personnel <1 /> Finder",
          description:
            "Streamline Staff availability with integrated personnel finder and your hiring workflow, job application and temp placement",
        },
        {
          title: "Monitor Multiple Offices Staff Within One App",
          description:
            "Connect your multiple offices and manage the above features through your smart phone",
        },
        {
          title: "Manage Timesheet, Leave and Vacation",
          description:
            "Easy access to timesheet for entry and apply for leave or vacation from any smart phone",
        },
        {
          title: "Job Finder",
          description:
            "Streamline your availability with integrated job finder, job application and temp placement",
        },
        {
          title: "Connect With Multiple Offices Within One App",
          description:
            "Connect with your working places and manage these features through your smart phone",
        },
      ],

      plan: {
        perMonth: "mo",
        perActiveStaff: "per Active Staff User",
        perActiveTempStaff: "per Active Temp Staff User",
        perStaffPlacement: "per Staff Placement",
        cta1: "Start Free Trial",
        cta2: "Purchase Plan",
        cta3: "Contact us",
        title: "Plans That Fit your Needs",
        enterprise: "Enterprise",
        enterpriseText1: "Contact Sales <1 /> To Build a Custom Plan",
        enterpriseText2:
          "Ideal for large enterprises with <1 /> setups across countries, having a <3 /> large set of employees.",
        singlePharmacy: "Single Pharmacy",
        multiplePharmacy: "Multiple Pharmacy",
        perPharmacy: "per Pharmacy",
        free: "Free",
        findNewPatiientsOnline:
          "Find new patients online and see their appointment requests",
        getStarted: "Get Started",
        basic: "Basic",
        freeTrialIstMonth: "free trial 1st month",
        viewPricing: "View Pricing",
        manageStaffcost: "+ Manage Staff Cost, Track Hours and Time-offs",
        advanced: "Advanced",
        staffManagement:
          "+ Staff Management, Peer Review and Patient Engagement",
        professional: "Professional",
        inventoryOrder: "+ Inventory, Order and Vendor Management",
        officStaffManagement: "Office & Staff Management",
        doctorProfileListingOnlineSearch:
          "Doctor Profile Listing - Online Search",
        patientAppointmentsRequests: "Patient Appointments Requests",
        timesheet: "Timesheet - Reports & Dashboard",
        officeManagementStaffProfilesRoles:
          "Office Management - Staff Profiles & Roles",
        staffHoursReportsForPayroll: "Staff Hours Reports for Payroll",
        leavesTimeOffVacationTracker: "Leaves & Time-off & Vacation Tracker",
        onlineHelpSupport: "Online Help & Support",
        onlineTraining: "Online Training",
        virtualHr: "Virtual HR",
        jobOpeningsReferrals: "Job Openings & Referrals (Hiring Process)",
        personnelSearch: "Personnel Search (Internal/External)",
        staffDigitalFormsContracts: "Staff Digital Forms/Contracts etc.",
        performanceReviews: "Performance Reviews/Dashboard",
        employeeNotices: "Employee Notices (for Offboarding/Termination)",
        employeeDiscussionNotes: "Employee Discussion Notes",
        jobBoardIntegration: "Job Board Integration*",
        StaffManagementCollaboration: "Staff Management & Collaboration",
        staffSchedulerShiftsManagement: "Staff Scheduler & Shifts Management",
        taskManagementStatusReports: "Task Management & Status Reports",
        teamConversationCollaboration: "Team Conversation & Collaboration",
        notesReminders: "Notes & Reminders",
        doctorsCollaboration: "Doctors Collaboration",
        peerReview: "Peer Review (Patient Review & Referral)",
        patientEngagement: "Patient Engagement",
        patientAppointmentsRecalls: "Patient Appointments / Recalls etc.",
        patientConversation: "Patient Conversation (Telehealth)",
        dashboardReports: "Dashboard & Reports",
        practiceManagementIntegration: "Practice Management Integration*",
        supplyManagement: "Supply Management",
        orderManagementVendorManagement: "Order Management / Vendor Management",
        marketPlace: "Market place (Sell Yours or Buy Others')",
        inventoryManagement: "Inventory Management",
        supportTraining: "Support & Training",
        inPersonHelpSupportTraining: "In Person Help & Support & Training",
        pricingDetailsForBasicPlan: "Pricing Details for Basic Plan",
        pricingDetailsForAdvancedPlan: "Pricing Details for Advanced Plan",
        pricingDetailsForProfessionalPlan:
          "Pricing Details for Professional Plan",
        pricingDetailsForEnterPrisesPlan:
          "Pricing Details for EnterPrises Plan",

        oneTimeSetupFree: "One Time Setup Fee",
        singleOffice: "Single Office",
        multipleOffice: "Multiple Office",
        alertContentInLandingPage:
          "After successful signup and one month free trial, your account will be charged with one time setup fee and monthly office charges based on the number of offices you have created. The Temporary Staff Monthly Charges and Permanent Staff Monthly Charges will be added in the billing whenever you add/invite a new staff member and they actively use the app. The Placement Charges occur when the actual personnel search & hiring is done through Miraxis Platform's job board.",

        perMonths: "/mo",
        perOffice: "per office",
      },
    },
    getstarted: {
      getstarted: "Welcome to Miraxis!",
      getstartedDesc: "Choose from the options below to get started.",
      startFreeTrial: "Start free trial",
      bookDemo: "Book a Demo",
      contact: "Contact Us",
    },
    faq: {
      faq: "FAQ",
      faqSearch: "Hi, How Can We Help You?",
      faqDesc: "Choose a category to quickly find the help you need",
      yourAccountRegistration: "Your Account & Registration",
      productFeatures: "Product Features",
      downloadOurGuide: "Download Our Guide",
      downloadOurCheckList: "Download our checklist",
      name: "Name*",
      emailAddress: "Email Address*",
      needMoreInfo: "Need More Info",
      iAgreeToReceiveTheInformations:
        "I consent to receive the information by email. I understand I may opt out at anytime using the unsubscribe link provided in all communications.",
      productFeaturesFaq: [
        {
          ques: "Can I get a demo?",
          answer: "Yes. Please contact our sales team and book a demo here.",
          answerText1: "Request a demo",
        },
        {
          ques: "Is there any training?",
          answer:
            "Yes. When you log in to your account, you can access online help. The video and in-person training are available by request. You can also book a training session here.",
          answerText1: "Request a demo & training",
        },
        {
          ques: "Do you provide any support?",
          answer: "Yes. You can contact our support team here.",
          answerText1: "Contact Support",
        },
        {
          ques: "Am I able to access features using my mobile?",
          answer:
            "Depending on the user’s role and features, Miraxis platform and its applications are accessible both through your mobile phone and computer.",
        },
        {
          ques: "What are the main features of Miraxis products?",
          answer:
            "You can see the detailed list of Miraxis products’ features for various users:",
          answerText1:
            "Physicians, Dentists, Pharmacists, Personnel, Patients, Healthcare Enterprises, Suppliers.",
        },
      ],
      generalFaq: [
        {
          ques: "What is Miraxis Platform and what can I do here?",
          answer:
            "We understand how hard it can be to manage practice operations effectively without sacrificing work/life balance or compromising the patient experience. Miraxis Platform has been created to help healthcare professionals to overcome such challenges. (To read more about the challenges facing practice owners and the benefits of an integrated, collaborative healthcare ecosystem,",
          answerText1: "download our helpful guide.",
          answerText2:
            "Whether you’re a solo practitioner, multi-practice owner, healthcare personnel, office manager, pharmacist, an enterprise with several clinics, or a supplier, Miraxis has a wide array of fully-integrated solutions to enable you to connect, collaborate, and thrive by automating day-to-day workflows and creating a connected healthcare community.",
          answerText3:
            "View the detailed list of Miraxis products’ features for each provider:",
          answerText4: "Physicians",
          answerText5: "Dentists",
          answerText6: "Pharmacists",
          answerText7: "Personnel",
          answerText8: "Patients",
          answerText9: "Healthcare Enterprises",
          answerText10: "Suppliers",
        },
        {
          ques: "What does an Integrated Healthcare Management Solution mean?",
          answer:
            "Are you looking to adopt and implement a fully integrated healthcare management solution into your practice? We’ve got you covered with our comprehensive checklist on what you should be looking for when it comes to the solution you choose for your practice(s).",
          answerText1: "Download our checklist",
        },
        {
          ques: "Are Miraxis products in the Cloud?",
          answer:
            "Yes. Miraxis Platform and its innovative applications —Miraxis Practice, Miraxis Patient, and Miraxis Supply— are true cloud-based products. Our products do not need any installation, have no IT footprint and are accessible anytime anywhere using your mobile phone or your computer’s internet browser. It’s a cloud-based platform, so all your data is synced across teams and devices, while updates are instant and automatic.",
        },
        {
          ques: "How secure is our data? How about privacy?",
          answer:
            "Miraxis is committed to your privacy and the security of your data. Here are the measures we've taken to ensure that your data is never compromised: Secured access using HTTPS (SSL), password-protected accounts, daily backups, 99% uptime service, 24/7 monitoring, PCI-compliant payments, highly-secured architecture and infrastructure using Microsoft Azure. We are vigilant about keeping up-to-date with the latest security and privacy measures and systems to protect your data and personal information.",
        },
        {
          ques: "How much does it cost?",
          answer:
            "You can see the details of pricing for our products in this page:",
          answerText1: "Miraxis Pricing",
        },
        {
          ques: "Can I use my mobile phone to access my data?",
          answer:
            "Yes. Miraxis Platform and its applications are cloud-based applications, meaning they are accessible using both mobile phones or computers, anytime, anywhere.",
        },
        {
          ques: "How do you install Miraxis?",
          answer:
            "Miraxis Platform and its applications are cloud-based applications, meaning they do not need any installation or footprint on your office servers or computers. You just log in to the applications using either your mobile phone or the internet browser on your computer.",
        },
        {
          ques: "Can I get a demo?",
          answer: "Of course! Please use this link to request a demo.",
          answerText1: "Schedule a demo",
        },
        {
          ques: "What is listing your practice in search for patients. What does it mean? How does it work?",
          answer:
            "Miraxis Online Search helps practice owners and healthcare professionals to connect with new patients. In order to list your practice information or your profile information in the list of healthcare providers and to activate online booking for your practice and your associates, you will need to sign up to an account in Miraxis. Take me to",
          answerText1: "Sign Up",
          answerText2: "page, I still need",
          answerText3: "more information",
        },

        {
          ques: "How do I contact the site administrator?",
          answer: "Please use this link to contact the website admin.",
          answerText1: "Contact Admin",
        },
        {
          ques: "I have a technical issue with the application. Who do I contact?",
          answer: "Please use this information to contact Support. ",
          answerText1: "Contact Support",
        },
        {
          ques: "What are the terms and conditions for using this site?",
          answer: "The terms and conditions are located",
          answerText1: "here",
        },
        {
          ques: "What is the privacy policy for this site?",
          answer: "The privacy policy for this site is located",
          answerText1: "here",
        },
        {
          ques: "What if I can’t find my question here?",
          answer:
            "Feel free to contact Support directly. We’re here to answer your questions. ",
          answerText1: "Contact Support",
        },
      ],
      accountFaq: [
        {
          ques: "How do I sign up or register?",
          answer:
            "You can either use the “Sign Up” button on the top right of the webpage or check out the page related to your profession listed on the",
          answerText1: "main page",
        },
        {
          ques: "How can my staff sign up?",
          answer: "There are two ways for your staff to sign up:",
          answerText1:
            "If you are a practice owner, you can create a new account in Miraxis Practice, add one office, and then start inviting your staff from inside the app.",
          answerText2: "Create a new provider account.",
          answerText3:
            "Staff can register their own account in Miraxis Practice independently and start using the app; however, if they want to access your office, you should invite them first. Check out the online help inside the app for more information on how to invite staff. Healthcare Personnel can create a new account here.",
          answerText4: "Create a new personnel account",
        },
        {
          ques: "What do I need to register my account?",
          answer: "You only need an email address.",
        },
        {
          ques: "Will I have a trial subscription? For how long?",
          answer:
            "Yes. Providers and practice owners can use Miraxis products for free for one month. Healthcare personnel can create an account for free.",
        },
        {
          ques: "How do I reset my password?",
          answer:
            "When you log in to the app, click on “Forgot password” and follow the instructions to reset your password.",
        },
        {
          ques: "I forgot my username. How do I obtain it?",
          answer:
            "Miraxis usernames are created using email addresses. Please try logging in using your email address.",
        },
        {
          ques: "My trial subscription expired. What do I do now?",
          answer:
            "You can go back to your account and upgrade your subscription to access your account.",
        },
        {
          ques: "Can I register more than once?",
          answer: "You can register a new account with a new email address.",
        },
        {
          ques: "What are the rules for choosing my username and password?",
          answer:
            "The email used for registering your account is your username. There is no major rule involved, however, it should be a valid email address. The password must be 8 or more characters and contain at least one number, one small and one capital character.",
        },
        {
          ques: "How do I upgrade my account?",
          answer: "To upgrade your account, you can ",
          answerText1: "log in",
          answerText2:
            "to our account on the web, and select “Manage Subscription” from the Profile drop down menu at the top right. Under Manage Subscription, select the option to “Change Subscription”.",
        },
        {
          ques: "Why is my account deactivated?",
          answer:
            "Your account’s trial period has expired. You can upgrade your account by logging in to your account and upgrading your subscription. If you still have issues with your account, contact our support team here.",
          answerText1: "Contact Support",
        },
        {
          ques: "Can I ask my office manager to create an account for my office on my behalf?",
          answer:
            "Yes. Your office manager can use an email address to create an account on your behalf. Or you can create an account yourself as an owner and add your office manager as an admin to your account to manage your practice in the app. You can select different access rights for your staff; one of the options is Admin for your account. Check out the online help in the app to find more information on how to add an admin access to your office manager.",
        },
        {
          ques: "What if I cannot find my questions here?",
          answer:
            "If you have more questions or need help with your account, contact our support team here:",
          answerText1: "Contact Support",
        },
        {
          ques: "What if I have more than one office but would like to register only one office at this moment?",
          answer:
            "As a provider or practice owner, you can buy the single office subscription and later upgrade your account to the multiple offices subscription when more than one office is added.",
        },
        {
          ques: "What are the app download links?",
          answer1:
            "The Practice Android and iOS app can be downloaded from here:",
          answerText1: "Practice Android App",
          answerText1_1: "Practice iOS App",
          answer2:
            "The Patient Android and iOS app can be downloaded from here: ",
          answerText2: "Patient Android App ",
          answerText2_1: "Patient iOS App",
          answer3:
            "The Supply Android and iOS app can be downloaded from here: ",
          answerText3: "Supply Android App",
          answerText3_1: "Supply iOS App ",
        },
        {
          ques: "Can I also sign up from a mobile app?",
          answer:
            "Sign Up process can be done from the website only. You can click here to",
          answerText1: "Sign Up",
        },
        {
          ques: "How can I register as a patient?",
          answer: "You can click on the link here to Sign Up as a Patient:",
          answerText1: "Sign Up as Patient",
        },
        {
          ques: "Is there any cost involved if I want to register as a patient?",
          answer:
            "There is no cost involved if you want to Sign Up as a Patient.",
        },
        {
          ques: "How can I register as healthcare personnel?",
          answer: "You can click on the link here to Sign Up as a Personnel:",
          answerText1: "Sign Up as Personnel",
          answerText2:
            "To sign up as personnel, please make sure to select any of these options from the Roles dropdown in the Sign-Up form: Dental Practice Staff or Medical Practice Staff or Pharmacy Staff.",
        },
        {
          ques: "Is there any cost involved if I want to register as healthcare personnel?",
          answer:
            "There is no cost involved to register as a healthcare personnel.",
        },
        {
          ques: "How much does a subscription cost?",
          answer: "You can see pricing on this page: ",
          answerText1: "Miraxis Pricing",
        },
        {
          ques: "Can I downgrade or upgrade my current subscription plan?",
          answer: "To change the existing subscription plan, you can",
          answerText1: "log in",
          answerText2:
            "to our account on the web, and select “Manage Subscription” from the Profile drop down menu at the top right. Under Manage Subscription, select the option to “Change Subscription.",
        },
      ],
    },
    pricing: {
      pricing: "Plans That Fit Your Needs",
      healthcareProfessionals: "Healthcare Professionals",
      healthcareEnterprise: "Healthcare Enterprise",
      personnel: "Personnel",
      patients: "Patients",
      suppliers: "Suppliers",
      professionalgDesc:
        "Helping Healthcare Providers, Practice Owners (e.g. Physicians, Dentists), and Pharmacists reduce costs, boost productivity, grow their practice, and deliver better patient care.",

      plan: [
        {
          pricingDesc:
            "Ideal for Healthcare Enterprises with practices and setups in different locations, managing a large number of employees in multiple offices.",
          title: "Healthcare Enterprise",
          price: "Contact Sales",
          description: "To build a Custom Plan",
          purchase: "Contact Us",
        },
        {
          pricingDesc:
            "Helping Healthcare Personnel better manage their work and reduce stress using their mobile phones.",
          title: "For Personnel",
          price: "FREE!",
          description1: "Temping made easy",
          description2: "Find your next job",
          description3: "Collaborate and communicate easily",
          description4: "Reduce your stress and save time",
          purchase: "Sign Up",
        },
        {
          pricingDesc:
            "Helping Patients connect with Healthcare Providers for a superior patient experience.",
          title: "For Patients",
          price: "FREE!",
          description1: "Find a doctor for your unique needs",
          description2: "Schedule appointments with ease",
          description3: "Communicate efficiently with your doctor",
          purchase: "Sign Up",
        },
        {
          pricingDesc:
            "Helping Vendors and Healthcare Suppliers save time and money with automated order and delivery management.",
          title: "For Suppliers",
          price: "Contact Sales",
          description: "To build a Custom Plan",
          purchase: "Contact Us",
        },
      ],
    },
    featuresLanding: {
      featuresBannerHeading:
        "A full suite of tools to save time, reduce costs and alleviate stress.",
      featuresBannerDesc:
        "It’s the business of healthcare, connected at a click.",
      serviceCtaTitle: "Have a question about Miraxis products?",
      serviceCtaDesc1: "Get in touch",
      serviceCtaDesc2:
        "with our customer service and find out how we can tailor our services to fit your needs.",
      hexagonDesc1:
        "Whether you’re a practice owner, healthcare professional, supplier, or patient, the Miraxis platform transforms the healthcare experience.",
      hexagonDesc2:
        "today or contact us directly and discover how Miraxis's products can help change the way you work and live.",
      notesText:
        "*Note: This feature is coming in 2023. Contact our customer service to learn more about this information.",
      fixedMenuText: "Select the feature you would like to explore",
      services: [
        {
          rowHeading: "Staff Management",
          rowTagline: "Manage your people with efficiency and ease",
          rowDesc:
            "Tired of being bogged down with paperwork and tedious admin tasks? Managing your staff and your business shouldn’t be a struggle. Miraxis Practice can help.",
          ctaText:
            "Many practices use Miraxis Platform every day to eliminate inefficient processes and build a profitable business. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Simplify personnel management",
              text1:
                "Manage timesheets, vacation & streamline payroll with ease",
              text2:
                "Enable staff to clock in/clock out easily using mobile phone or dedicated office workstation",
              text3: "Schedule personnel shifts and availability",
              text4:
                "Let your staff book time off easily & quickly and share across your office calendar",
            },
            {
              title: "Streamline task management",
              text1:
                "Keep staff accountable and get things done by assigning and tracking tasks",
              text2:
                "Start with basic task assignment and grow to our advanced features connected to timesheets and status reports",
              text3:
                "Stop sticking notes papers on your monitors, start using Miraxis notes and its reminders",
            },
            {
              title: "Drive effective communication and collaboration",
              text1:
                "Use Miraxis Team Conversation to conduct live conversations with your team members in private or create group discussions",
              text2:
                "Share business news and announcements with your staff with ease",
              text3: "Manage communications with your peer in other practices",
            },
          ],
        },
        {
          rowHeading: "Jobs & Personnel",
          rowTagline: "Find & hire great talent and optimize office workforce",
          rowDesc:
            "Are you finding it difficult to find and hire high-quality personnel in a competitive marketplace? Miraxis Practice can help.",
          ctaText:
            "Finding and hiring the right candidates can be stressful, but using Miraxis Platform isn’t. With Miraxis Practice, you’re automatically integrated with this feature. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Simplify recruitment process",
              text1: "Automate referral and hiring workflow",
              text2:
                "Digitize the offer or employment contract management process",
              text3: "Automate onboarding for new hires",
            },
            {
              title: "Find the best candidates, faster",
              text1: "Post jobs for open positions (temp or full-time)",
              text2:
                "Streamline your hiring process for internal personnel pool or external available resources",
            },
            {
              title: "Optimize your workforce",
              text1: "Manage staff availability across multiple practices",
              text2:
                "Integrate with Miraxis Leave & Absence features to automate your temp hiring, internally or externally",
            },
          ],
        },
        {
          rowHeading: "Virtual HR Manager",
          rowTagline: "Simplify daily HR management",
          rowDesc:
            "How much of your day is spent managing HR paperwork and doing repetitive admin tasks? Stop wasting your valuable time.",
          ctaText:
            "Miraxis Practice transforms your HR tasks into a simple, manageable, and affordable workflow. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Eliminate paper-based processes",
              text1:
                "Leverage online workflow to conduct performance reviews and streamline salary changes",
              text2:
                "Keep track of employees’ records & notices within the app",
              text3: "Smoothly onboard & offboard employees online",
            },
            {
              title: "Manage schedules with less stress",
              text1: "Track absence & vacation requests",
              text2: "Plan and schedule shifts with ease",
              text3: "Know when personnel arrive, leave, or take breaks",
            },
            {
              title: "Find what you need, when you need it",
              text1:
                "Keep track of your HR files and documents in secure, cloud-based storage",
              text2: "Automate online legal forms & contracts",
              text3:
                "Quickly find employee data (e.g. prior pay increases, employee incidents)",
            },
          ],
        },
        {
          rowHeading: "Online Patient Services",
          rowTagline:
            "Deliver outstanding patient experience and keep your schedule full",
          rowDesc:
            "Miraxis Patient and Miraxis Practice work together seamlessly to attract and engage patients, deliver an outstanding patient experience, and grow your business.",
          ctaText:
            "Miraxis Patient gives you tools to create the best patient experience and keep your schedule full. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Streamline booking process",
              text1:
                "Simplify booking, rescheduling, and recalling patients’ appointments",
              text2: "Offer patients the option to register on wait list",
              text3:
                "Customize screening and intake questionnaires to obtain detailed patient information before booking",
            },
            {
              title: "Optimize patient experience",
              text1:
                "Help patients find you easily by registering your professional profile and office specialty in Miraxis platform",
              text2:
                "Build great patient relationships by using Miraxis intelligent tools:",
              textList1: "Automated messaging",
              textList2: "Marketing communications",
              textList3: "Reminders",
              textList4: "Email, SMS, Live Chat, Audio & Video",
              textList5: "Text messages",
              textList6: "In-app notifications",
              textList7: "Patient mobile app",
            },
            {
              title: "Deliver better patient care",
              text1: "Easily access patient history for efficient service",
              text2:
                "Communicate and collaborate quickly and seamlessly with specialists and other healthcare professionals",
            },
          ],
        },
        {
          rowHeading: "Personnel Scheduler",
          rowTagline: "Efficient Staff Scheduling for Every Practice",
          rowDesc:
            "Save hours scheduling staff and reduce your costs with Miraxis Personnel Scheduler.",
          ctaText:
            "Miraxis Scheduler provides your team with more control and flexibility and drastically reduces the amount of time your team spends on scheduling personnel. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Make your schedules work for you",
              text1:
                "Build your staff schedules and manage their availability and shifts easily",
              text2:
                "Make updates from anywhere, anytime using your mobile phone or laptop",
            },
            {
              title: "Be a time-tracking guru",
              text1:
                "Manage time tracking, leaves, office appointments and meetings in one consistent view",
              text2:
                "Assign the management of your office calendar to one or multiple assistants",
            },
            {
              title: "Collaborate with ease",
              text1:
                "Create work events and invite your team to participate with a few clicks",
              text2: "Manage multiple practices with one common personnel team",
              text3:
                "Create work shifts and allocate your team to avoid schedule conflicts",
            },
          ],
        },
        {
          rowHeading: "Leave – Time Off Tracking",
          rowTagline:
            "Improve visibility to your office Leaves and optimize your taskforce",
          rowDesc:
            "Take the burden off managers’ shoulders by empowering employees.",
          ctaText:
            "Miraxis Leave - Time Off feature provides your team with more control and flexibility and drastically reduces the amount of time your team spends on personnel’s vacation requests. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Customize the view",
              text1:
                "Set time-off categories (e.g. sick time, vacation, casual)",
              text2:
                "View the Leave Schedule at a glance, by week or month and in context with other events",
            },
            {
              title: "Simplify request workflow",
              text1: "Empower employees to request time off online",
              text2:
                "Gain total visibility and control over employee time-off requests",
              text3:
                "Check for time-off conflicts between workers before approving requests",
              text4:
                "Connect with employees directly through the platform to verify their time off, if desired",
            },
            {
              title: "Never be short-staffed",
              text1:
                "Check staff time-off calendar and initiate hiring in advance",
              text2: "Find replacement personnel via Miraxis platform",
              text3:
                "Find candidates for replacement either through internal existing personnel or by hiring an external applicant",
            },
          ],
        },
        {
          rowHeading: "Timesheet Management",
          rowTagline: "Take control and boost productivity",
          rowDesc:
            "Gain clarity, save time, and take control of your staff’s working hours.",
          ctaText:
            "Miraxis Timesheet Management gives you more control and flexibility and drastically reduces the amount of time you spend on managing personnel working hours. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Digitize your workflow",
              text1:
                "Improve productivity, save time and reduce cost by digitizing timesheet and task management in your practice",
              text2:
                "Set customized notifications to monitor working hours and break time",
            },
            {
              title: "Leverage reporting tools",
              text1: "Generate reports to streamline your payroll process",
              text2: "Customize filtering to view different pay periods",
              text3:
                "View staff cost in real-time to identify trends and improve staff utilization",
            },
            {
              title: "Take control",
              text1: "Control access to timesheet entry for your office",
              text2: "Customize the approval process",
              text3:
                "Provide staff flexibility for entering their hours based on your office preference, (i.e., using mobile phone or through a designated workstation for Clock-in/Clock-out)",
            },
          ],
        },
        {
          rowHeading: "Online Legal Forms and Contracts",
          rowTagline: "Manage Staff Forms Efficiently",
          rowDesc:
            "Save yourself from the burden of managing the staff forms through Miraxis Online Contracts and Forms.",
          ctaText:
            "Miraxis Online Form and Contract feature allows your team to send customized contracts to the staff member for easy approval and drastically reduces the amount of time spent on managing the personnel contract files offline. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Automate Contract Management",
              text1:
                "Save time by automating the process of sending employment contracts.",
              text2:
                "Digitally sign the contract forms and review the forms before sending it.",
              text3: "Download the contract forms for reference.",
            },
            {
              title: "Customize Contracts",
              text1: "Customize the content of the contracts easily.",
              text2:
                "Add or remove Terms and Conditions in the contracts as per the company policies.",
              text3:
                "Send the contracts to Personnel and Associates by customizing the terms in each separately.",
            },
            {
              title: "Simplify Staff Approvals",
              text1: "Simplify the staff approvals by digitally signing it.",
              text2: "Easily manage the contract approval status.",
              text3: "Download the accepted contracts for reference.",
            },
          ],
        },
        {
          rowHeading: "Peer Review and Patient Referral",
          rowTagline: "Collaborate with ease",
          rowDesc:
            "Streamline peer review and patient referral to deliver better patient care.",
          rowDesc1:
            "With Miraxis Practice, employees enter their own vacation and time-off requests into the platform. Managers simply approve or decline, saving time, effort, and admin headaches.",
          ctaText:
            "Miraxis Peer Review and Patient Referral feature help your team improve patient care and also refine your practice administration processes resulting in saving time and reducing cost in your business operation, and establishing a referral system for your practice. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Connect with peers",
              text1:
                "Communicate easily with your team or with other doctors in the community to discuss different cases, and receive feedback to increase the quality of care and improve treatment plans",
              text2:
                "Create groups with other health professionals to share opinions, identify strengths and areas of improvement to encourage growth and refinement",
            },
            {
              title: "Simplify patient referral",
              text1:
                "Easily refer a patient to another doctor via Miraxis platform",
              text2:
                "Reassign patient appointments to other doctors working in the office for peer review",
              text3: "Create groups with other doctors to share referrals",
            },
          ],
        },

        {
          rowHeading: "Telehealth",
          rowTagline: "Connect with patients",
          rowDesc:
            "Enable patients to access healthcare services remotely to improve availability and accessibility.",
          rowDesc1:
            "With Miraxis Practice, employees enter their own vacation and time-off requests into the platform. Managers simply approve or decline, saving time, effort, and admin headaches.",
          ctaText:
            "Miraxis Telehealth feature provides your team with remote access to the patients with mobility issues increasing your production as well as reducing the amount of time your team spends on patients booking administration. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Enhance patient experience",
              text1:
                "Improve access to care for patients with mobility issues, time or transportation constraints, or living in remote areas",
              text2:
                "Streamline online booking, pre-appointment screening questions and waiting list",
              text3:
                "Initiate phone or video calls with patients via Miraxis platform",
              text4:
                "Take advantage of Patient Live Chat to communicate with patients",
            },
            {
              title: "Optimize coordination of care",
              text1:
                "Share files, forms or documents with patients to keep them informed",
              text2:
                "Enable patients to send documents in support of their appointment",
              text3: "Manage history of audio and video calls with patients",
              text4: "Reopen closed chats to review case details",
            },
            {
              title: "Never be short-staffed",
              text1:
                "Check staff time-off calendar and initiate hiring in advance",
              text2: "Find replacement personnel via Miraxis platform",
            },
          ],
        },
        {
          rowHeading: "Business Dashboard",
          rowTagline: "Gain insight into practice operations",
          rowDesc:
            "Drill down into practice and patient care data to inform decision-making and drive growth.",
          rowDesc1:
            "With Miraxis Practice, employees enter their own vacation and time-off requests into the platform. Managers simply approve or decline, saving time, effort, and admin headaches.",
          ctaText:
            "Miraxis Platform includes numerous reports and dashboards that your team can use daily to have more control on business operation and administration. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Enable data-driven business decisions",
              text1:
                "View numerous operational dashboards and reports to monitor operations, optimize processes, and improve practice performance",
              text2:
                "Identify remaining items in inventory, expiring items, items that have reached the Minimum Reorder Quantity, and more via Inventory Dashboard",
              text3:
                "Leverage Order Management Dashboard for insight into orders placed by you and your Office Manager",
            },
            {
              title: "Optimize practice performance",
              text1:
                "Gain insight into staff hours by exporting timesheets of employees working in your office(s)",
              text2:
                "View pending timesheets, approved hours, pending leaves, and more to inform staffing decisions",
              text3:
                "Keep track of new patients and upcoming appointments using Patient and Appointment Dashboard",
            },
            {
              title: "Never be short-staffed",
              text1:
                "Check staff time-off calendar and initiate hiring in advance",
              text2: "Find replacement personnel via Miraxis platform",
            },
          ],
        },
        {
          rowHeading: "Inventory & Supply Management",
          rowTagline: "Ensure tight inventory control",
          rowDesc:
            "Does inventory management keep you up at night? Miraxis can help. Miraxis Inventory & Supply Management automates and streamlines purchasing & fulfillment processes between your practice and the vendors that supply your practice with products and services to save you time, money, and resources.",
          ctaText:
            "Miraxis Inventory & Supply Management feature provides your team with more control and flexibility and drastically reduces the amount of time your team spends on managing your inventory and supply expenses. Get access to the platform that is helping practices across Canada and the US thrive and grow.",
          slider: [
            {
              title: "Keep tabs on inventory",
              text1:
                "Trace inventory in real-time to prevent over-ordering, expired products, or running out of supplies",
              text2:
                "Consolidate and track supplier data in centralized database",
              text3: "Ensure accurate receipt of orders",
            },
            {
              title: "Save time and effort",
              text1: "Conduct automated stock audits",
              text2: "Automate SKU ordering to replenish stock when low",
              text3:
                "Centralize information about suppliers and their products in one place",
            },
            {
              title: "Simplify accounts management",
              text1: "Easily manage billing and payments",
              text2: "Send POs directly to suppliers",
              text3: "Link supplier invoices with POs to monitor expenses",
            },
          ],
        },
        {
          rowHeading: "Order and Delivery Management",
          rowTagline: "Take and Deliver Orders Efficiently",
          rowDesc:
            "Miraxis Supply product helps Vendors track and streamline their order and delivery management to drive sales revenue and ensure their customers always receive the products they need.",
          ctaText:
            "Miraxis Supply product provides your team with more control and flexibility to manage your clients' supply needs. Get access to the platform that is helping Suppliers across Canada and the US maximize their profitability.",
          slider: [
            {
              title: "Maximize profitability",
              text1:
                "Connect directly to your clients’ supply needs to ensure consistent revenue stream",
              text2:
                "Gain instant visibility into your clients’ supply issues to manage requirements proactively",
            },
            {
              title: "Streamline order management",
              text1: "Complete phase-based order management",
              text2: "Consolidate all order status in a single dashboard",
              text3:
                "Manage promotions and discount codes to ensure accurate pricing",
            },
            {
              title: "Deliver superior customer service",
              text1:
                "Easily customize your product catalog and update in real time",
              text2:
                "Provide comprehensive product details to help customers search more efficiently",
              text3:
                "Generate invoice reports for tracking and customer reference",
              text4:
                "Manage client issues effectively using Support and Helpdesk portal",
            },
          ],
        },
      ],
    },
    platformOverview: {
      bannerHeading1: "A Smart Platform",
      bannerHeading2: "to Propel Your Business",
      bannerHeading3: "to its Potential",
      bannerDesc:
        "Intelligent workflows, one integrated solution, data dashboards and smart connectivity to optimize your business  and help you reach your goals.",
      sliderText1: "Multiple Applications, One Integrated Solution",
      sliderText2: "Accessible Anywhere Anytime",
      sliderText3: "Intelligent Workflows and Connectivity",
    },
    featuresSlider: {
      sliderText1:
        "All in one place, integrated, accessible anywhere anytime, affordable and easy to navigate",
      sliderText2:
        "Real-time information gives you tighter control over your business operation, whether single/multiple practices or enterprise",
      sliderText3:
        "Fully customizable for managing your office(s) on your mobile phone or computer",
    },
    staff: {
      exportAllStaff: "Export All Staff",
      staffListOverview: "Staff List Overview",
      updateAcrossOffices: "Update Across Offices",
      bulkUpdateSelected: "Bulk Update Selected",
      bulkUpdateSelectedSingleOffice: "Bulk Update Selected (Single Office)",
      updateStaffForMultipleOfficesHelpDescription:
        "Use this screen to update a staff member’s information across multiple offices at once. This helps you keep their details consistent without editing each office separately.",
      bulkOfficeStaffHelpDescription:
        "Use this screen to update details for multiple staff members who all belong to the same office. This helps you quickly apply common changes without updating each staff member individually.",
      bulkGlobalStaffHelpDescription:
        "Use this screen to update information for multiple staff members at once across all their assigned offices. This helps you save time when several staff members need the same updates.",
      globalStaffHelpDescription:
        "The list shows all staff members in the organization. If a staff member works in multiple offices, they appear only once. Use the three dots  on a staff tile to manage their details. You can perform the following actions:",
      staffHelpDesc:
        "The list shows all staff members in the office. Use the three dots on a staff tile to manage their details.",
      exportVisibleStaffOnly: "Export Visible Staff Only",
      addUpdate: "Add/Update from CSV",
      downloadTemplate: "Download Template CSV",
      bulkUpdate: "Bulk Update Selected",
      renotify: "Re-notify",
      resendInvite: "Resend Invite",
      deactivate: "Deactivate",
      remove: "Remove",
      enterOfficeName: "Please select Office",
      enterDepartmentName: "Please add department name",
      errorExistingDepartment: "Assigned department cannot be deleted.",
      annualBonus: "Annual Bonus",
      signingBonus: "Signing Bonus ($)",
      compensation: "Compensation",
      salary: "Salary",
      switchOwner: "Switch Owner",
      switchAccountOwner: "Switch Account Owner",
      deletePolicy: "Delete Policy?",
      downloadAppText:
        "Download our mobile application to continue using Miraxis",
      noOfficeFound: "No Office Found.",
      addressNotAddedByTheAccountOwner:
        "Address not added by the Account Owner.",
      timesheet: "Timesheet",
      hour: "Hour",
      duration: "Duration",
      viewReview: "View Review",
      hour_plural: "Hours",
      addReason: "Add Reason",
      timesheetLeaves: "Timesheet & Leaves",
      timesheetNotApplicable: "Timesheet Not Applicable",
      timesheetNonWorkingDay:
        "You cannot fill timesheet for this day as this is a non-working day for you.",
      timesheetHoliday:
        "You cannot fill the timesheet for this day as it is a Holiday.",
      timesheetFutureDate:
        "You cannot fill timesheet for the future dates. Switch to mobile if you want to apply for a leave.",
      thisIsANonWorkingDayForYou: "This is a non working day for you.",
      startTime: "Start Time",
      finishTime: "Finish Time",
      endTime: "End Time",
      breakDuration: "Break Duration",
      submitTimesheet: "Submit Timesheet",
      editTimesheet: "Update Timesheet",
      saveTimesheet: "Save Timesheet",
      requestUpdate: "Request Update",
      timesheetDrafted: "Timesheet saved as draft successfully.",
      timesheetSubmitted: "Timesheet submitted successfully.",
      timesheetDraftUpdated: "Timesheet draft updated successfully.",
      timesheetUpdated: "Timesheet updated successfully.",
      timesheetTimeShouldBeGreaterThanBreakTime:
        "Break time should be less than total time.",
      timesheetStartTimeShouldBeLessThanFinishTime:
        "Finish time should be greater than the Start time.",
      seeReason: "See Reason",
      seeHistory: "See History",
      reasonForRejection: "Reason for Rejection",
      timesheetNotOnPremises:
        "You cannot submit a timesheet for this office remotely; the timesheet submission is allowed only when you are physically in the office.",
      timesheetOfficeDisabled:
        "You cannot fill the timesheet as the office is deactivated.",
      timesheetStaticIPDisabled:
        "You cannot add the timesheet of the office on web. Please switch to mobile for adding the timesheet.",
      advancedOptions: "Advanced Options",
      howDoYouWantToLogYourTimesheet: "How do you want to log your timesheet?",
      allDay: "All Day",
      hourly: "Hourly",
      typeOfWork: "Type of Work",
      typeOfTask: "Task",
      taskAssigned: "Select a task already assigned",
      taskAlreadyAssigned: "Task already assigned",
      selectWork: "Select Work",
      selectTask: "Select Task",
      addCustomWork: "Add Custom Work",
      addCustomTask: "Add Custom Task",
      medicienceSchedule: "Medicine Schedule",
      patientAppointment: "Patient Appointment",
      inventoryCheckup: "Inventory Checkup",
      addDescription: "Add Description",
      percentage: "%",
      cad: "CAD",
      description: "Description",
      addTask: "Add Task",
      timesheetType: "Timesheet Type",
      hourlyRate: "Hourly Rate",
      annualSalary: "Annual Salary",
      otherCompensation: "Other Compensation",
      commission: "Commission",
      commissionPercentageRadio: "Percentage (%)",
      commissionFixedAmountRadio: "Fixed Amount per case/patient/product($)",
      bonus: "Bonus",
      performanceBonusPercentage: "Performance Bonus (%)",
      PerformanceBonusCurrency: "Performance Bonus ($)",
      Bonus: "Bonus",
      linkedPerformanceReview: "Linked Performance Review",
      totalHours: "Total Hours",
      totalAmount: "Total Amount",
      totalInvoiceAmount: "Total Invoice Amount",
      shareInvoice: "Share Invoice",
      shareAllInvoices: "Share All Invoices",
      shareSelectedInvoices: "Share Selected Invoices",
      viewSummary: "View Summary",
      dateFrom: "From",
      dateTo: "To",
      totalHoursOfPayment: " Total Hours of Payment ",
      logged: "Logged",
      approved: "Approved",
      holiday: "Holiday",
      workingDays: "Working Days",
      leaves: "Leaves",
      reason: "Reason",
      reasonForRejectionLeave: "Reason for Rejecting Leave",
      overtime: "Overtime",
      total: "Total",
      clockIn: "Clock-In",
      clockOut: "Clock-Out",
      breakStart: "Break Start",
      breakEnd: "Break End",
      saveDraft: "Save as draft",
      saveDraftDesc: "Do you want to save this timesheet as draft?",
      select: "Select",
      selectAll: " Select All",
      Selected: "Selected",
      recall: "Recall",
      collection: "Collection",
      accountReceivable: "Account Receivable",
      patientRescheduling: "Patient Rescheduling",
      booking: "Booking",
      chairsideAssisting: "Chairside assisting",
      Sterilization: "Sterilization",
      inventoryManagement: "Inventory Management",
      patientChartReviewUpdate: "Patient Chart Review / Update",
      organizingOffice: "Organizing Office",
      managingCharts: "Managing Charts",
      hourlyRateHistory: "Hourly Rate History",
      noReviews: "No Reviews",
      notimeEntered: "No time sheet entered for this month",
      deleteTask: "Delete Task",
      deleteTaskDesc: "Are you sure you want to delete the task?",
      reason: "Reason",
      reasonModalTitle: "Give reason to update timesheet",
      sendRequestToEdit: "Send request to edit",
      reasonError: "Please enter reason to update",
      timesheetRequestSent: "Timesheet update request sent successfully.",
      eventAdded: "{{eventOrShift}} added successfully!",
      showingSchedule: "Showing Schedules for",
      selectAccountOwner: "Select Account Owner",
      eventUpdated: "Event Successfully Updated.",
      timeExpired:
        "Time period for accepting or rejecting this request has been expired.",
      timeExpiredToJoin: "Time period for joining event has been expired.",
      acceptEventRequest: "Accept Event Request",
      overRightAcceptEventRequest:
        "The selected date and time is already blocked in your calendar. Are you sure you still want to accept the event?",
      confirmAcceptEventRequest:
        "Accepting the event would mean that you will be part of the invited event and the date and time of the event will show as blocked in your calendar. Are you sure you want to accept the event?",
      downloadTheApplication: "Download the Application",
      downloadTheApplicationDesc: "To access more feature, download the app.",
      currentDay: "Current day",
      selectedDateLegend: "Selected date",
      nonWorkingDay: "Non-working Day",
      pastDatesAndTimesheetPending: "Past Dates and Timesheet Pending",
      pastDatesAndTimesheetAdded: "Past Dates and Timesheet Added",
      myTimesheetsLeaves: "My Timesheets & Leaves",
      myPerformanceReview: "My Performance Review",
      addEditTimesheet: "Add/Edit Timesheet",
      addNote: "Add Note",
      note: "Note",
      noReasonAdded: "No reason added",
      reasonToUpdateTimesheetHeading: "Reason to update timesheet",
      reasonToUpdateTimesheetSubHeading: "Provide a reason to update timesheet",
      reasonToUpdateTimesheetFirstButton: "Send Request to Edit",
      reasonToUpdateTimesheetSecondButton: "Cancel",
      staffEditInfo: "Your timesheet has been added by {{admin}}",
      adminEditInfo:
        "{{admin}} is adding a timesheet for {{staff}} and it will automatically get approved.",
      editTimesheetByAdmin:
        "Your are updating the timesheet filled by {{staff}}. This information can be viewed by the employee.",
      updateStaffTimesheetInfoWarning:
        "You cannot submit a timesheet for this date because the office requires an approved event/shift. Click 'Request Update' below to ask your manager to approve a shift/event or allow you to log hours for this date.",
    },
    staffLeaves: {
      from: "From",
      to: "To",
      duration: "Duration",
      leaveType: "Leave Type",
      backupStaffMember: "Backup Staff Member",
      reasonForLeave: "Reason for Leave",
      approve: "Approve",
      leaves: "Leaves",
      reason: "Reason",
      status: "Status",
      alertMessage:
        "For applying the leave longer than {{days}} days the leave request should be submitted {{month}} Month prior.",
      applyLeave: "Apply Leave",
      editLeave: "Edit Leave",
      noOfWorkingDaysForLeave: "No. of Working Days for Leave",
      vacation: "Vacation",
      casual: "Casual",
      medical: "Medical",
      total: "Total",
      remaining: "Remaining",
      taken: "Taken",
      addBackupStaff: "Add Backup Staff",
      internalTempList: "Internal Temp List",
      addBackupStaffManually: "Add backup Staff Manually",
      selectStaff: "Select Staff",
      addBackupStaffManuallyHeading: "Add Backup Staff Manually",
      name: "Name",
      contactNo: "Contact Number",
      selectTemporaryStaff: "Select Temporary Staff",
      reasonForRejection: "Reason for Rejection",
      noStaffAdded: "No staff available for your selection",
      noLeavesAvailable: "No leaves available for your selection",
      approveLeave: "Approve Leave",
      approveLeaveContent: "Are you sure you want to approve the leave?",
      selectBackupText:
        "Select backup staff from Internal list or you can add a staff member manually.",
      duarationValidationMsg: "You cannot apply leave for non-working days",
      reasonMsg: "Please enter reason of leave of atmost 500 characters",
      approveLeaveWithoutAdding:
        "You are approving the leave without adding the backup staff member.",
      backUpMemberAddMsg: "Please select backup staff",
      change: "Change",
      approveCancellation: "Approve Cancellation",
      rejectCancellation: "Reject Cancellation",
      leaveCancellationRequest: "Leave cancellation request is rejected",
      leaveConflictIndicator:
        "This staff member has scheduling conflicts involving one or more assigned events or shifts",
      yourLeaveCancellationRequest:
        "Your leave cancellation request is rejected",
      clickForReason: "Click here for reason",
      clicktoSeeFullSchedule: "Click here to see full schedule",
      viewSchedule: "View Schedule",
      leaveCancellation: "Leave Cancellation",
      leaveConflictTitle: "Leave Conflicts",
      leaveConflictBodyone:
        "The selected leave dates overlap with one or more existing events or scheduled shifts. Approving this leave may result in conflicts or disruptions in the schedule.",
      leaveConflictBodytwo:
        "Do you still want to proceed with approving the leave?",
      archiveModalmessage:
        "Are you sure you want to archive the leave? Once archived, the leave will be removed from the list and can be accessed by applying the archive filter.",
      unArchiveModalmessage:
        "Are you sure you want to unarchive the leave? Once unarchived, the leave will be added in the main list of leaves.",
      approveCancellationModalMessage:
        "Are you sure you want to approve the cancellation of this leave request? Once approved, the leave will be marked as canceled and the employee’s leave balance will be updated accordingly.",
      withDrawLeaveModal:
        "Are you sure you want to withdraw your leave request? This action cannot be undone and your leave will be cancelled.",
      cancelLeaveModal:
        "Are you sure you want to cancel your leave? A cancellation request will be sent to the owner for review.",
    },
    modalForComment: {
      cancellationpending: "Reason For Cancellation Pending",
      Archived: "Reason For Archive",
      isConflictingLeave: "Reason for Accepting Leave",
      cancellationReject: "Reason for Rejecting Cancellation",
      cancellationAccept: "Reason for Approving Cancellation",
      backupUserId: "Reason for Accepting Leave",
      reject: "Reason for Rejecting Leave",
      rejected: "Reason for Rejecting Leave",
      accept: "Reason for Accepting Leave",
      approved: "Reason for Accepting Leave",
      cancel: "Reason for Cancelling Leave",
      archive: "Reason For Archive",
      archived: "Reason For Archived",
      unarchive: "Reason For Unarchive",
      withdrawn: "Reason for Withdrawing Leave",
    },
    staffTimesheet: {
      emptyMsg: "No requests and approvals available for your selection",
      name: "Name",
      staffNoRecordFound: "No staff member available for your selection",
      emptMsg: "No timesheets available for your selection",
      logged: "Logged",
      approved: "Approved",
      Pending: "Pending",
      Approved: "Approved",
      Rejected: "Rejected",
      Withdrawn: "Withdrawn",
      Cancel: "Cancel",
      cancellationPending: "Cancellation Pending",
      CancellationPending: "Cancellation Pending",
      Archived: "Archived",
      totalCost: "Total Cost",
      holidays: "Holidays",
      workingDays: "Working Days",
      leaves: "Leaves",
      overtime: "Overtime ",
      status: "Status",
      markAsPaid: `Mark as Paid`,
      totalHours: "Total Hours",
      loggedHours: "Logged Hours",
      cost: "Cost",
      approve: "Approve",
      timesheets: "Timesheets",
      holidaysDescription: "Holidays in this period: ",
      holiDays: "Christmas Day (Dec 25, 2022) | Good Friday (Dec 26, 2022)",
      exportTimesheetData: "Export Timesheet Data",
      addEditTimesheet: "Add/Edit Timesheet",
      timesheetReport: "Timesheet Report",
      date: "Date",
      started: "Started",
      finished: "Finished",
      break: "Break",
      total: "Total",
      totalAmount: "Total Amount",
      hourlyRate: "Hourly Rate",
      totalHoursOfPayment: "Total Hours of Payment",
      timesheetsDetailFor: "Timesheet Detail for ",
      typeOfWork: "Type of Work",
      startTime: "Start Time",
      finishTime: "Finish Time",
      endTime: "End Time",
      task: "Task",
      description: "Description",
      task1: "Task 1",
      task2: "Task 2",
      task3: "Task 3",
      breakDuration: "Break Duration",
      timesheetType: "Timesheet Type",
      reasonForRejection: "Reason for Rejection",
      selectedEmployee: "Selected Employee",
      reason: "Reason",
      selectAll: "Select All",
      appliedFor: "Applied For",
      duration: "Duration",
      typeOfLeave: "Type of Leave",
      reasonForEditTimesheet: "Reason for Edit Timesheet",
      requestandApprovals: "Requests & Approvals",
      pendingForApproval: "Pending for Approval",
      paid: "Paid",
      partiallyPaid: "Partially Paid",
      submitted: "Submitted",
      cannotUndo: "You cannot undo the update.",
      markAsPaidConfirmMsg:
        "Are you sure you want to mark the timesheet as Paid?",
      invalidSelectionMsg: "Decision cannot be taken due to invalid selection.",
      pleaseNote: "Please Note: ",
      Note1: "1. Only Approved timesheets can be marked as paid.",
      Note2: "2. Only Pending timesheets can be Approved/Rejected.",
      Note3: "3. Rejected timesheets cannot be Approved.",
      leave: "Leave",
      editTimesheet: "Edit Timesheet",
      edit: "Edit",
      details: "Details",
      start: "Start",
      finish: "Finish",
      hours: "Hours",
      currentDay: "Current Day",
      holiday: "Holiday",
      rejected: "Rejected",
      goToCurrentDate: "Go to current date",
      previous: "Previous",
      next: "Next",
      note: "Note",
      clockInClockMsg: "Timesheet has been edited by Manager.",
      sortByAlphabetical: "Alphabetical (A-Z)",
      sortByEmploymentDate: "Employment Date",
      leavesEmptyMsg: "No leaves available for your selection",
      acceptTimesheet: "Accept Timesheet",
      acceptTimesheetConfirmBody:
        "Only timesheets with Pending status will be approved. Timesheets with any other status will remain unchanged. Are you sure you want to accept the timesheet?",
      accept: "Accept",
      rejectTimesheetTitle: "Reject Timesheet",
      rejectTimesheetBulkBody:
        "Only timesheets with Pending status will be rejected. Timesheets with any other status will remain unchanged. Are you sure you want to reject the timesheet?",
      markTimesheetAsPaidTitle: "Mark Timesheet as Paid",
      markTimesheetAsPaidBulkBody:
        "Only timesheets with Accepted status will be marked as Paid. Timesheets with any other status will remain unchanged. Are you sure you want to mark the timesheet as Paid?",
      noPendingTimesheetsAvailable: "No Pending Timesheets available.",
      noApprovedTimesheetsAvailable: "No Approved Timesheets available.",
      selectAtLeastOneStaffMember: "Please select at least one staff member.",
    },

    accountOwner: {
      office: "Office",
      isDeactivated: "is deactivated.",
      ownerAdminHeadingForCompanyDirectory: "Showing Company Directory for",
      searchByOfficeName: "Search by Office Name",
      ownerManager: "Owner/Manager",
      searchByName: "Search by Name",
      staff: "Staff",
      updateCurrency: "Update Subscription ",
      officeStaffInformation: "Contacts Directory",
      selectOffices: `Select Offices`,
      selectOfficeForShift: `Select Office for the Shift`,
      selectOfficeShiftModalDescription:
        "To publish the shift, you should select an office.",
      timesheetSubmission: "Timesheet submission settings saved successfully.",
      updatePlanOwner:
        "Your account owner's subscription plan does not include this feature. To use this feature, please contact your account owner to upgrade the plan.",
      updatePlanforTilesOwner:
        "Your current subscription plan is “{{field}}”. This plan does not support this feature. To enable this feature, you need to upgrade your subscription plan by signing in to your account in the web and accessing the subscription management from the main menu. You can also view the list of subscription plans and their supported features in the main webpage.",
      updatePlan:
        "Your current subscription plan is “{{field}}”. This plan does not support this feature. To enable this feature, you need to upgrade your subscription plan by  accessing the subscription management from the main menu. You can also view the list of subscription plans and their supported features in the main webpage.",
      toastSectionOfUs:
        "You cannot add offices located in the US region as you have selected CAD Currency for your account during the signup process.",
      toastSectionOfCad:
        "You cannot add offices located in the CA region as you have selected USD Currency for your account during the signup process.",
      trialSelectedToast:
        "You'll be charged a one-time setup fee and monthly office fees based on the number of offices. Adding staff incurs a monthly fee while they are active—deactivate them anytime to stop future charges. Hiring through Miraxis includes a one-time placement fee per hire.",
      confirmCurrency: "Confirm Currency",
      confirmCadCurrency:
        "By selecting the currency CAD for your account, you will only be able to create Offices that are located in Canada region.",
      confirmUsdurrency:
        "By selecting the currency USD for your account, you will only be able to create Offices that are located in US region.",
      confirmSelectionCurrency:
        "Are you sure you want to select this currency?",
      cannotSelectUs: "You cannot select US and the selected currency is CAD",
      cannotSelectCad:
        "You cannot select Canada and the selected currency is USD",
      subscriptionTrailHeading:
        "The credit card will not be charged during the trial period",
      multipleOfficeHeading:
        "Please choose carefully, decision once made cannot be changed later.",
      subscriptionCommonHeading:
        "Please enter the card details that will be charged every month when your subscription billing is due.",
      subscriptionTerminated: "Subscription Terminated",
      subscriptionTerminatedDesc:
        "The subscription is terminated. Please purchase the subscription to continue using the functionalities.",
      setupOffice: "Setup Office",
      officeDeactivationWarning:
        "You will not be able to take any action associated with the office and it will no longer be considered as part of the subscription plan. Are you sure you want to de-activate the office?",
      addStaff: "Add Staff",
      deactivateOffice: "Deactivate Office",
      readOnly: "Read Only",
      chooseOfficeTitle1: "Choose One Office From These",
      chooseOfficeDescription1:
        "For single office subscription all the other offices will be disabled.",
      chooseOfficeTitle2: "Choose the offices to proceed.",
      chooseOfficeDescription2:
        "Do you want to make the previous read-only office(s) enabled?  If so, please select the offices you would like to enable.",
      officeDetails: "Office Details",
      paymentDetails: "Payment Details",
      createOffice: "Create Office",
      saveOffice: "Save Office",
      selectACard: "Please select a card from the list",
      addMoreStaff: "Do you want to add staff member",
      searchStaff: "Search Staff",
      paidAlert:
        "This is a paid subscription, please check the pricing details.",
      editStaffMember: "Edit Staff Member",
      addStaffMember: "Add Staff Member",
      assignAccountAdminRole: "Assign Account Admin Role",
      showHourlyRate: "Show Hourly Rate to Admin",
      selectSchedule: "Select Schedule",
      sendInvitation: "Send Invitation",
      updateUser: "Update User",
      staffDeleteConfirmation: "Are you sure you want to delete invitation ?",
      staffDetail: "Staff Detail",
      jobTitle: "Job Title",
      jobType: "Job Type",
      access: "Access",
      thisMonth: "This Month",
      invitationPending: "Invitation Pending",
      invitationDeclined: "Invitation Declined",
      removedStaff: "Removed",
      staffRoleDeleteConfirmation: "Are you sure you want to delete the role?",
      markAsDefault: "Mark as Default",
      emptyStaffRolesMessage: "No staff roles added yet",
      staffRoles: "Staff Roles",
      cannotDeleteStaffRole:
        "This role is already assigned to staff and cannot be deleted.",
      dentalRoles: "Dental Roles",
      addNewRole: "Add New Role",
      medicalRoles: "Medical Roles",
      manageRoles: "Manage Roles",
      pharmacistRoles: "Pharmacist Roles",
      labImagingAndMedicalRoles: "Imaging and Medical Lab",
      saveRole: "Save Role",
      editRole: "Edit Role",
      manageHolidays: "Manage Holidays",
      addHoliday: "Add Holiday",
      updateHoliday: "Update Holiday",
      monthly: "Monthly",
      yearly: "Yearly",
      holidaysIn: "Holidays in",
      emptyHolidaysMessage: "No Holiday for",
      addHolidayMessage:
        "Please click on <1>Add Holiday</1> to add a <3 /> holiday for this",
      year: "Year",
      date: "Date",
      month: "Month",
      changePassword: "Change My Password",
      editProfile: "Edit Profile",
      changePasswordLink: "Change Password",
      myProfile: "My Profile",
      mySubscription: "My Subscription",
      enterpriseName: "Enterprise Name",
      changeSubscription: "Change Subscription",
      manageCards: "Manage Cards",
      terminateSubscription: "Terminate Subscription",
      viewFeatures: "View Features",
      creditCards: "Credit Cards",
      card: "Card",
      searchOfficeByName: "Search Office by Name",
      changeCardDetails: "Change Card Details",
      creditCardDetails: "Credit Card Details",
      for: "For",
      updateCard: "Update Card",
      selectCard: "Select Card",
      or: "OR",
      addNewCard: "Add New Card",
      noPlanSubscribedYet: "No Plan subscribed yet.",
      terminateSubscriptionWarningMessage:
        "Are you sure you want to terminate your subscription? You will no longer be able to manage your offices or staff members through the application.",
      sureAboutTermination: "Yes I am sure. Terminate my account Immediately",
      notSureAboutTermination: "No, I do not want to terminate my account",
      mo: "mo",
      perActiveUserStaff: "per Active Staff User",
      perActiveTempUserStaff: "per Active Temp Staff User",
      perActiveTempUserStaff1: "Per Active Temp Staff User",
      perStaffPlacement: "per Staff Placement",
      perStaffPlacement1: "Per Staff placement",
      yourCurrentPlan: "Your Current Plan",
      purchasePlan: "Purchase Plan",
      enterprise: "Enterprise",
      enterprisePlanTitle: "Contact Sales <1 /> To Build a Custom Plan",
      enterprisePlanDescription:
        "Ideal for large enterprises with setups across countries, having a large set of employees.",
      noOfOffices: "No. of Offices",
      chooseSubscription: "Choose Subscription",
      setupYourAccount: "Complete Your Account Setup",
      letsHelpYouInSettingUpYourAccount:
        "To activate your account, please enter your business information. This helps us tailor the platform to your needs and prepare your workspace.",
      setupAccount: "Setup Account",
      changePlanConfirmation: "Are you sure you want to change plan?",
      singleOfficeSubscription: "Single Office Subscription",
      multipleOfficeSubscription: "Multiple Office Subscription",
      enterprisePlans: "Enterprise Plans",
      perOffice: "per office",
      confirmSubscription: "Confirm Subscription",
      freeTrialEndsOn: "Free trial ends on",
      startTrialNow: "Start Your Free Trial Now!",
      trialDescription:
        "If you choose no subscription, you have to choose subscription later <1 /> when trial ends.",
      billing: "Billing",
      noSubscription: "No Subscription",
      trialCta: "Try It Free for 30 Days",
      paySubscription: "Pay Subscription",
      startYourFreeTrial: "Start Your Free Trial",
      cardDetails: "Card Details",
      saveCard: "Save Card",
      billingPreferenceTitle: "How would you like to pay for your offices?",
      billingPreferenceType1Text:
        "One Credit Card for Every Offices <1>(For One Credit Card, You Will Get One Invoice)</1>",
      billingPreferenceType2Text:
        "Different Credit Card for Different Offices <1>(For Multiple Credit Cards, You Will Get Multiple Invoices)</1>",
      cardInputText1:
        "Please enter the card details that will be charged every month when your subscription billing is due.",
      cardInputText2:
        "Note: You can add offices and link different cards to each office later in next steps. A minimum of 2 offices will be charged each month until offices are added. You can associate a different card with each office under Payment Details when adding a new office",
      deactivateStaff: "Deactivate Staff",
      cancelInvitationStaff: "Cancel Invitation Staff",
      cancelInvitation: "Cancel Invitation",
      cancelInvitationModalHeader: "Cancel Invitation?",
      deactivate: "Deactivate",
      commonMultipleDesciption:
        "This person is assigned to multiple offices. Select the offices from which you want to {{type}} this staff member.",
      activateStaff: "Activate Staff",
      activate: "Activate",
      removeStaff: "Remove Staff",
      remove: "Remove",
      removeAsAnAccountAdmin: "Remove as an Account Admin",
      officeSelectionDescription:
        "This person is an ‘<1>Account Admin</1>’ for this office. Do you want to {{action}} this person {{role}}from this office only or all offices?",
      officeSelectionOption1:
        "{{action}} this person {{role}}from this office only",
      officeSelectionOption2: "{{action}} this person {{role}}from all offices",
      ownershipSelectionDescription:
        "This person is an ‘<1>Account Admin</1>’ for this office. There are work items such as Tasks created by this person that should be transferred to another Admin in your account.",
      ownershipSelectionOption1: "Transfer their work items to my own account",
      ownershipSelectionOption2:
        "Transfer their work items to another Admin for this office",
      ownershipSelectionOption2_plural:
        "Transfer their work items to another Admin for all offices",
      activateStaffModalDescription:
        "<0>The activated staff member will be associated with the office again and can also submit timesheets.</0><1>Are you sure you want to activate the staff member?</1>",
      deactivateStaffModalDescription:
        "<0>The staff member will no longer be associated with the office and cannot submit timesheets but can still view previous timesheets.</0><1>The staff member can be re-activated later if they re-join.</1>",
      rERC5b4PoR51qWEvAWuJsX6yRVRBvRVta7:
        "<0>The staff member will be permanently removed and there will be no association with the office.</0><1>The staff member can still view their timesheets but cannot take any action.</1>",
      rERC5b4PoR51qWEvAWuJsX6yRVRBvRVtb7:
        "<0>Are you sure you want to remove the person as an Admin?</0>",
      daysPerYear: "Days/Year",
      staffMembers: "Staff Members",
      preferences: "Office Preferences",
      Mypreferences: "My Preferences",
      timesheetSubmissionPreferences: "Timesheet Submission Preferences",
      enableSubmissionTimesheetSubmissionPreferences:
        "Enable submission only if a shift/event exists",
      allowSubmissionTimesheetSubmissionPreferences:
        "Allow timesheet only when shift/event is created",
      basic: "Basic",
      basicDescription:
        "Staff can submit timesheets using their phone anytime anywhere but the admin can approve/reject them.",
      onPremise: "On Premise",
      onPremiseDescription:
        "Staff can submit timesheets only when they are in the office premises. For this option, you also need to configure settings for Geo-Fencing or Static IP.",
      staticIP: "Static IP",
      staticIPDescription:
        "Static IP option is a location-based service; the staff can submit timesheets only in the workstations of which Static IP addresses are added below.",
      addNewStaticIP: "Add New Static IP",
      geoFencing: "Geo-Fencing",
      clockInClockOut: "Clock In / Clock Out",
      staticIPonMobile: "Static IP on Mobile",
      staticIPonMobileDescription:
        "Static IP option is a location-based service; the staff can submit timesheets using mobile when connected on office Wi-Fi.",
      staticIPMobileNotAddedErrorMessage:
        "To select the preference of static IP on mobile, it is mandatory for you to add at least one active IP address of the office.",
      clockInclockOutErrorMessage:
        "The Clock In / Clock Out option can only be selected if either of the Geo-fencing, Static IP, or both are selected.",
      nameOfIP: "Name of IP",
      staticIPAddress: "Static IP Address",
      nameOfIPExample: "e.g. Workstation 001",
      ipAddress: "IP Address",
      ipAddressExample: "e.g. 100.179.14.253",
      newStaticIP: "New Static IP",
      updateStaticIP: "Update Static IP",
      ipAddedSuccessfully: "IP added successfully.",
      ipUpdatedSuccessfully: "IP updated successfully.",
      ipStatusUpdatedSuccessfully: "IP status updated successfully.",
      ipDeletedSuccessfully: "IP deleted successfully.",
      ipDeleteConfirmationText:
        "The staff members will not be able to fill the timesheet from the deleted IP location. Are you sure want to delete the selected IP?",
      ipActivationConfirmationText:
        "Are you sure you want to activate the selected IP?",
      ipDeactivationConfirmationText:
        "If you deactivate an IP, the users from this IP will not be able to fill in any timesheets. Are you sure you want to deactivate this IP?",
      defineGeoFencingArea: "Define Geo-Fencing Area",
      editGeoFencingArea: "Edit Geo-Fencing Area",
      editGeoFencingAreaConfirmationText:
        "You have already defined a Geo-fencing area. Would you like to edit it?",
      geoFenceAreaUpdateSuccessfully: "Geo-Fence area updated successfully",
      deactivatedOfficePreferenceMessage:
        "The selected office is deactivated. Any changes you make in the timesheet preference will be applicable once the office is activated.",
      preferencesUpdatedSuccessfully:
        "Timesheet preferences updated successfully.",
      clockInpreferencesUpdatedSuccessfully:
        "Clock In / Clock Out preferences updated successfully.",
      geoFenceNotDefinedErrorMessage:
        "To select the preference of Geo-fencing, it is mandatory for you to define the office area first.",
      staticIPNotAddedErrorMessage:
        "To select the preference of Static IP, it is mandatory for you to add at least one active IP address for the office.",
      clearGeoFencingArea: "Clear Geo-fencing area",
      drawGeoFencingArea: "Draw Geo-fencing Area",
      finishDrawingGeoFence: "Finish Drawing",
      cancelDrawingGeoFence: "Cancel Drawing",
      drawGeoFenceHint:
        "Click the map to place points ({{count}} placed). Add at least 3 points, then click Finish Drawing or click the first point to close.",
      assignDoctorRole:
        "Assign Doctor, Hygienist or Therapist Role for Online Booking",
      assignReceptionistRole: "Assign Receptionist Role",
      geoFenceInstructionStep1:
        "Zoom Out and Zoom In on the map to find the exact location.",
      geoFenceInstructionStep2:
        "When drawing is active (crosshair cursor), click on the map to place boundary points. Add at least three points, then click Finish Drawing or click the first point again to close the area. Use Clear Geo-fencing area first if you need to redraw an existing fence.",
      geoFenceInstructionStep3:
        "Once drawn, click on Save to save the defined geo fence area.",
      geoFenceInstructionStep4:
        "In case you want to edit, Clear the geo fence area first to define the new area.",
      geoFenceInstructionStep5: "",
      geoFenceDescription:
        "Geofencing is a location-based service; the Staff can submit timesheet using their phone only when they are in your office building. To configure this option, you need to select the boundary of your office building using the tool below.",
      moveToOfficeLocation: "Move to Office Location",
      startFreeSubscriptionToday: "Start Free Subscription Today",
      freePackageDescription:
        "With free subscription, you will only be listed as a search result to the patients. To receive the appointments and access to other features, upgrade your plan.",
      freeAccountBannerText:
        "You can not add staff members and offices as this is a Free Account",
      freeAccountUpgradeText: "Want to add more Offices?",
      freeAccountUpgradeButtonText: "Upgrade Now",
      wantToUpdateYourInfo: "Want to update your info?",
      editOfficeWarningMessage:
        "To change your office info (e.g., its address), go to More Options (︙) on the office tile and select <strong>Edit Office</strong>.",
      editProfileWarningMessage:
        "To update your <strong>profile</strong> (e.g., name or medical background), go to",
      noStaffMembersAllowed: "No Staff Members Allowed",
      basicInfo: "Basic Info",
      medicalBackground: "Medical Background",
      credentialsAndLicensing: "Credentials & Licensing",
      credentialDeletedSuccessfully: "Credential deleted successfully",
      addOrEdit: "Add or Edit",
      selectSpecialtiesAndServices: "Select Specialties / Services",
      addSpecialtiesAndServices: "Add Specialties / Services",
      saveSpecialty: "Save Specialty",
      primaryLicense: "Primary License",
      noLicensesAddedYet: "No licenses added yet.",
      addLicenseDescription:
        "Add a license to start tracking validity and renewal dates.",
      addLicense: "Add License",
      addAnotherLicense: "Add Another License",
      certifications: "Certifications",
      noCertificationsAvailable: "No certifications available.",
      addCertificationDescription:
        "Add a certification to maintain accurate compliance records.",
      addCertification: "Add Certification",
      addAnotherCertification: "Add Another Certification",
      training: "Training",
      noTrainingRecordsFound: "No training records found.",
      addTrainingDescription: "Add a training entry to keep profile complete.",
      addTraining: "Add Training",
      addAnotherTraining: "Add Another Training",
      expires: "Expires:",
      noExpiryDate: "No expiry date",
      view: "View",
      edit: "Edit",
      delete: "Delete",
      notAdded: "Not Added.",
      years: "years",
      credentialName: "Credential Name",
      type: "Type",
      issuingAuthority: "Issuing Authority",
      credentialId: "Credential ID",
      issueDate: "Issue Date",
      expiryDate: "Expiry Date",
      expiresOnDate: "Expires on a Date",
      doesNotExpire: "Does Not Expire",
      proofDocument: "Proof Document",
      download: "Download",
      additionalDocuments: "Additional Documents",
      downloadingDocument: "Downloading document...",
      documentDownloadedSuccessfully: "Document downloaded successfully",
      errorDownloadingFile: "Error downloading file",
      uploadFile: "Upload file",
      noFileSelected: "No file selected",
      selectOffice: "Select Office",
      selectStaff: "Select Staff",
      selectType: "Select Type",
      credentialIdOptional: "Credential ID (Optional)",
      pleaseSelectAtLeastOneOffice: "Please select atleast one office.",
      pleaseSelectAtLeastOneStaffMember:
        "Please select atleast one staff member.",
      pleaseSelectAtLeastType: "Please select Type",
      pleaseAddCredentialName: "Please add credential name.",
      noNameSelected: "No name selected",
      selectCredentialName: "Select Credential Name",
      addNewCredential: "Add New Credential",
      noCredentialsAvailableForSelection:
        "No credentials available for selection.",
      credentialNameStaffInfoMessage:
        "Can't find the credential name you need? Contact your manager to have it added.",
      cannotDeleteCredentialNameInUse:
        "Cannot delete because this Credential Name is used by staff records.",
      deleteCredentialTitle: "Delete Credential",
      deleteCredentialConfirmation:
        "Are you sure you want to delete the credential?",
      credentialNameAddedSuccessfully: "Credential name added successfully",
      credentialNameUpdatedSuccessfully: "Credential name updated successfully",
      credentialNameDeletedSuccessfully: "Credential name deleted successfully",
      clearSearch: "Clear search",
      search: "Search",
      na: "N/A",
      pleaseAddIssuingAuthority: "Please add issuing authority.",
      expiryDateShouldBeGreaterThanIssueDate:
        "Expiry date should be greater than issue date.",
      expiryDateRequired: "Please select an expiry date.",
      pleaseUploadProofDocument: "Please upload Proof Document.",
      ownerAdminHeadingForCredentialsAndLicensing: "Showing Credentials for",
      credentialUpdatedSuccessfully: "Credential updated successfully",
      credentialSavedSuccessfully: "Credential saved successfully",
      addCredentialInformationForOffice:
        "{{addEdit}} credential information, expiry details, and supporting documents for an office.",
      addCredentialInformationForStaff:
        "{{addEdit}} credential information, expiry details, and supporting documents for a staff member.",
      addCredentialInformation:
        "{{addEdit}} credential information, expiry details, and supporting documents.",
      ninetyDaysBeforeExpiry: "90 days before expiry",
      thirtyDaysBeforeExpiry: "30 days before expiry",
      sevenDaysBeforeExpiry: "7 days before expiry",
      onExpiry: "On expiry",
      notifyStaff: "Notify Staff",
      select: "Select",
      deleteDocument: "Delete Document",
      deleteDocumentDescription:
        "Deleting the document will permanently delete it for all the users.",
      deleteDocumentConfirmation:
        "Are you sure you want to delete the document?",
      manageStaffCredentialExpiryReminders:
        "Manage staff credential expiry reminders and notification timing",
      manageOfficeCredentialExpiryReminders:
        "Manage office credential expiry reminders and notification timing",
      credentialsLicensingHelpStaffBody:
        "Enable the toggle to notify users when their documents are nearing expiry, and select the number of days in advance for sending these notifications. This setting applies only to notifications for users about their own documents; owners and admins will not receive alerts for staff documents. Instead, they can view expired documents by navigating to the Credentials and Licensing list from global options and applying relevant filters. Disable the toggle if notifications are not required.",
      credentialsLicensingHelpOfficeBody:
        "Enable the toggle to send reminder notifications for expiring office credentials and select the owner and admin who should receive them. Only the selected users will be notified, and you can define the number of days in advance for sending these reminders. Disable the toggle if notifications are not required.",
      saving: "Saving...",
      preferencesSavedSuccessfully: "Preferences saved successfully",
      allOffices: "All Offices",
      allRoles: "All Roles",
      selected: "Selected",
      staffLicense: "Staff License",
      officeLicense: "Office License",
      showExpiringSoon: "Show expiring soon (within 1 week)",
      credentialStatus: "Credential Status",
      credentialType: "Credential Type",
      addStaffCredential: "Add Staff Credential",
      addOfficeCredential: "Add Office Credential",
      noStaffCredentialsAvailable:
        "No staff credentials available for your selection",
      noOfficeCredentialsAvailable:
        "No office credentials available for your selection",
      credentialsAndLicensingDetails: "Credentials & Licensing Details",
      editOfficeCredential: "edit office credential",
      editStaffCredential: "edit staff credential",
      officeName: "Office Name",
      staffMember: "Staff Member",
      action: "Action",
      valid: "Valid",
      expiringSoon: "Expiring Soon",
      expired: "Expired",
      license: "License",
      certification: "Certification",
      officeLicenses: "Office Licenses & Credentials",
      officeLicensesDescription:
        "The Office Licenses & Credentials section allows you to manage all licenses, permits, and credentials associated with an office.",
      keyCapabilities: "Key Capabilities",
      staffViewAddEditCapability:
        "View, add, and edit staff licenses and credentials.",
      officeViewAddEditCapability:
        "View, add, and edit office licenses and credentials.",
      updateCredentialDetailsCapability:
        "Update credential details such as credential name, type, credential number, issuing authority, issue date, expiry information, and supporting documents.",
      automatedExpiryRemindersCapability:
        "Receive automated expiry reminders for credentials that have a valid expiry date and a Proof Document attached.",
      expiryStatus: "Expiry Status",
      staffExpiryStatusDescription:
        "Each credential is assigned one of the following statuses based on its expiry information:",
      officeExpiryStatusDescription:
        "Each office credential is assigned one of the following statuses based on its expiry information:",
      currentStatus: "Current",
      currentStatusDescription:
        "The credential has a future expiry date and is not yet approaching expiry.",
      expiringSoonStatusDescription:
        "The credential will expire within one week.",
      expiredStatusDescription: "The expiry date has passed.",
      noExpiryStatus: "No Expiry",
      noExpiryStatusDescription: "The credential does not have an expiry date.",
      expiryUnknownStatus: "Expiry Unknown",
      expiryUnknownStatusDescription: "The expiry date is not known.",
      documentation: "Documentation",
      documentationStatus: "Documentation Status",
      documentationStatusDescription:
        "The Documentation column indicates whether a Proof Document has been uploaded:",
      completedStatus: "Completed",
      completedStatusDescription: "A Proof Document has been uploaded.",
      proofMissingStatus: "Proof Missing",
      proofMissingStatusDescription: "No Proof Document has been uploaded.",
      cannotEditCredentialAddedByOtherOwner:
        "You cannot edit the record as it is added by another account owner.",
      cannotDeleteCredentialAddedByOtherOwner:
        "You cannot delete the record as it is added by another account owner.",
      cannotDeleteCredentialContactManager:
        "Credentials once added cannot be deleted. Please contact your manager to delete the credentials for you.",
      officeLicensesNote:
        "Note: Expiry Status and Documentation Status are independent of each other. An office credential can have a status of Current, Expiring Soon, Expired, No Expiry, or Expiry Unknown, while its Documentation Status may still be Proof Missing.",
      staffLicenses: "Staff Credentials",
      officeLicensesPermits: "Office Licenses & Permits",
      staffLicensesDescription:
        "The Staff Licenses & Credentials section allows you to manage all licenses and credentials associated with staff members.",
      staffLicensesNote:
        "Note: Expiry Status and Documentation Status are independent of each other. A credential can have a status of Current, Expiring Soon, Expired, No Expiry, or Expiry Unknown, while its Documentation Status may still be Proof Missing.",
      unknownFile: "Unknown file",
      upgradeSubscriptionDescription:
        "To add your offices and see your appointments, please upgrade your subscription.",
      showInSearchDatabase: "Show In Search Database",
      profile: "Profile",
      upgradeSubscription: "Upgrade Subscription",
      deleteMyAccount: "Delete my Account",
      deleteAccount: "Delete Account?",
      deleteAccountDescription:
        "If you delete the account, you will not be listed in the search database to the patient and you cannot log in again. Are you sure you want to delete the account?",
      practiceAddress: "Practice Address",
      searchbySpecialtiesName: "Search by Specialties Name",
      uploadOfficePictureDescription:
        "Click here to Upload Office Picture or Profile Picture.",
      uploadOfficeLogoDescription:
        "Upload your Company Logo JPG or PNG. Recommended size 500*500px.",
      switchToMobileApp: "Switch to Mobile App",
      switchToMobileAppDesc:
        "To view the linked Performance Review, please switch to the mobile app.",
      okayGotIt: "Okay, Got it",
      officeManagers: "Office Managers",
      clockInClockOutDesc:
        "The staff office timings are filled based on when they Clock In and Clock Out from the office. Edit timesheet request will be sent to account owners and admins for approval. Please select Static IP or Geofencing to be able to select clockin/out.",
      addNewEventShift: "Create Event / Shift",
      addNewEvent: "Create Event",
      eventTab: "Event",
      shiftTab: "Shift",
      editEvent: "Edit {{eventOrShift}}",
      staffDetails: "Staff Details",
      newEvent: "New Event",
      newEventShift: "New Event/Shift",
      allDayEvent: "All Day {{eventOrShift}}",
      automacticallyAccept: "Automatically approve join requests",
      automacticallyAcceptInfoText:
        "When enabled, staff from the selected offices can join this event automatically without waiting for your approval.",
      endDateRepeatedEvents: "End Date for Repeated {{eventOrShift}}",
      clearAll: "Clear all",
      frequency: "Frequency",
      every: "Every",
      each: "Each",
      onThe: "On The...",
      daysOfWeek: "Days of Week",
      events: "Events",
      shifts: "Shifts",
      selectRoles: "Select Roles",
      noRolesSelected: "No role(s) selected",
      blockTimeslotAallDoctors:
        "Do you also want to block the timeslot of all doctors, who are assigned in this event, for online patient scheduling?",
      selectEmployees: "Select Staff Members",
      selectStaff: "Select Staff",
      addEmployees: "Add Staff Members",
      searchEmployee: "Search staff member",
      notifiedEmployee: "Notified Employee(s)",
      noEmployeesSelected: "No staff members selected",
      notes: "Notes",
      note: "Note",
      addEvent: "{{saveOrPublish}} {{eventOrShift}}",
      UpdateEvent: "Update {{eventOrShift}}",
      tags: "Tags",
      searchByName: "Search by Name",
      addRoles: "Add Roles",
      eventDetails: "{{eventOrShift}} Details",
      details: "Details",
      requestToJoin: "Request to join ",
      offices: "Office(s) ",
      employeesInvitationStatus: "Employees Invitation Status",
      requestedJoinEventFor: "requested to join {{eventOrShift}} for ",
      seeSpecificDates: "See Specific Dates ",
      specificDates: "Specific Dates ",
      deleteEvent: "Delete Event ",
      areYouSureYouWantToDeleteTheEvent:
        "Are you sure you want to delete the event?",
      reasonOfRejection: "Reason of Rejection",
      decline: "Remove Request",
      WithdrawRequest: "Withdraw Request?",
      withdraw: "Withdraw",
      requestedJoinEventForThisDay:
        "requested to join {{eventOrShift}} for this day ",
      SeeReasonofRejection: "See Reason of Rejection",

      deleteNotes: "Delete Notes",
      pricingDetailsOfBasicPlan: "Pricing Details of Basic Plan",
      pricingDetailsOfAdvancedPlan: "Pricing Details of Advanced Plan",
      pricingDetailsOfProfessionalPlan: "Pricing Details of Professional Plan",
      deleteNote: "Delete Note",
      areYouSureYouWantToDeleteTheNote:
        "Are you sure you want to delete the note?",
      reasonOfCancellation: "Reason of Cancellation",
      writeReason: "Write a reason",
      scheduler: "Scheduler",
      officeScheduler: "Office Schedule",
      agenda: "My Events",
      mySchedule: "My Schedule",
      multipleOffice: "Multiple Office",
      requests: "Invitation Requests",
      workingEventsShifts: "Event Workspace",
      myEventsShifts: "Other Office Events/Shifts",
      filters: "Filters",
      busyTimeslot: "Busy Timeslot",
      addBusyTimeslots: "Add Busy Timeslots",
      addBusyslots: "Add Busy Slot",
      editBusyTimeslots: "Edit Busy Timeslots",
      duplicateBusySlot: "Duplicate",
      duplicateBusyTimeslots: "Duplicate Busy Timeslots",
      addBusyTimeslotsDesc:
        "Make yourself unavailable for any online patient scheduling or any working events scheduled in your office.",
      blockSlot: "Block Timeslot",
      busyTimeslotDetails: "Busy Timeslot Details",
      endTime: "End Time",
      deleteBusyTimeslot: "Delete Busy Timeslot",
      busyTimeSlot: "End Date for Repeated Busy Timeslot",
      areYouSureYouWantToDeleteBusyTimeslot:
        "Deleting the busy timeslot would mean that you are available for Patient Bookings and Events. Are you sure you want to delete the busy timeslot?",
      eventCreatedBy: "Assigned  by",
      assigneddBy: "Assigned  by",
      withdrawRequest: "Withdraw Request",
      cancelSchedule: "Cancel Schedule",
      goBack: "Go Back",
      yesAccept: "Yes, Accept",
      confirmAccept: "Confirm Accept",
      confirmAcceptDesc:
        "The selected date and time is blocked in your calendar. Do you still want to Accept?",
      dateRange: "Date Range",
      staffAvailability: "Staff Schedule",
      employees: "Staff Members",
      officeForPublishing: "Office for Publishing",
      employe: "Staff Member(s)",
      staffTxt: "Staff Member(s)",
      createdByYou: "Created by You",
      createdByOthers: "Created by Others",
      eventsNotAccepted: "Events Not Accepted",
      eventCreatedByYou: "Event Created by You",
      eventCreatedByOthers: "Event Created by Others",
      shiftCreatedByYou: "Shift Created by You",
      shiftCreatedByOthers: "Shift Created by Others",
      shiftNotAccepted: "Shifts Not Accepted",
      busy: "Busy",
      busySlot: "Busy TimeSlot",
      busySlots: "Busy TimeSlots",
      nonAvailableDays: "Non Available Days",
      filterEvents: "Events Filter",
      viewSetting: "Display Settings",
      notifyEmployee: "Notify Staff Member",
      notifyEmployees: "Notify Employees",
      timeslotNotifyEmployee:
        "This will notify staff member about your busy timeslots",
      onLeave: "On Leave",
      leaveApproved: "Leave - Approved",
      leavePending: "Leave - Request",
      leave: "Leave",
      officeName: "Office Name",
      searchPlaceholderForStaffScheduleTitle:
        "Search by tags, event title or staff member.",
      searchForTagsEventsTitle: "Search for tags, events title",
      searchForTitleAndStaff: "Search for title, staff member",
      publishEvent: "Publish Event",
      preferredOption: "Choose Your Preferred Option",
      publishEventHeadingSelection:
        "Who Can See and Join This {{eventOrShift}}?",
      publishHeadingToolTip1:
        "If you choose the “Only invited staff can see and join this {{eventOrShift}}” option, only the specified staff members will receive invitations to join the {{eventOrShift}}. Non-invitees will not have the ability to request access to the {{eventOrShift}}.",
      publishHeadingToolTip2:
        "If you choose the “Let other staff request to join (besides invitees)”, the selected staff members will receive invitations to join the {{eventOrShift}}, and other staff members within the organization will have the option to request to join.",
      publishHeadingToolTip3:
        "If you choose the “Save as draft (do not publish yet)” option, the {{eventOrShift}} will be saved for your reference but will not be visible to any staff members on the calendar. You can publish it at a later time if desired.",
      publishHeadingToolTip4: `If you select "Let other staff request to join" staff members assigned to the selected office and role will be able to request to join the event.`,
      publishHeadingToolTip5: `If you select "Save as draft (do not publish yet)", the event will be saved for your reference but will not be visible to any staff members on the calendar. You can publish it at a later time if desired.`,
      inviteesOnly: "Only invited staff can see and join this {{eventOrShift}}",
      allowRequestForStaffMembers: "Let other staff request to join",
      allowInvitees: "Let other staff request to join (besides invitees)",
      nonInviteeFirstOption: "Only staff from invitee’s offices",
      nonInviteeSecondOption: "All staff across the organization",
      nonInviteeThirdOption: "Specific offices only",
      nonInviteeFourthOption: "Specific offices only",
      saveDraft: "Save as draft (do not publish yet)",
      inviteesOnlyMsg:
        'If you choose the "Only invited staff can see and join this {{eventOrShift}}" option, only the specified staff members will receive invitations to join the event. Non-invitees will not have the ability to request access to the event.',
      allowInviteesMsg:
        'If you choose the "Let other staff request to join (besides invitees)" option, the selected staff members will receive invitations to join the event, and other staff members within the organization will have the option to request to join.',
      saveDraftMsg:
        'If you choose the "Save as draft (do not publish yet)" option, the event will be saved for your reference but will not be visible to any staff members on the calendar. You can publish it at a later time if desired.',
      editNote: "Edit Note",
      saveLocation: "Save Location",
      viewNote: "View Note",
      resetFilter: "Reset Filter",
      hideFilters: "Hide Filters",
      showFilters: "Show Filters",
      ouDontHaveAnyPendingRequests:
        "No invitation requests available for your selection",
      noOfficeFound: "No office available for your selection",
      noOwnerManagerFound: "No Owner/Manager available for your selection",
      NoNotificationsFound: "No notifications available for your selection",
      assignedEmployees: "Assigned Employees:",
      dateApply: "Date apply successfully",
      foralldates: " All future dates",
      showOnMap: "Show on Map",
      notRegisterInGoogle: "Not registered on Google",
      selectValidCountry:
        "Please choose a different location as it is not as per the selected country.",
      addOffice: "Add Office",
      addOfficeBottomDesc:
        "If you have registered your business address on Google, select the exact location from the options below for better reach to the patients.",
      sync: "Sync",
      addToCalendar: "Download and Add to Calendar",
      addToCalendarDescription:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries,",
      syncModalTitle: "Sync with Calendar",
      syncUrlToolTip: "Copy this Url",
      from: "From",
      to: "To",
      search: "Search",
      syncUrlCopied: "Sync url copied to clipboard.",
      suggestionAcMsg: "Have suggestion? Communicate them here, ",
      NeedHelpAcMsgStart: "Need help? Check out our ",
      NeedHelpAcMsgEnd: " for tips on using the platform's features.",
      suggestionAcTitle: "Feedback & Suggestion",
      OnlineHelpTitle: "Online Help",
      NeedHelpStaffMsg:
        "Need help? For more information about how to use the app's modules i.e. how to create & share invoices for timesheet, see ",
      downloadApp:
        "Want to download the app? Access full features of the application by downloading the app here: Android or iOS",
      Android: "Android ",
      ViewDetails: "View Details",
      iOS: " iOS",
      ortoo: "or",
      multipleOffices: "Multiple Offices",
      singleOffice: "Single Office",
      basicPlan: "Basic Plan",
      featureIncludedInBasicPlan: "Features Included in Basic Plan",
      featureIncludedInProfessionalPlan:
        "Features Included in Professional Plan",
      featureIncludedInEnterPrisePlan: "Features Included in Enterprise Plan",
      featureIncludes: "Feature includes:",
      viewPricingDetails: "View Pricing Details",
      viewComparisonFeatures:
        "View Comparison of Features in Different Subscription Plans",
      pricingDetailsForBasicPlan: "Pricing Details for Basic Plan",
      oneTimeSetupFee: "One Time Setup Fee",
      advanced: "Advanced",
      professional: "Professional",
      featureTextGoesHere: "Feature text goes here",
      pricingDetails: "Pricing Details",
      subscriptionPlanFeaturesComparison:
        "Subscription Plan Features Comparison",
      selectNoOfOffice: "Select Number of Offices",
      featureIncludedInAdvancedPlan: "Features Included in Advanced Plan",
      basicPlanAlert:
        "After successful signup and one month free trial, your account will be charged with one time setup fee and monthly office charges based on the number of offices you have created. The Temporary Staff Monthly Charges and Permanent Staff Monthly Charges will be added in the billing whenever you add/invite a new staff member and they actively use the app. The Placement Charges occur when the actual personnel search & hiring is done through Miraxis Platform's job board.",
      alerttrial:
        "The free trial account will automatically be upgraded to a professional subscription package after the expiry of the trial subscription. You can change the subscription plan or cancel this upgrade before the expiry date. ",
      twoOffices: "Two Offices",
      viewPricingPlan: "View Pricing Plan",
      officeTypeNote:
        "Note: After one month/expiry of trial account, your subscription will be upgraded to a paid subscription so you don't lose settings and data. You can cancel this upgrade before the expiry if you wish.",
      perActivePermanentStaffMember: "Per Active Permanent Staff Member ",
      perActiveTempStaffUser: "Per Active Temp Staff User",
      singleOfficePricingPlan: "Single Office Pricing Plan",
      okay: "Okay",
      multipleOfficePricingPlan: "Multiple Office Pricing Plan",
      confirmSubscriptionDetail:
        "Your free trial account will be upgraded automatically to a paid subscription after completion of the free trial, and your credit card will be charged. You can cancel it before the upgrade if you wish. You will need to enter your credit card information in order to use this free trial account.",
      yesConfirm: "Yes, Confirm",
      doYouConfirmThisSubscription: "Do you confirm this subscription?",
      startfreeTrial: "Start Free Trial",
      durationAlert:
        "Note: For the duration of free trial, the credit card(s) won't be charged.",
      deactivated: "Deactivated",
      editCardDetail: "Credit Card Details for {{officeName}}",
      editOffice: "Edit Office",
      updatePlanForNotification:
        "You current subscription plan does not have an access to this feature anymore.",
      removeOffice: "Remove Office",
      removeOfficeConfirmation: "Are you sure you want to remove office?",
      manageCardHeading: "Manage Credit Cards for Your Offices",
      adminTooltipText:
        "The staff member assigned as admin can access the staff as well as the administration functionality. For Example: They can both submit a timesheet for their own hours, and approve/reject other staff timesheets.",
      doctorTooltipText:
        "The staff member assigned the role of a doctor can receive the patient appointment requests and can manage their schedule & timeslots for receiving the patient appointments. They can also be setup to be in Miraxis's online booking search for patients.",
      receptionistTooltipText:
        "The staff member assigned the role of a receptionist can view and manage the doctor's appointments and schedule.",
      inventoryTooltipText:
        "The staff member assigned the role of an inventory manager can manage the inventory of an office by adding and removing the items in inventory.",
      ordermanagerTooltipText:
        "The staff member assigned the role of an order manager can purchase supplies/place an order with the vendor for an office.",
      patientName: "Patient Name",
      profileColor: "Pick a Profile Color",
      profileColorInfoMsg:
        "Select a color to highlight this staff member's name in the office scheduler. Use consistent colors for similar roles (e.g., all assistants) to easily identify them at a glance.",
      timeLineSettings: "Timesheet Settings",
      generalTimesheetSettings: "General Timesheet Settings",
      timesheetSubmissionControl: "Timesheet Submission Control",
      noUsersAdded: "No users added",
      noStaffSelected: "No staff member(s) selected",
      noOfficeSelected: "No office(s) selected",
      eventCannotBeMovedToAPastDate: "Event cannot be moved to a past date",
      duplicateEvent: "Duplicate {{eventOrShift}}",
    },
    superAdmin: {
      extendTrialDate: "Extend Trial Date",
      manageAccountOwners: "Account Owners",
      emptyOwnersListMessage: "No owners added yet",
      ownerDeactivateWarningMessage:
        "The account owner will no longer be able to access the platform. Are you sure you want to de-activate the account?",
      ownerPlanDeactivateWarningMessage:
        "Are you sure you want to de-activate the plan?",
      emptyDemoRequestListMessage: "No request yet",
      searchDemoRequests: "Search Demo Requests",
      demoRequests: "Demo Requests",
      emptyTestimonialListMesssage: "No testimonial yet",
      addTestimonial: "Add Testimonial",
      manageTestimonials: "Testimonials",
      designation: "Designation",
      category: "Category",
      description: "Description",
      actions: "Actions",
      download: "Download",
      edit: "Edit",
      enable: "Enable",
      disable: "Disable",
      uploadAPicture: "Upload a Picture",
      manageContent: "Content",
      active: "Active",
      inactive: "Inactive",
      url: "URL",
      personnelName: "Personnel Name",
      activeOffices: "Active Offices",
      status: "Status",
      personnelDeactivationWarningMessage:
        "The member will no longer be able to access the platform. Are you sure you want to de-activate the account?",
      managePersonnel: "Manage Personnel",
      searchMember: "Search Member",
      emptyPersonnelListMessage: "No Personnel added yet.",
      accountOwnerName: "Account Owner Name",
      role: "Role",
      currentActivePlan: "Current Active Plan",
      endDateOfTrial: "End Date of Trial Account",
      cancelPlan: "Cancel Plan",
      subscriptionManagement: "Subscription Management",
      subscriptionManagementForVendors: "Subscription Management for Vendors",
      singleOfficeSubscription: "Single Office Subscription",
      multipleOfficeSubscription: "Multiple Office Subscription",
      enterpriseSubscription: "Enterprise Subscription",
      trialSubscription: "Trial Subscription",
      officeCharges: "Office Charges",
      cad: "CAD",
      usd: "USD",

      perMonth: "per month",

      temporaryStaffCharges: "Temporary Staff Charges",
      permanentStaffCharges: "Permanent Staff Charges",
      placementCharges: "Placement Charges",
      editSubscription: "Edit Subscription",
      emptyPlanMessage: "No Plan added yet",
      enterprisePlanName: "Enterprise Plan Name",
      mo: "mo",
      enterpriseOfficePlans: "Enterprise Office Plans",
      addNewPlan: "Add New Plan",
      emptyEnterprisePlanListMessage: "No enterprise plan added yet",
      searchPlans: "Search Plans",
      enterprisePlanSubscription: "Enterprise Plan Subscription",
      addNewAccountOwner: "Add new Account Owner",
      enterpriseOwnersEmptyListMessage: "No enterprise owners added yet",
      editUser: "Edit User",
      enterNewData: "Enter new Data",
      contactNo: "Contact No.",
      personnelActiveOffices: "Personnel's Active Offices",
      address: "Address",
      officeName: "Office Name",
      yes: "Yes",
      no: "No",
      viewAccountOwner: "View Account Owner",
      accountOwnerDetail: "Account Owner's Detail",
      noActiveOffices: "No Active Offices",
      viewPersonnelOfficeListOf: "View Personnel Office List of",
      viewSubscriptionDetails: "View Subscription Details",
      viewTransactionHistory: "View Transaction History",
      viewStaffMembers: "View Staff Members",
      accountOwnersTransactionHistory: "Account Owner's Transaction History",
      noTransactionsYet: "No Transactions Yet!",
      dateAndTime: "Date & Time",
      refund: "Refund",
      partialRefund: "Partial Refund",
      refundAmountIs: "Refund amount is",
      amount: "Amount",
      staffName: "Staff Name",
      accountOwnersSubscriptionDetails: "Account Owner's Subscription Details",
      noActiveSubscription: "No Active Subscription",
      previousInvoices: "Previous Invoices",
      subscriptionName: "Subscription Name",
      totalSubscriptionPrice: "Total Subscription Price",
      startDate: "Start Date",
      endDate: "End Date",
      expireDate: "Expire Date",
      noInvoicesYet: "No invoices available for selection",
      invoiceDetails: "Invoice Details",
      totalOffices: "Total Offices",
      office: "Office",
      office_plural: "Offices",
      totalCost: "Total Cost",
      totalActivePermanentStaffMember: "Total Active Permanent Staff Member",
      permanentStaff: "Permanent Staff",
      permanentStaff_plural: "Permanent Staffs",
      temporaryStaff: "Temporary Staff",
      temporaryStaff_plural: "Temporary Staffs",
      totalActiveTemporaryStaffMember: "Total Active Temporary Staff Member",
      costPerPlacement: "Cost Per Placement",
      totalNumberOfPlacements: "Total Number of Placements",
      appVersion: "App Version",
      appVersions: "App Versions",
      deviceType: "Device Type",
      appType: "App Type",
      isMandatory: "Is Mandatory",
      createdAt: "Created At",
      addAppVersion: "Add App Version",
      editAppVersion: "Edit App Version",
      noAppVersionFound: "No App Version found.",
      specialties: "Specialties",
      manageSpecialtiesOrServices: "Manage Specialties / Services",
      addNewSpecialtyOrService: "Add New Specialty / Service",
      specialtiesOrServices: "Specialties/Services",
      specialtyOrService: "Specialty / Service",
      noSpecialtyOrServiceFound: "No Specialty / Service found.",
      editSpecialtyOrService: "Edit Specialty / Service",
      addSpecialtiesOrServices: "Add Specialties / Services",
      editSpecialtiesOrServices: "Edit Specialties / Services",
      statusUpdated: "Status updated.",
      specialtyActivationText:
        'Are you sure you want to activate "{{specialtyTitle}}"?',
      specialtyDeactivationText:
        'If you deactivate "{{specialtyTitle}}", it won\'t be visible to the user for selection in Profile.',
      specialtyDeactivationSubtext: "Are you sure you want to deactivate?",
      specialtyAddedMessage: "Specialty/Service added successfully.",
      specialtyUpdatedMessage: "Specialty/Service updated successfully.",
      reviewsAndRatings: "Reviews and Ratings",
      manageReviewsAndRatings: "Reviews and Ratings",
      patientsName: "Patient's Name",
      doctorsName: "Doctor's Name",
      accountOwner: "Account Owner",
      viewReviewAndRating: "View Review and Rating",
      noReviewsAddedYet: "No Reviews added yet.",
      noDoctorFound: "No Doctor Found.",
      recentlyAdded: "Recently Added",
      patients: "Patients",
      doctors: "Doctors",
      cadPrice: "Price in CAD",
      usdPrice: "Price in USD",
      reviewActivationConfirmationText:
        "An active review will be visible to the patients in the doctor's profile. Are you sure you want to activate the review?",
      reviewDeactivationConfirmationText:
        "A deactivated review will not be visible to the patients in the doctor's profile. Are you sure you want to deactivate the review?",
      reviewActivatedSuccessfully: "Review activated successfully.",
      reviewDeactivatedSuccessfully: "Review deactivated successfully.",
      activateThisComment: "Activate This Comment",
      deactivateThisComment: "Deactivate This Comment",
      reviewsAndRatings2: "Reviews & Ratings",
      allReviewsAndRatings: "All Reviews & Ratings",
      searchByPatientName: "Search by Patient Name",
      searchByDoctorName: "Search by Doctor Name",
      patientsReviewsAndRatings: "Patient's Reviews and Ratings",
      doctorsReviewsAndRatings: "Doctor's Reviews and Ratings",
      patientName: "Patient Name",
      doctorName: "Doctor Name",
      noReviewFound: "No Review Found.",
      managePatients: "Manage Patients",
      searchPatient: "Search Patient",
      noPatientFound: "No Patient Found.",
      broadcastMessages: "Broadcast Messages",
      newBroadcastMessages: "New Broadcast Message",
      sendBroadcastMessages: "Send Broadcast Message",
      sendNotification: "Send Notification",
      sendEmail: "Send Email",
      messageName: "Message Name",
      viewDetails: "View Details",
      descriptionBroadcast: "Description",
      selectUsers: "Select Users",
      selectedUsers: "Selected Users",
      searchByName: "Search by Name",
      allOffices: "All Offices",
      users: "Users",
      viewUsers: "View Users",
      AccountOwnerName: "Account Owner’s Name",
      sendToAccountOwners: "Send to Account Owners",
      sendToAllAccountOwners: "Send to All Account Owners",
      SendToStaff: "Send to Staff",
      SendToAllStaff: "Send to All Staff",
      userSelected: "user selected",
      multipleUsersSelected: "Multiple Users Selected",
      messageCreatedSuccessfully: "Broadcast message created successfully!",
      broadcastMessageDetails: "Broadcast Message Details",
      sentToOwnerAndStaff: "Sent to Account Owner & Staff",
      sentToOwner: "Sent to Account Owner",
      message: "Message",
      savedOn: "Saved On",
      sentOn: "Sent On",
      notification: "Notification",
      details: "Details,",
      comment: "Comment",
      appointmentRequest: "Appointment Request",
      markAsCompleted: "Mark as Completed",
      requestedOn: "Requested On ",
      patientID: "Patient ID",
      providerDoctorName: "Provider / Doctor’s Name",
      markComplete: "Mark as Complete",
      view: "View",
      appointmentRequests: "Appointment Requests",
      deleteAppointmentRequestTitle: "Delete Request",
      deleteAppointmentRequestSubtitle:
        "Are you sure you want to delete the request?",
      completeAppointmentRequestTitle: "Mark Request as Complete",
      completeAppointmentRequestSubtitle1:
        "Once marked Completed, the request status cannot be changed.",
      completeAppointmentRequestSubtitle2:
        "Are you sure you want to mark the request as Complete?",
      contentType: "Content Type",
      appointmentRequestDetail: {
        appointmentDate: "Preferred Appointment Date",
        title: "Appointment Request Details",
        time: "Time",
        markCompleted: "Mark as Completed",
      },
      appointmentRequestList: {
        status: {
          All: "All",
          Pending: "Pending",
          Completed: "Completed",
        },
      },
      DateAndTime: "Date & Time",
      Category: "Category",
      User: "User",
      NameOfTheUser: "Name of the User",
      noFeedbackSuggestionFound: "No Feedback & Suggestion Found",
      markAsResolved: "Mark as Resolved",
      markAsInProgress: "Mark as In-Progress",
      noTicketFound: "No Ticket Available for Your Selection",
      confirmStatusChangeToResolved:
        "Are you sure you want to change the status of the ticket to Resolved",
      confirmStatusChangeToInProgress:
        "Are you sure you want to change the status of the ticket to In-Progress",
      reviewDeactivateTitle: "Deactivate Review",
      reviewActivateTitle: "Activate Review",
      updateSubscription: "Update Subscription",
      updateSubscriptionDesc:
        "The account owner's next month billing will be as per the new subscription prices. Are you sure you want to update the subscription price?",
      officeUnitPriceError: "Please enter office charges",
      setUpFeeCharges: "Please enter Setup Fee charges",
      temporaryStaffUnitPriceError: "Please enter temporary staff charges",
      permanentStaffUnitPriceError: "Please enter permanent staff charges",
      placementUnitPriceError: "Please enter placement charges",
      noDataAvaliable: "No Data Available",
      vendor: {
        Activate: "Activate",
        ActivateDesc:
          "Once activated, the category can be assigned to the products by the vendors. Are you sure you want to activate the category?",
        Deactivate: "Deactivate",
        DeactivateDesc:
          "The deactivated category will keep on showing if already assigned to the product but cannot be assigned to a new product. Are you sure you want to deactivate the category?",
        ActivateVendorContent: "Are you sure you want to activate the vendor?",
        DecActivateVendorContent:
          "The deactivated vendor cannot receive the orders and cannot login into the vendor portal. Are you sure you want to deactivate the vendor?",
        salesDecActivate:
          "The deactivated sales representative cannot log in to the app and cannot place the orders. Are you sure you want to deactivate the sales representative?",
        salesActivate:
          "Are you sure you want to activate the sales representative?",
      },
      basicSubscription: "Basic Subscription",
      advanceSubscription: "Advance Subscription",
      advancedSubscription: "Advanced Subscription",
      professionalSubscription: "Professional Subscription",
      goToManageFeatures: "Go to Manage Features",
      subscriptionManagementForAccountOwners:
        "Subscription Management for Account Owners",
      singleOffice: "Single Office",
      setUpFree: "Setup Fee",
      perEachPlacement: "Per Each Placement",
      multipleOfficePlan: "Multiple Office Plan",
      timesheet: "Timesheet",
      leaves: "Leaves",
      taskManagement: "Task Management",
      onlineBooking: "Online Booking",
      performanceReview: "Performance Review",
      reportsAndDashboard: "Reports and Dashboard",
      analytics: "Analytics",
      messaging: "Messaging",
      schedular: "Schedular",
      basic: "Basic",
      advanced: "Advanced",
      professional: "Professional",
      manageFeatures: "Manage Features",
      endDateOfTrialAccount: "End Date of Trial Account",
      update: "Update",
      setUpFees: "Setup Fees",
      default: "Default",
      linkedWithFeature: "Linked with Feature",
      textual: "Textual",
      defaultTooltip:
        "Default features will be by default available to account owners. The super admin cannot unselect these features",
      linkedWithFeatureToolTip:
        "These features are linked with a module in the Miraxis application. Turning them off would mean that this feature will not be available in the app for the users.",
      textualTooltip:
        "Textual/Display Purpose Only features are not linked with any of Miraxis module. Turning them on and off will reflect the changes only on the landing pages",
      featureAlert:
        "Staff Scheduler & Shifts Management and Patient Appointments / Recalls etc. are linked. If one is selected, other one will be selected automatically.",
      note: "Note: ",
      invoices: "Invoices",
      previousInvoice: {
        forecatedInvoice: "FORECASTED INVOICE",
        previousInvoice: "PREVIOUS INVOICE",
      },
      invoiceModalWarningMsg: "The invoices do not include tax.",
      multipleSubscription: "Multiple Subscriptions",
      forcastedInvoiceDownloadMsg: "Forcasted Invoice download successfully",
      previousInvoiceDownloadMsg: "Previous Invoice download successfully",
      email: "Email Address",
    },

    patient: {
      findYourDoctor: "Find Your Doctor",
      searchByDoctorName: "Search by Doctor Name",
      findDoctorsTitle: "Find Doctors",
      selectLocations: "Select Your Location",
      doctorProfileTitle: "Doctor Profile",
      dentistry: "Dentistry",
      paleontology: "Paleontology",
      dermatologist: "Dermatologist",
      dermatology: "Dermatology",
      cardiologist: "Cardiologist",
      pediatrics: "Pediatrics",
      surgeon: "Surgeon",
      neurology: "Neurology",
      contactDetails: "Contact Details",
      ratingsReviewsTitle: "Ratings & Reviews",
      averageRating: "Average Rating",
      seeAllRatings: "See All Ratings",
      bookAppointment: "Book an Appointment",
      requestBookAppointment: "Request to be Added to a Waiting List",
      bookAppointmentBtn: "Request Booking Appointment",
      showingSlots: "Showing Timeslots for",
      slotsAvailable: "{{ count }} Timeslot Available",
      slotsAvailable_plural: "{{ count }} Timeslots Available",
      changeDate: "Change Date",
      timezone: "Timezone",
      selectSlots:
        "Select Timeslots to book an appointment. You can choose consecutive timeslots if available.",
      descriptionTherapyNeeded: "Description/ Therapy Needed",
      couldNotFindTheDesiredTimeslots: "Could not find the desired Timeslots?",
      requestAppointment: "Request Appointment",
      appointmentBooked: "Request for Appointment Sent",
      appointmentBookedDesc:
        "Please download the application in order to see your appointment details ",
      officesPageTitle: "Offices of {{ doctorName }}",
      officeSpecialtiesOrServices: "Office Specialties / Services:",
      specialtiesServices: "Specialties / Services",
      phoneNo: "Phone No.",
      searchLocationUpdated: "Search location updated successfully.",
      viewOffice: "View {{ count }} Office",
      viewOffice_plural: "View {{ count }} Offices",
      lookingForMore: "Narrow down the search result?",
      searchBySpecialties: "Search by Specialties",
      findDoctorSpecialty: "Find a Doctor by Specialty",
      searchBySpecialty: "search by specialty",
      selectSpecialty: "Select a specialty",
      showingResultsFor: "Showing results for: {{ specialty }}",
      resetSearch: "Reset Search",
      officeSpecialties: "{{ officeName }} Specialties",
      otherRoleWarningMessage:
        "Your email is registered with Miraxis with a role other than patient. Please create a patient account with a different email id to make a booking.",
      noAvailableDateMessage:
        "The doctor does not have any available timeslot in the selected office for booking.",
      slotNotAvailable: "Timeslot not available",
      consectiveSlotsError: "You can only select consecutive timeslots.",
      consectiveSlotsError2:
        "Timeslot cannot be selected as the timeslots in continuation are not available for booking.",
      durationError: "You can select timeslots upto 1 hour of duration.",
      noReviewsYet: "No Reviews Yet.",
      sameTimeForAllDates: "Same time for all dates",
      differentTimeForWeekdays: "Different time for weekdays",
      cities: "Cities",
      town: "Town",
      requestAnAppointment: "Request an Appointment",
      provider: "Provider",
      appointmentInformation: "Appointment Information",
      selectYourPreferredAppointmentDate:
        "Select your preferred appointment date",
      morning: "Morning",
      afternoon: "Afternoon",
      evening: "Evening",
      anytime: "Anytime",
      selectTimeOptional: "Select Time",
      ReasonForYourVisit: `Reason(s) for your visit. Please don't include sensitive personal information`,
      yourContactInformation: "Your Contact Information",
      useMyLocation: "Use my location",
      topLocalitiesCanada: "Top Localities in Canada",
      viewDoctorsMap: "View Doctors on Map",
      viewDoctorsList: "View Doctors List",
      familyMembers: "Family Members",
      addedMembers: "Added Members",
      membersAddedYou: "Members Added You",
      addNewMember: "Add New Member",
      bookingForWhom: "For whom do you want to book the appointment?",
      waitingListModal: {
        confirmModalSubTitle: "Are you sure you want to submit this request?",
      },
      requestAppointmentModal: {
        title: "Submit Appointment Request",
        subTitle1:
          "The request for appointment will be sent to the email id of the selected doctor.",
        subTitle2: "Are you sure you want to submit the request?",
      },
      searchByLocation: "Search by Location",
      noPhoneError: "No contact available for call",
      requestAppointmentTerms:
        "This request form does not confirm an appointment since the schedule information for this health provider is not available at this moment. We will try to reach this provider and share your appointment information with them. For your protection, do not include sensitive personal financial or medical information in the free-text comments box. Please contact them directly if you do not receive a response to your appointment request.",
      acceptTerms:
        "Accepting terms & conditions is mandatory to submit an appointment request.",
      googleError:
        "Google doctors api responded with following status: {{ status }}",
      requestSuccessMessage: "Request sent successfully.",
      Requestascompleted: "Request(s) marked as completed.",
      fillQuestionnaireDesc:
        "To select the timeslots for booking an appointment, please click below to fill in the questionnaire.",
      fillInTheQuestionnaire: "Fill in the Questionnaire",
      viewEditQuestionnaire:
        "Based on your answers to the questionnaire, the time needed for the required treatment is {{time}} mins",
      viewEdit: "View / Edit",
      QuestionnaireForBookingAnAppointment:
        "Questionnaire for Booking an Appointment",
      questionnaireFillError: "Please, fill the questionnaire first.",
      termsAndConditionsBeforeText:
        "I consent to share my information with the provider for appointment booking purposes, and accept the",
      termsAndConditions: "Terms & Conditions",
      listYourPractice: "List Your Practice",
      listYourPracticeModalDesc:
        "In order to list your practice in the search result, to connect you with new patients and to activate online booking for you, you will need to sign up to the Miraxis platform. Please enter the information below to get started.",
      yesTakeMeToSignUpPage: "Yes, take me to sign up page",
      stillNeedMoreInformationAndDemo: "Still need more information and demo",
    },

    contracts: {
      enterPlaceholder: "Enter",
      templateName: "Template Name",
      noSignUploaded: "No Signature Uploaded",
      savedInputMaxLimit:
        "the template name should be a less than 100 characters.",
      viewContract: "View Contract",
      Commission: "Commission",
      Bonus: "Bonus",
      savedTemplate: "Saved Template",
      selectATemplate: "Select a Template",
      noTemplateAvailable: "No template available for your selection",
      noTemplateSelected: "No template selected",
      yourContract: "Your Contract",
      contractDate: "Contract Date",
      date: "Date",
      draft: "Draft",
      pending: "Pending",
      addedBy: "Added By",
      staticContract: "Static Contract Attached",
      sent: "Sent",
      accepted: "Accepted",
      addContract: "Add New Contract",
      selectDesignation: "Select Designation",
      newContract: "New Contract",
      attachContract: "Attach Contract",
      contractTemplate: "Use Template Contract",
      urbanDental: "Urban Dental",
      newEmploymentContract: "New Employment Contract",
      templateYouWantToUse: "Which template do you want to use?",
      defaultTemplate: "Default Template ",
      recentlySavedTemplate: "Recently Saved Template",
      basicInfo: "Basic Information",
      dateContract: "Date of Contract",
      businessLegalName: "Business Legal Name",
      position: "Position",
      lengthEmployment: "Length of Employment",
      startWork: "Start of Work",
      endWork: "End of Work",
      employeeName: "Employee Name",
      employeeAddress: "Employee Address",
      salaryFeeWage: "Salary / Fee / Wage",
      salutation: "Salutation",
      subject: "Subject",
      heading: "Heading",
      startDate: "1. Start Date",
      position2: "2. Position",
      wageHoursWork: "3. Wage and Hours of Work",
      reportingRelationship: "4. Reporting Relationship",
      overtime: "5. Overtime",
      probationalPeriod: "6. Probational Period",
      benefits: "7. Benefits",
      vacation: "8. Vacation",
      lengthCompletedServices: "Length of Completed Services",
      vacationEntitlement: "Vacation Entitlement",
      vacationPayWages: "Vacation Pay % Wages",
      confidentialInformation: "9. Confidential Information",
      policies: "10. Policies",
      noRecentTemplate: "Sorry, you don't have any saved template",
      termination: "12. Termination",
      canNotAddMoreFields: "You can add a maximum of 3 additional fields",
      yourTruly: "Your's truly,",
      general: "General",
      acceptOffer: "Accept Offer",
      ownerAndTheAssociateAgree:
        "The Owner and the Associate Agree as Follows:",
      theOwnerAgree: "The Owner Agrees:",
      theAssociateAgree: "The Associate Agrees:",
      theAssociateAgreeContd: "The Associates Agrees Contd:",
      addMoreDetails: "Add More Details",
      accountOwnerName: "[Account Owner Name Inc.]",
      authorisedSignature: "Authorised Signature",
      pleaseUploadImageSignature: "Please upload an image of your signature",
      nextStep: "Next Step",
      previousStep: "Previous Step",
      reviewEmploymentContract: "Review Employment Contract",
      sendContractForm: "Send Employment Contract",
      deleteContract: "Delete Contract",
      deleteSection: "Delete New Section",
      confirmDeleteSection: "Are you sure you want to delete?",
      deleteSectionDesc:
        "If you delete the section, it will not be added to the contract form.",
      confirmDeleteContract:
        "Are you sure you want to delete the drafted contract?",
      staffMemberContract:
        "The Staff Member will be notified if you send the contract.",
      confirmSendContract: "Are you sure you want to send the contract?",
      acceptContractTerms:
        "Accepting the offer would mean that you agree to the terms mentioned in the contract.",
      confirmAcceptOffer: "Are you sure you want to Accept the Offer?",
      cancelContractForm: "Cancel Contract Form?",
      cancelContractFormDesc:
        "You have changed some contents on this form. Do you want to save these changes as Draft?",
      saveDraft: "Save as Draft",
      exitWithoutSaving: "Exit Without Saving",
      addNewDetailsInThisSection: "Add New Details In This Section",
      noSectionSelected: "No Section Selected",
      section1Heading: "Section 1 - Heading",
      section1Body: "Section 1 - Body",
      selectSection: "Select Section",
      section: "Section",
      termsOfUseForContractTemplate: "Use Template Contract",
      termsOfUseForContractTemplateDesc:
        "Miraxis Technology Solutions Inc. assumes no responsibility or liability for any errors or omission in the content of this contract template. Accessing or using this contract template does not create a lawyer-client relationship. The content on this template is general with no guarantees of completeness & accuracy, and provided for the user to make appropriate changes specific to the user's employment terms, and the content does not constitute legal or other professional advice or an opinion of any kind. Users are advised to seek specific legal advice regarding any specific legal contract.",
      termsOfUseForSignContractDesc:
        "This contract has been created / customized by your employer based on your employment terms. Miraxis Technology Solutions Inc. assumes no responsibility or liability for any errors or omission in the content of this contract. Accessing or using this contract does not create a lawyer-client relationship. The content on this contract does not constitute legal or other professional advice or an opinion of any kind. Users are advised to seek specific legal advice regarding any specific legal contract.",
      useTemplate: "Use Template",
      IAgreeTermsUseContractTemplate:
        "I agree to Terms of Use for this Contract Template",
      IAgreeTermsSignContract:
        "Select here to indicate that you agree to the above-mentioned Terms of Use for this Contract",
      agreeStaffTermsAndConditions:
        "I accept the offer of employment described in this letter:",
      exportEmploymentContract: "Export Employment Contract",
      exportContract: "Export Contract",
      exportContractDesc:
        "If you export the contract. It will be saved as Draft and will be added in the list of contracts. Are you sure you want to export the contract and save it as Draft.",
      saveTemplate: "Save This Contract as a Template?",
      saveTemplateDesc:
        "Would you like to save your changes as a reusable template for future contracts?",
      saveTemplateSubDesc: "A name is required to save your template.",
      sendEmploymentContract: "Send Employment Contract",
      signEmploymentContract: "Sign Employment Contract",
      signContract: "Sign Contract",
      formsAndContract: "Forms & Contracts",
      contracts: "Contracts",
      searchByStaffName: "Search By Staff Name",
      summary: "Summary",
      contractUploadedSuccessfully: "Contract uploaded successfully",
      templateSavedSuccessfully: "Contract template saved successfully",
      staffMembers: "Staff Members",
      timesheet: "Timesheet",
      leaves: "Leaves",
      noContractsFound: "No contracts available for your selection",
    },

    message: {
      addedSuccessfully: "{{field}} added successfully.",
      updatedSuccessfully: "{{field}} updated successfully.",
      deletedSuccessfully: "{{field}} updated successfully.",
      atleastonedate: "Select at least one date.",
    },
    scheduler: {
      staffMembersFirstName: "First Name",
      staffMembersFullName: "Full Name",
      createdBy: "Created By",
      viewSchedulingAssistant: "View Scheduling Assistant",
      deletingOtherShift: "You are deleting a shift created by ",
      eventsEmptyMessage: "No events match your filter criteria.",
      excludeHolidays: "Exclude Holidays",
      excludeLeaves: "Exclude Leaves",
      excluded: "Excluded",
      onLeave: "On Leave",
      onHoliday: "On Holiday",
      warningMessageForAvailability: "There can be some conflicting events.",
      errorMessageForAvailability: "The schedule have conflicting events.",
      dashboardErrorMessageForAvailability:
        "This event conflicts with existing schedules. Check Staff Schedule for details.",
      successMessageForAvailability: "No scheduing conflicts detected.",
      eventHistoryModalHeading: "Log Detail",
      eventHistoryModalEmptyMessage:
        "The invitees have been updated, and the changes can be viewed in the log list.",
      eventHistoryModalTitleHeading: "Event Title updated to",
      eventHistoryModalNewMemberHeading: "New Members are added",
      eventHistoryModalRemovedMemberHeading: "Members are removed",
      busySlotHistoryModalNewMemberHeading: "New offices are added",
      busySlotHistoryModalRemovedMemberHeading: "Offices are removed",
      eventHistoryModalStartDateHeading: "Start Date updated to",
      eventHistoryModalRepeatTypeHeading: "Repeat Type updated to",
      eventHistoryModalRepeatTypeMessageHeading:
        "Custom Repeat Type updated to",
      eventHistoryModalEndDateHeading: "End Date updated to",
      eventHistoryModalStartEndTimeHeading: "Start and End Time updated to",
      eventHistoryModalLocationHeading: "Location updated to",
      eventHistoryModalRolesHeading: "Roles updated to",
      eventHistoryModalBlockHeading:
        "Block for online patient scheduling updated to",
      eventHistoryModalNotesHeading: "Notes updated to",
      eventHistoryModalTagsHeading: "Tags updated to",
      eventHistoryModalNotifyHeading: "Notify updated to",
      editModal1Option: "Edit this {{eventOrShift}} only",
      editModal2Option:
        "Edit this {{eventOrShift}} and all future {{eventOrShifts}}",
      editModal3Option: "Edit all the {{eventOrShifts}}",
      editEventModalHeading: "Edit {{eventOrShift}}",
      editEventModalDescription:
        "This is a recurring {{eventOrShift}}. Do you want to:",
      closeShiftNewReason: "Close Shift to New Requests",
      closeSuccess: "Shift closed successfully.",
      closeShiftModalDescription:
        "Are you sure you want to close this shift? Once the shift is closed, no further join requests will be accepted.",
      closeShift: "Close Shift",
      shiftDetailCloseText: "The shift is closed.",
      shiftClosedText:
        "You can't request to join this shift because it has been closed by the owner.",
      acceptEventRequest: "Accept {{eventOrShift}} Request",
      aboutModalHeading: "About Scheduler",
      aboutModalIntro:
        "The Scheduler is your central hub for managing all events, shifts, and staff availability across multiple offices.",
      officeSchedule: "Office Schedule",
      staffSchedule: "Staff Schedule",
      staffScheduleText:
        "View availability and shifts of all staff across offices.",
      eventWorkspace: "Event Workspace",
      eventWorkspaceText:
        "Create, edit, and manage events. You can keep them private, share with invitees, or publish for everyone.",
      mySchedule: "My Schedule",
      myEvents: "My Events",
      myEventsText: "View your own events and set your availability.",
      invitationRequests: "Invitation Requests",
      invitationRequestsText: "See and respond to event invites sent to you.",
      otherOfficeEvents: "Other Office Events/Shifts",
      editRepeatEventChangeWarning:
        "You're changing the recurrence pattern. This will affect the series. You will be asked to confirm before saving.",
      otherOfficeEventsText:
        "Browse events you’re not invited to but can request to join.",
      aboutModalBottomText:
        "Each tab includes filters to help you focus—filter by office, staff, event type, or hide extra details to reduce clutter.",
      filterEvents: "Filter Events",
      filterEventsDescription:
        "Each tab includes filters to help you focus. Filter the events by:",
      filterEventsFirstBullet: "Office: ",
      filterEventsFirstBulletDescription:
        "View events for a specific office location.",
      filterEventsSecondBullet: "Staff Members: ",
      filterEventsSecondBulletDescription:
        "See events assigned to selected staff.",
      filterEventsThirdBullet: "Event Type: ",
      filterEventsThirdBulletDescription:
        "Filter by type (e.g., shift, events, patient appointments, busy slots and leaves).",
      filterEventsFourthBullet: "Company-Wide: ",
      filterEventsFourthBulletDescription:
        "Shows events created at the organization level for staff working across multiple offices. These are not tied to a specific office.",
      schedulingAssistantTooltipHeading: "How it works:",
      schedulingAssistantTooltipSubHeading:
        "Use this screen to check availability of selected staff members.",
      schedulingAssistantTooltipFirstLi:
        "The Date & Time fields show your current selection. If you entered a date/time in the previous tab, it appears here.",
      schedulingAssistantTooltipSecondLi:
        "To update it, click a timeslot in the scheduler below — the fields will update automatically.",
      schedulingAssistantTooltipThirdLi: `Or click "Find Availability" to highlight the earliest free timeslot for all selected staff. Then click your preferred time to select it.`,
      schedulingAssistantTooltipBottom: `This selection will be used when you return to create your event or shift.`,
      selectOfficeModalDescription:
        "To publish the {{eventOrShift}} for non-invitees to join and save the {{eventOrShift}} as draft, please select an office.",
      saveEventShift: "Save {{eventOrShift}}",
      schedulerAssistantModalText1:
        "To view the schedules of staff members, please switch to the Scheduling Assistant tab.",
      schedulingAssistant: "Scheduling Assistant",
      schedulerAssistantModalText2:
        "You can check staff availability, identify conflicting schedules, and manage bookings efficiently. This feature helps streamline coordination and optimize team scheduling.",
      schedulerAssistantModalText3:
        "You can create {{eventOrShift}} by either selecting staff, Role only or both. Then you can use scheduling Assistant to see invitees schedules; or you can use Find Availability function to find the next available time slot for the invitees. When you find the right date & time, you can click on Continue Event/Shift Creation to come back to the {{eventOrShift}} screen to complete the event/shift creation.",
      schedulerAssistantModalText4:
        'If you select "Let other staff request to join" staff members assigned to the selected office and role will be able to request to join the {{eventOrShift}}.',
      schedulerAssistantModalText5:
        'If you select "Save as draft (do not publish yet)", the {{eventOrShift}} will be saved for your reference but will not be visible to any staff members on the calendar. You can publish it at a later time if desired.',
      schedulerAssistantModalText6:
        "When enabled, staff from the selected offices can join this {{eventOrShift}} automatically without waiting for your approval.",
      schedulerAssistantModalText7:
        "Choose the staff members whose schedule you want to view. These selected staff members will automatically be added as invitees to the event. If you don’t want them as invitees, you can remove them before publishing the {{eventOrShift}}.",
      schedulerAssistantModalText8:
        "Click the to check when the selected staff members are available without any conflicts. The system will show the next available time slot.",
      schedulerAssistantModalText9: "Use ”Next” to view later time slots",
      schedulerAssistantModalText10: "Use ”Previous” to go back",
      schedulerAssistantModalText11:
        "Use ”Reset” to return to your original selection",
      schedulerAssistantModalText12:
        "Click on a time slot to select it for your {{eventOrShift}}.",
      schedulerAssistantModalText13:
        "This section shows the date and time you’ve selected. If you already chose a time in the previous step, it will appear here.",
      schedulerAssistantModalText14:
        "To change it, simply click on a time slot in the scheduler—the fields will update automatically.",
      staffMemberTooltip1:
        "You can invite specific staff member to the {{eventOrShift}}. This is optional.",
      staffMemberTooltip2:
        "If no staff members are selected but a role is chosen, the {{eventOrShift}} is open for employees with that role to join.",
      rolesTooltip1: `If a role is selected, only staff with that role can request to join the {{eventOrShift}}. Example: For a "Assistant Training" shift, if the role "Assistant" is selected, only assistants can request to join.`,
      rolesTooltip2:
        "If no staff member or roles are selected, the {{eventOrShift}} is open for all employees to request to join.",
      WithdrawRequest: " Withdraw Request?",
      WithdrawRequestContent: "Are you sure you want to withdraw the Request?",
      DeclineRequest: "Remove Request?",
      DeclineRequestContent:
        "Removing this request will mean you can no longer join or reapply for this {{eventOrShift}}.",
      DeclineRequestConfirm:
        "Are you sure you want to remove it from the list?",
      acceptEventNotBookedDesc:
        "Accepting the {{eventOrShift}} would mean that you will be part of the invited {{eventOrShift}} and the date and time of the {{eventOrShift}} will show as blocked in your calendar.",
      acceptEventBookedDesc:
        "The selected date and time is already blocked in your calendar.",
      shiftModuleRequestHeading: "Request to join shift for all future date",
      shiftModuleRequestSubHeading:
        "Accepting this shift will add it to your Scheduler / Calendar, blocking the date and time. Are you sure you want to proceed?",
      shiftModuleRequestToJoinHeading:
        "Request to join shift for all future date",
      shiftModuleRequestToJoinRadio1:
        "Request to join shift for all future dates",
      shiftModuleRequestToJoinRadio2:
        "Request to join shift for specific dates",
      requestToJoin: "Request to join",
      confirmAcceptEvent:
        "Are you sure you want to accept the {{eventOrShift}}?",
      cancelEvent: "Cancel Event",
      repeatForAll: "Repeat for all",
      shift: "shift",
      repeatForAllFuture: "Repeat for all Future Dates - Everyday",
      never: "Never",
      reqAcceptSuccessfully: "{{eventOrShift}} Request accepted successfully.",
      reqRejectSuccessfully: "{{eventOrShift}} Request rejected successfully.",
      reqCancelledSuccessfully:
        "{{eventOrShift}} Request cancelled successfully.",
      reqToJoin: "Requests to Join",
      publishedEvent: "Published",
      publishEvent: "Publish Event",
      isDraft: "Draft",
      unassigned: "UNASSIGNED",
      unassignedCount: "{{count}} unassigned",
      unassignedShiftsCount: "{{count}} unassigned shifts/events",
      shiftDragStaffDifferentOffice:
        "The selected staff member is not associated with the assigned office.",
      selectOfficeForEvent: "Select Office for the Event",
      selectOfficeEventModalDescription:
        "Select the office for this event assignment. If the selected office differs from the event's current office, the event will become company-wide.",
      publish: "Publish",
      publishEventShiftTitle: "Publish Shifts and Events",
      publishEventShiftIntroMonth:
        "You are about to publish draft shifts and events for the selected month.",
      publishEventShiftIntroWeek:
        "You are about to publish draft shifts and events for the selected week.",
      publishEventShiftIntroDay:
        "You are about to publish draft shifts and events for the selected day.",
      publishEventShiftPeriodMonth: "Month Name",
      publishEventShiftPeriodWeek: "Week",
      publishEventShiftPeriodDate: "Date",
      publishEventShiftShiftsToPublish: "Shifts to Publish",
      publishEventShiftEventsToPublish: "Events to Publish",
      publishEventShiftDescription:
        "Once published, the selected draft shifts and events will move to Published status, will become visible to the assigned staff members and invitees, and notifications and related communications will be triggered for the published records.",
      publishEventShiftConfirmQuestion: "Are you sure you want to publish?",
      publishItemTypeMixed: "shifts and events",
      publishBulkSuccess: "Events and shifts published successfully.",
      eventFound: " events found.",
      viewOptions: "View Options",
      viewByStaffName: "View by Staff Name",
      viewWeekly: "Weekly",
      bulkSelect: "Bulk Select",
      sortBy: "Sort by",
      sortByDefault: "Default",
      sortByStaffNameAsc: "Staff Name (A-Z)",
      sortByStaffNameDesc: "Staff Name (Z-A)",
      sortByEmploymentDateLatest: "Employment Date (Latest)",
      sortByEmploymentDateOldest: "Employment Date (Oldest)",
      sortByStartTime: "Start Time",
      unavailable: "Unavailable",
      unpublish: "Unpublish",
      copyPreviousDay: "Copy Previous Day",
      clearDay: "Clear Day",
      saveDayAsTemplate: "Save Day as Template",
      copyPreviousWeek: "Copy Previous Week",
      clearWeek: "Clear Week",
      saveWeekAsTemplate: "Save Week as Template",
      copyPreviousMonthly: "Copy Previous Month",
      clearMonthly: "Clear Month",
      saveMonthlyAsTemplate: "Save Month as Template",
      addFromSavedTemplate: "Add from Saved Template",
      applyTemplateIntroDay: "You are using template for {{period}}.",
      applyTemplateIntroWeek: "You are using template for {{period}}.",
      applyTemplateIntroMonth: "You are using template for {{period}}.",
      searchTemplateByName: "Search by name",
      useTemplate: "Use Template",
      noTemplatesAvailableForSelection: "No templates available for selection",
      applyTemplateSuccess: "Template applied successfully.",
      applyTemplateSelectRequired: "Please select a template to continue.",
      saveTemplate: "Save Template",
      templateName: "Template Name",
      templateNamePlaceholder: "Add Template Name",
      templateNameMaxLength:
        "The template name should be less than 100 characters.",
      saveTemplateIntroDay:
        "You are saving the shifts and events for {{period}} as a template. This action respects the applied filters, so only the shifts and events displayed in the view will be saved to the template.",
      saveTemplateIntroWeek:
        "You are saving the shifts and events for {{period}} as a template. This action respects the applied filters, so only the shifts and events displayed in the view will be saved to the template.",
      saveTemplateIntroMonth:
        "You are saving the shifts and events for {{period}} as a template. This action respects the applied filters, so only the shifts and events displayed in the view will be saved to the template.",
      saveTemplateSuccess: "Template saved successfully.",
      saveTemplateEmpty:
        "No shifts or events are visible in the current period to save as a template.",
      copyPreviousIntroDay:
        "You are about to copy shifts and events from the previous day to the currently selected day. This action respects the applied filters, so only the shifts and events displayed in the view will be copied.",
      copyPreviousIntroWeek:
        "You are about to copy shifts and events from the previous week to the currently selected week. This action respects the applied filters, so only the shifts and events displayed in the view will be copied.",
      copyPreviousIntroMonth:
        "You are about to copy shifts and events from the previous month to the currently selected month. This action respects the applied filters, so only the shifts and events displayed in the view will be copied.",
      copyPreviousShiftsToCopy: "Shifts to Copy",
      copyPreviousEventsToCopy: "Events to Copy",
      copyPreviousDescriptionDay:
        "The copied shifts and events will be created in Draft status. Existing shifts and events in the current day will remain unchanged.",
      copyPreviousDescriptionWeek:
        "The copied shifts and events will be created in Draft status. Existing shifts and events in the current week will remain unchanged.",
      copyPreviousDescriptionMonth:
        "The copied shifts and events will be created in Draft status. Existing shifts and events in the current month will remain unchanged.",
      copyPreviousConfirmQuestionDay:
        "Are you sure you want to copy the previous day?",
      copyPreviousConfirmQuestionWeek:
        "Are you sure you want to copy the previous week?",
      copyPreviousConfirmQuestionMonth:
        "Are you sure you want to copy the previous month?",
      copyPreviousConfirm: "Copy",
      copyPreviousSuccess: "Shifts and events copied successfully.",
      copyPreviousEmpty:
        "No shifts or events found in the previous period to copy.",
      clearPeriodIntroDay:
        "You are about to remove shifts and events for the selected day.",
      clearPeriodIntroWeek:
        "You are about to remove shifts and events for the selected week.",
      clearPeriodIntroMonth:
        "You are about to remove shifts and events for the selected month.",
      clearPeriodPeriodDate: "Day",
      clearPeriodPeriodWeek: "Week",
      clearPeriodPeriodMonth: "Month",
      clearPeriodShiftsToRemove: "Shifts to Remove",
      clearPeriodEventsToRemove: "Events to Remove",
      clearPeriodDescriptionDay:
        "This action respects the applied filters, so only the shifts and events displayed in the view will be removed. It will remove both draft and published shifts and events for the selected day.",
      clearPeriodDescriptionWeek:
        "This action respects the applied filters, so only the shifts and events displayed in the view will be removed. It will remove both draft and published shifts and events for the selected week.",
      clearPeriodDescriptionMonth:
        "This action respects the applied filters, so only the shifts and events displayed in the view will be removed. It will remove both draft and published shifts and events for the selected month.",
      clearPeriodConfirmQuestionDay: "Are you sure you want to clear the day?",
      clearPeriodConfirmQuestionWeek:
        "Are you sure you want to clear the week?",
      clearPeriodConfirmQuestionMonth:
        "Are you sure you want to clear the month?",
      clearPeriodSuccess: "Shifts and events cleared successfully.",
      publishSelected: "Publish Selected",
      unpublishSelected: "Unpublish Selected",
      deleteSelected: "Delete Selected",
      deleteEventShiftTitle: "Delete Selected Shifts and Events",
      deleteEventShiftIntroWeek:
        "You are about to delete the selected shifts and events for the selected week.",
      deleteEventShiftIntroDay:
        "You are about to delete the selected shifts and events for the selected day.",
      deleteEventShiftIntroMonth:
        "You are about to delete the selected shifts and events for the selected month.",
      deleteEventShiftPeriodWeek: "Week",
      deleteEventShiftPeriodDate: "Date",
      deleteEventShiftPeriodMonth: "Month Name",
      deleteEventShiftShiftsToDelete: "Shifts to Delete",
      deleteEventShiftEventsToDelete: "Events to Delete",
      deleteEventShiftDescriptionWeek:
        "Once deleted, the selected shifts and events will be removed from the weekly view. Deleted records also trigger cancellation notifications for assigned staff members and invitees.",
      deleteEventShiftDescriptionDay:
        "Once deleted, the selected shifts and events will be removed from the daily view. Deleted records also trigger cancellation notifications for assigned staff members and invitees.",
      deleteEventShiftDescriptionMonth:
        "Once deleted, the selected shifts and events will be removed from the monthly view. Deleted records also trigger cancellation notifications for assigned staff members and invitees.",
      deleteEventShiftConfirmQuestion: "Are you sure you want to delete?",
      quickEdit: "Quick Edit",
      saveChanges: "Save Changes",
      multipleDuplicates: "Multiple Duplicates",
      duplicatePlain: "Duplicate",
      duplicateSuccess: "Duplicated successfully.",
      assignStaff: "Assign Staff",
      unassignUsers: "Unassign Users",
      actionComingSoon: "{{action}} will be available soon.",
      bulkActionSuccess: "Bulk action completed successfully.",
      bulkDeleteSuccess: "Selected items deleted successfully.",
      notifyAttendees: "Notify Attendees Before {{eventOrShift}}",
      whoElseCanJoin:
        "Who else can see this {{eventOrShift}} and request to join?",
      confirmationTitle: "Confirmation Required",
      rejectingActionTitle: "Reason for rejecting cancellation request",
      inviteesOnly: `You have selected <strong>"Only invited staff can see and join this {{eventOrShift}}"</strong>. Only the invited staff members will receive an invitation to join this {{eventOrShift}}. Non-invitees will not be able to view or request access to the {{eventOrShift}}.\nAre you sure you want to proceed with this option?`,

      allowRequestForStaffMembers: `You have selected <strong>"Let other staff request to join"</strong>. Only the invited staff members will receive an invitation to join this {{eventOrShift}}. Non-invitees will not be able to view or request access to the {{eventOrShift}}.\nAre you sure you want to proceed with this option?`,

      saveDraft: `You have selected <strong>"Do Not Publish and Save as Draft"</strong>. The {{eventOrShift}} will be saved for your reference but will not be visible to any staff members on the calendar. You can publish it at a later time.\nAre you sure you want to proceed with this option?`,

      allowInvitees: `You have selected <strong>"Let other staff request to join (besides invitees)"</strong>. The selected staff members will receive invitations to join the {{eventOrShift}}, while other staff members in the organization can request access to join.\nAre you sure you want to proceed with this option?`,

      userNotselectedAllowInvitees: `You have selected the option: <strong>"Let other staff request to join"</strong>. This means that the staff members assigned to the selected office and role will be able to request to join the {{eventOrShift}}.\nWould you like to continue with this option?`,

      joinEvent: "Join {{eventOrShift}}?",
      confirm: "Confirm",
      joinSingleEvent:
        "The request to join will be sent to the event host. Are you sure you want to request to join the event?",
      eventrepeatsevery: "This {{eventOrShift}} repeats every ",
      recurringEventEvery:
        "This {{eventOrShift}} is recurring {{eventOrShift}}",
      RequesttojoineventAllDay: "Request to join  {{eventOrShift}} for All ",
      RequesttojoineventFutureDay:
        "Request to join for all recurring {{eventOrShift}} dates",
      JoinSpecificDates: "Request to join  {{eventOrShift}} for Specific Dates",
      event: "Event",
      joinSingleEventDesc:
        "The request to join will be sent to the {{eventOrShift}} host.",
      joinSingleEventConfirm:
        "Are you sure you want to request to join the {{eventOrShift}}?",
      noEventsFound: "No events available for your selection",
      invitationRequestModalHeading: "Invite Staff to Office",
      invitationRequestModalSubHeading:
        "The selected staff member is not currently part of this office. Would you like to invite them to join the office before proceeding?",
      invitationRequestModalSendButton: "Invite Staff and Accept Request",
      noRequestFound: "No requests available for your selection",
      deleteTheEventDesc:
        "Deleting the event would delete the event for you and the event will be removed from the list of staff members.",
      areYouSureYouWantToDeleteTheEvent:
        "Are you sure you want to delete the event?",
      publishTheEventDesc:
        "Once published, the event will be visible to the uninvited staff to join.",
      areYouSureYouWantToPublishTheEvent:
        "Are you sure you want to Publish the event?",
      isDraftPublishTitle: "For whom do you want to publish the event?",
      deleteEvent: "Delete {{eventOrShift}}",
      deleteBusyTimeslotbtn: "Delete Busy Timeslot",
      mandatoryMsg:
        "Some mandatory fields are missing.\n Please fill in all required fields.",
      yesDelete: "Yes, delete",
      deletePolicy: "Delete Policy",
      allDays: "All {{field}}s",
      acceptRequest: "Accept Request to Join?",
      acceptRequestContent:
        "Are you sure you want to accept the joining request?",
      busySlotAdded: "Busy timeslot added successfully!",
      busySlotUpdated: "Busy timeslot updated successfully.",
      noEvent: "No Event",
      noOfficeFoundForEvent:
        "Events Cannot Be Created As There Is No Office Found.",
      noOfficeFoundForBusyslots:
        "Busy Timeslots Cannot Be Created As There Is No Office Found.",
      enterprise: "Company-Wide",
      views: {
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        dailyList: "Daily List",
        weeklyList: "Weekly List",
      },
      agenda: {
        appointmentTag: "Appointment",
        appointmentTitle: "Patient Appointments",
        appointmentPatientTitle: "Booked By - {{name}}",
        eventTag: "Event",
        shiftTag: "Shift",
        shiftCreatedByOthers: "Shift Created By Others",
        shiftByOthers: "Shift By Others",
        busyTag: "Busy",
        leaveTag: "Leave",
        pendingLeave: "Leave Request",
        approvedLeave: "Approved Leave",
        leaveTitle: "All Day",
        allDayEvent: "All Day",
        onLeave: "On Leave",
        seeMore: "See More",
        seeLess: "See Less",
        seeMoreWithCount: "+{{count}} more",
        staffMember: "Staff Member",
        staffName: "Staff Name",
        doctorName: "Doctor Name",
        patient: "Patient - {{name}}",
      },
      eventDoesNotExist: "No {{eventOrShift}} available for your selection",
      Slotblocked: "Slot is blocked",
      SlotblockedDescription:
        "This time was blocked via your booking availability settings. Editing is only available from there.",
      PatientAppointment: "Patient Appointment",
      PatientAppointmentCheckFromMobile:
        "Patient Appointments are viewed and managed on the Miraxis App. Please switch to mobile app to view the appointment details",
      agendaLeave: "Leave",
      agendaLeaveDescription:
        "Leaves are viewed and managed on the Miraxis App. Please switch to mobile to view the details of the applied leave",
      eventDeletedFor: "Event deleted for",
      reasonForDeleteEvent: "Reason for deleted event",
      deleteForAll: "Delete for all",
      deleteForAllOffices: "Delete for all Offices",
      deleteForSelectedEmployee: "Delete for selected staff",
      deleteForSelectedOffices: "Delete for selected offices",
      selectToDeleteEvent:
        "Select how you want to delete this {{eventOrShift}}",
      selectToDeleteBusySlot:
        "Select how you want to delete this busy timeslot",
      deleteEventOnly: "Delete this {{eventOrShift}} only",
      deleteAllFutureEvents: "Delete this and all future {{eventOrShift}}",
      deleteBusySlotOnly: "Delete this busy timeslot only",
      deleteAllFutureBusySlot: "Delete this  and all future busy timeslot",
      deletForSpecificeDate: "Delete for specific dates",
      reasonForDelete: "Reason for delete {{eventOrShift}}",
      reasonForDeleteBusyTimeSlot: "Reason for delete busy timeslot",
      selectAlteastOneDate: "Please select at least one date",
      eventNoLongerForAvailble: "This event is no longer available for",
      eventAlreadyDeleted: "This Event is already deleted",
      noReason: "No reason provided",
      historyLogs: "History Logs for {{eventOrShiftOrLeave}}",
      duplicateEvent: "Duplicate {{eventOrShiftOrLeave}}",
      continueEventCreation: "Continue {{eventOrShift}} Creation",
      eventHistoryTable: {
        actions: "Actions",
        actionTakenBy: "Action Taken By",
        actionTakenOn: "Action Taken On",
        actionDateAndTime: "Action Date & Time",
        date: "Date",
        invitees: "Invitees",
        reason: "Reason",
        delete: "DELETE",
        edit: "EDIT",
        viewDetails: "View Details",
        viewReason: "View Reason",
        reasonForDeleteEvent: "Reason for delete event",
        emptyMsg: "No history logs available for your selection",
      },
      invalidEventData: "Invalid event data",
      eventShiftAlreadyExistForUser:
        "This {{eventOrShift}} is already exist for this user.",
      cannotMoveAllDayToTimeBased: "Cannot move all-day event to time-based",
      cannotMoveTimeBasedToAllDay: "Cannot move time-based event to all-day",
    },
    notificationsPage: {
      title: "Notifications",
      allNotification: "See All Notifications",
      officePolicyAssignmentDeleteView:
        "This policy assignment has been deleted.",
    },
    messenger: {
      emptyModalMsg: "No chat available for your selection",
      doYouReallyWantToCall: "Do you really want to make a call?",
      chatClosed: "closed",
      patientLiveChat: "Patient Live Chat",
      doctorLiveChat: "Doctor Live Chat",
      viewDetails: "View Details",
      download: "Download",
      viewAppointment: "View Appointment",
      externalChat: "External Chat",
      internalChat: "Internal Chat",
      selectOffice: "Select Office",
      allOffices: "All Offices",
      filtersActiveIndicator: "Filters are applied",
      sdkErrorMessage:
        "Something went wrong. Please try again after sometime. If issue persists, contact admin.",
      messages: "Messages",
      noCallHistoryFound: "No call history",
      enableMicrophone: "Please enable your microphone",
      enableCamera: `Please enable your camera`,
      enableCameraMicrophone: `Please enable your camera/microphone`,
      noCallHistoryAvailable: "No call history available for your selection",
      callHistory: "Call History",
      newConversationLabel: "New Conversation",
      newPatientChat: "New Patient Chat",
      newConversationToast:
        "Note: Patients with no appointment won’t show up in the list.",
      // closeChatPreventInput:
      //   "The chat has been closed. Try to reopen the chat from the chat settings.",
      closeChatPreventInput: `The chat is closed. To send or receive messages, open the chat by selecting the "Open Chat" option.`,
      confirmCloseChatLabel: "Yes, Close",
      closeChat: "Close Chat",
      openChatDescription:
        "If you open the chat, you can send the message to patient and receive message from them. Are you sure you want to open the chat?",
      confirmOpenChatLabel: "Yes, Open",
      openChat: "Open Chat",
      closeChatDescription:
        "Patient won’t be able to communicate if you close this chat. Are you sure you want to close the chat?",
      teamConversation: "Team Live Chat",
      patientConversation: "Patient Live Chat",
      notes: "Notes",
      internal: "Internal",
      external: "External",
      members: "Members",
      theAcountOwnerIs: "The account owner is:",
      pleaseSelectConversationToStart: "No Chat available for your selection",
      pleaseInternalSelectConversationToStart:
        "No internal chat available for your selection",
      pleaseExternalSelectConversationToStart:
        "No external chat available for your selection",
      pleaseDoctorSelectConversationToStart:
        "No doctor chat available for your selection",
      pleasePatientSelectConversationToStart:
        "No patient chat available for your selection",
      ongoingConversations: "Ongoing Conversations",
      noConversation: "No chat",
      noInternalChat: "No internal chat",
      noExternalChat: "No external chat",
      noPatientChat: "No patient chat",
      noDoctorChat: "No doctor chat",
      noConversationDesc: "No chat available for your selection",
      noInternalConversationDesc:
        "No internal chat available for your selection",
      noExternalConversationDesc:
        "No external chat available for your selection",
      noPatientConversationDesc: "No patient chat available for your selection",
      noDoctorConversationDesc: "No doctor chat available for your selection",
      contactInfo: "Contact Info",
      mediaDocs: "Media & Docs",
      seeAll: "See all",
      deleteChat: "Delete Chat",
      deleteConversation: "Delete Conversation",
      deleteConversationDesc:
        "If you delete a conversation, it will still be visible to the other member. Are you sure you want to delete?",
      media: "Media",
      docs: "Docs",
      newGroup: "New Group",
      newTeamChat: "New Team Chat",
      groupNote: "Note: Select multiple staff to create a group chat.",
      startGroup: "Start a Group",
      startChat: "Start Chat",
      loading: "Loading...",
      createGroup: "Create Group",
      noUserFound: "No User Found",
      noUserFoundDesc:
        "Sorry, no user was found. You can only chat with those users who have access to messenger.",
      updateGroup: "Update Group",
      editGroup: "Edit Group",
      removePicture: "Remove Picture",
      groupName: "Group Name",
      create: "Create",
      update: "Update",
      archiveChat: "Archive Chat",
      unarchiveChat: "Unarchive Chat",
      newConversation: "New Chat",
      title: "Title*",
      findThePersonByEmailAddressPhoneNumber:
        "Find the person by email address or phone number:",
      egAdamsmithEmailCom: "E.g. adamsmith@email.com",
      emptyContactText1: "We could not find the contact you were looking for.",
      emptyContactText2:
        "You can share the Miraxis app with your contacts so they can be available in the list and join your conversation.",
      shareApp: "Share App",
      selectedAccountOwnerText: "Showing messages for ",
      changeAccountOwner: "Change",
      userNotCreated: "not active yet.",
      groupNameExistanceError: "Please add the group Name.",
      groupNameLengthError:
        "Group Name length can not be more than {{limit}} characters",
      groupImageTypeError: "Please upload image only.",
      groupImageSizeError: "Image Size can not be more than {{size}} MB.",
      createdBy: "Created by",
      deleteGroupChat: "Delete Group",
      deleteGroupChatDesc:
        "Once deleted, the group chat will be deleted for you as well as the other members in the group. Are you sure you want to delete the group chat?",
      removeMember: "Remove Member",
      removeMemberDesc:
        "Are you sure you want to remove this member from the group? The member will not have access to any new messages sent in the group.",
      removeMemberSuccess: "Member removed successfully",
      removeMemberError: "Only the group creator can remove members",
      deleteSingleChat: "Delete chat",
      deleteSingleChatDesc:
        "If deleted, the chat will be removed from your list as well as from the list of the other member in the chat. Are you sure you want to delete the chat?",
      fileSizeError: "{{name}} has size more than {{size}} MB",
      noDataFound: "No Media",
      selectedOffices: "Offices",
      titleLengthError: "Title not valid",
      fileTypeNotSupported:
        "{{name}} has a file type ({{type}}) that is not supported.",
      emailValidationError: "Please enter a valid email address.",
      phoneValidationError: "Please enter a valid phone number.",
      emailNotExist: "This email address does not exist.",
      phoneNotExist: "This phone number does not exist.",
      createGroupError: "You don't have access to create group chats.",
      externalChatAccessError: "You don't have access to external chat.",
      shareAppEmailSubject: "Register and Download the Miraxis App",
      shareAppEmailBody:
        "Hi,\n\tYour friend has shared an app 'Miraxis HealthHub' with you that empowers the healthcare Professionals.\n\tMiraxis HealthHub is a cloud-based platform which connects healthcare community, integrate and automate their workflows.\n\n\tYou can click on {{webUrl}} to register with the platform. After registration, you can also click on the link below to download the app.\n\n\tAndroid Link: {{playStoreLink}}\n\tIOS Link: {{appStoreLink}}\n\n",
      allNotification: "See All Notifications",
      addGroupMember: "Add Group Member",
      addMember: "Add Member",
      removedFromGroupByCreator: "Removed from group by creator.",
      enableChatNotifications:
        "Enable browser notifications to get alerts for new team chat messages, including when this tab is in the background.",
      enableChatNotificationsAction: "Enable notifications",
      chatNotificationsBlocked:
        "Chat notifications are blocked in this browser. Allow notifications for this site in the address bar (lock icon) or site settings, then refresh.",
    },
    vendorManagement: {
      promotionDisabled:
        "The promotion cannot be sent as the account is terminated. To send a new promotion, purchase a subscription from the ",
      promoCodeDisabled:
        "The promo code cannot be added/sent as the account is terminated. To send a new promotion, purchase a subscription from the ",
      salesRepDisabled:
        "The sales representatives cannot be added as the account is terminated. To add a new sales representative, purchase a subscription from the ",
      salesRepDetailDisabled:
        "The sales representatives cannot be viewed as the account is terminated. To add a new sales representative, purchase a subscription from the ",
      vendorAccountDisabled:
        "Your account is terminated. You can view and manage the old orders but cannot receive new orders from the buyers. To continue receiving new orders, purchase a subscription from the ",

      promocodeSend: "Promocode sent successfully!",
      orderCancelledByCustomer: "Cancelled By Customer",
      mentionPaymentMode: "Mention the mode of payment",
      modeOfPaymentPlaceholder: "E.g. Credit card, Cash, Cheque etc.",
      noOrdersFound: "No Orders Found",
      paymentReceivedByCash: "Payment received by cash.",
      noCustomersFound: "No Customers Found",
      updatedSuccessfully: "Updated successfully!",
      selectYourCard: "Select Your Card",
      pay: "Pay now",
      useSavedCard: "Used saved card",
      addNewCard: "+ Add New Card",
      sendPromocodes: "Send Promo Codes",
      quantityToCancel: "No. of Quantity to Cancel",
      noShipmentMsg: "No shipment",
      noNewShipmentMsg: "No new shipment",
      noNonShippedMsg: "No items available for shipment",
      noneDeliveredMsg: "No item is marked as delivered by the customer",
      noneCancelledMsg: "No item is canceled",
      noDataFound: "No Data Found!",
      uploadError: "The following image(s) could not be uploaded",
      editProduct: "Edit Item",
      editProfile: "Edit Profile",
      salesRepDetailsSuc: "Details updated successfully!",
      personalDetails: "Personal Details",
      cardDetails: "Card Details",
      promoCodesModule: {
        promoCodeAddSuc: "Promo Code added successfully!",
        searchByName: "Search by Name",
        noDataFound: "No Data Found!",
      },
      deleteProdTitle: "Delete Product",
      deleteProdDesc:
        "Deleting the product would make the product Unavailable for buyers to purchase. Are you sure you want to delete the product?",
      productDelSuc: "Product deleted successfully!",
      cardAddedSuc: "Card added successfully!",
      noOfficeFound2: "No Office Found!",
      officesAssignedSuccessfully: "Office(s) assigned successfully.",
      differentPricesSet: "Prices Set For Different Locations",
      numberOffices: "{{offices}} Offices",
      inviteSent: "Invite sent successfully.",
      noItemAvailable: "No Item Available for Selection.",
      deliveryDays: "{{fromDays}} - {{toDays}} Days",
      setupAccount: {
        pageTitle: "Set Up Your Account",
        pageSubTitle:
          "Join Miraxis to add & sell your items to hospitals and practitioners easily.",
      },
      productAdded: "Product added successfully.",
      productUpdated: "Product updated successfully.",
      addBankDetails: {
        addBank: "Create a Stripe Account",
        pageTitle: "Add Card Details",
        pageStep: "Step 4 of 5",
        pageStepLast: "Step 5 of 5",
        creditCard: "Credit Card",
        creditCardDesc: "Add Credit Card to Top Up Promotions easily.",
        cardDetails: "Card Details",
        bankDetails: "Bank Details",
        bankDetailsDesc:
          "Add Bank Account so that all the transaction can be transferred to your account easily.",
        accountNumber: "Account Number",
        accountHolderName: "Account Holder Name",
        saveBankDetails: "Save Bank Details",
        saveCardDetails: "Save Card Details",
        BankDetails: "Bank Details",
        BankDetailsDesc:
          "Bank details are required to receive payments from buyers who place orders on your products. For adding the bank details, you need to create a Stripe account.  By clicking on the button below, you will be directed outside of Miraxis Platform to create a Stripe account.  Please follow the instructions step by step and come back to Miraxis by logging in to your account again.",
        continueStripAccount: "Continue to Stripe Account",
        warningText:
          "Please complete the Stripe configurations such as bank details, home address, or any required documents to complete the vendor sign up process.",
      },
      errors: {
        selectOneItems: "Please select at least one item",
        selectCustomersError: "Please, select at least 1 customer.",
        emailError2: "Upto 64 chars allowed before '@'.",
        assignOfficeError: "Please select at least one office.",
        stripeError: "Stripe error. Please, try again.",
        emailError: "Please enter a valid email address.",
        productImageError: "Please, add a product image.",
        productImageSizeError: "Image should be less than {{size}} MB.",
        productImageTypeError: "{{type}} image type is not supported.",
        priceZeroError: "Price cannot be zero.",
        fromError: '"From" day can\'t be larger than "To" day',
        toError: '"To" day can\'t be smaller than "From" day',
        sameFromAndTo: '"From" and "To" day cannot be same.',
        daysError: "Please, fill the day.",
        priceError: "Please, add the price.",
        taxError: "Please, select at least one tax.",
        errorMessage: "This field is mandatory.",
        minQuantityOrder1: "Minimum Order Quantity cannot be less than 1.",
        minQuantityOrder2:
          "Minimum Order Quantity cannot be greater than Maximum Order Quantity.",
        maxQuantityOrder1: "Maximum Order Quantity cannot be less than 1.",
        maxQuantityOrder2:
          "Maximum Order Quantity cannot be less than Minimum Order Quantity.",
        totalQuantityInInventory: "Items in inventory  cannot be less than 1.",
        quantityShortageReminder: "Shortage Quantity cannot be less than 1.",
        cannotBeMore:
          "Selected quantity of an item cannot be more than the quantity remaining.",
        cannotBeLess: "Selected quantity of an item cannot be less than one.",
      },
      dashboard: "Business Dashboard",
      manageOrders: "Sales Orders & Shipment",
      manageCatalogue: "Catalogue & Inventory",
      manageCustomers: "Customers",
      promotion: "Promotions",
      promoCodes: "Promo Codes",
      topUp: "Top-Up Promotions",
      supportHelpdesk: "Support & Helpdesk",
      salesRepresentative: "Sales Representative",
      manageInvoices: "Invoices & Reports ",
      importCatalogue: "Import Catalogue",
      uploadImages: "Upload Images",
      exportSampleCSV: "Export Sample File",
      addNewItem: "Add New Item ",
      searchByItemNoName: "Search by Item No., Name...",
      sKUProductID: "SKU/Product ID",
      minQuantityOrder: "Min. Quantity to Order",
      productName: "Product Name",
      maxQuantityOrder: "Max. Quantity to Order",
      productType: "Product Type",
      taxApplied: "Tax Applied",
      notAvailable: "Not Available",
      available: "Available",
      totalQuantityInInventory: "Total Quantity In Inventory",
      quantityShortageReminder: "Quantity Shortage Reminder",
      productDescription: "Product Description",
      reminderTooltipDesc:
        "An email will be sent to you whenever the quantity reaches to minimum limit.",
      unitPrice: "Unit Price",
      setUnitPriceForTheItem: "Set a unit price for the item",
      setPrice: "Set Price",
      unitTaxPrice: "Unit Tax Price",
      setUnitTaxPriceForTheItem: "Set a unit tax price for the item",
      setTaxPrice: "Set Tax Price",
      locationDeliveryTime: "Location & Delivery Time",
      setDeliveryTimeForTheItem: "Set delivery time for the item",
      setDeliverTime: "Set Deliver Time",
      customersDiscount: "Customer's Discount",
      vipCustomers: "VIP Customers",
      normalCustomers: "Normal Customers",
      vIPCustomersDiscount: "VIP Customers Discount",
      normalCustomersDiscount: "Normal Customers Discount",
      samePriceForAll: "Same Price for All",
      viewDetails: "View Details",
      gENCANONLYTAXCODE: "GEN-CAN-ONLY-TAX-CODE",
      changeTaxPrice: "Change Tax Price",
      deliveryTimeSetForDifferentLocations:
        "Delivery Time Set For Different Locations",
      seeDeliveryTime: "See Delivery Time",
      setDifferentPriceForEachLocation: "Set Different Price for Each Location",
      alberta: "Alberta",
      britishColumbia: "British Columbia",
      manitoba: "Manitoba",
      newBrunswick: "New Brunswick",
      newfoundlandAndLabrador: "Newfoundland and Labrador ",
      northwestTerritories: "Northwest Territories",
      manageLocationDeliveryTime: "Manage Location & Delivery Time",
      fromDays: "From Day(s)",
      toDays: "To Day(s)",
      productDetails: "Product Details",
      discounts: "Discounts",
      location: "Location",
      price: "Price",
      customersCategory: "Customers’ Category",
      discountAllowed: "Discount Allowed",
      discountAllowedInPercentage: "Discount Allowed (in percentage)",
      deliveryTime: "Delivery Time",
      promotionsBalance: "Promotions Balance",
      promotionLaunched: "Promotion Launched",
      promotionRemaining: "Promotion Remaining",
      topUpPromotion: "Top Up Promotion",
      topUpPromotions: "Top Up Promotions",
      topUpPromotionsInTop: "Top-Up Promotions",
      topUpHistoryInTop: "Top-Up History",

      topUpHistory: "Top Up History",
      date: "Date",
      plan: "Plan",
      searchbyTicketNo: "Search by Ticket No.",
      addNewTicket: "Add New Ticket",
      allTickets: "All Tickets",
      pending: "Pending",
      resolved: "Resolved",
      inProgress: "In Progress",
      createdOn: "Created on:",
      issuedOn: "Issued on:",
      ticketNo: "Ticket No.",
      orderNo: "Order No.",
      ticketType: "Ticket Type",
      assignOrder: "Assign Order",
      description: "Description",
      createTicket: "Create Ticket",
      ticketDetails: "Ticket Details",
      you: "YOU",
      helpdesk: "HELPDESK",
      writeYourMessage: "Write your message",
      addNewPromoCode: "Add New Promo Code",
      launched: "Launched",
      sendToCustomers: "Send to Customers",
      expireOn: "Expire On",
      expiredOn: "Expired On",
      expired: "Expired",
      selectCustomers: "Select Customers",
      selected: "Selected",
      pleaseSelectCustomersYouWantToSendPromoCodes:
        "Please select customers you want to send promo codes.",
      sendPromoCodes: "Send Promo Codes",
      promoCode: "Promo Code",
      expiryDate: "Expiry Date",
      sendPromoCodeTo: "Send Promo Code to",
      sendToAllCustomers: "Send to All Customers",
      sendtoSelectedCustomers: "Send to Selected Customers",
      generate: "Generate",
      addNewPromotion: "Add New Promotion",
      promoCodeAssigned: "Promo Code Assigned",
      promotionStartDate: "Promotion Start Date",
      promotionExpiryDate: "Promotion Expiry Date",
      wantToLaunchMorePromotions: "Want to launch more promotions?",
      goToTopUpToBuyYourPromotions: "Go to Top-Up to buy your promotions.",
      goToTopUp: "Go to Top Up",
      promotionDetail: "Promotion Detail",
      promotionSentTo: "Promotion Sent To",
      promotionStatus: "Promotion Status",
      selectedCustomers: "Selected Customers",
      viewListOfCustomers: "View List of Customers",
      promocodes: "Promo Codes",
      customers: "Customers",
      sendInvite: "Send Invite",
      okayGotIt: "Okay, Got it",
      customersModalDesc:
        "Help your customers join Miraxis by inviting them and start ordering their items from here.",
      promotionHeading: "Promotion Heading",
      promotionLaunchDate: "Promotion Launch Date",
      selectPromoCode: "Select Promo Code",
      allPaymentMethods: "All Payment Methods",
      manageInvoicesSearchPlaceholder:
        "Search by Order No., Invoice No., Office Name...",
      invoiceNo: "Invoice No.",
      paymentMethod: "Payment Method",
      orderStatus: "Order Status",
      paymentStatus: "Payment Status",
      officeName: "Office Name",
      actions: "Actions",
      exportInvoice: "Export Invoice",
      manageSalesRepresentative: "Sales Representative",
      inviteSalesRep: "Invite Sales Rep.",
      officesAssigned: "Offices Assigned",
      inviteNewSalesRepresentative: "Invite New Sales Representative",
      editSalesRepresentative: "Edit Sales Representative",
      salesRepresentativeDetails: "Sales Representative Details",
      assignOffice: "Assign Office",
      searchByOfficeName: "Search by Office Name",
      noOfficeFound: `No Office Found! Please Click On ‘Assign Office’ To Add Offices.`,
      noOfficeFoundline1: `No Office Found!`,
      noOfficeFoundline2: `Please Click On ‘Assign Office’ To Add Offices.`,
      selectOffices: `Select Offices`,
      deleteOffice: `Delete Office`,
      deleteOfficeDsc: `If you delete the office, the sales representative will not be able to place the order for the deleted office. Are you sure you want to delete the office?`,
      inviteCustomers: `Invite Customers`,
      allCustomers: `All Customers`,
      billMeLaterAccess: `Bill Me Later Access`,
      billMelater: "Bill Me Later",
      customerDetails: `Customer Details`,
      vIPCustomerAccess: `VIP Customer Access`,
      billMeLaterAccessCreditLimit: `Bill Me Later Access & Credit Limit`,
      exportInvoices: `Export Invoice(s)`,
      generateInvoices: `Generate  Invoice(s)`,
      exportOrders: `Export Order(s)`,
      markAsPaidModalTitle: `Mark as Paid`,
      markAsPaidModalDesc: `Once marked Paid, the payment status cannot be changed. Are you sure you want to mark the order as Paid?`,
      editCustomerDetails: `Edit Customer Details`,
      billMeLaterCreditLimit: `Bill Me Later Credit Limit`,
      saveChanges: `Save Changes`,
      customerName: `Customer Name`,
      markAsPaid: `Mark as Paid`,
      orderHistory: `Order History`,
      dateRangeFrom: `Date Range From:`,
      activateTopUp:
        "Once activated, the top-up plan can be purchased by the vendors. Are you sure you want to activate the top-up plan?",
      deactivateTopUp:
        " Once deactivated, the top-up plan cannot be purchased by the vendors. Are you sure you want to deactivate the top-up plan?",

      to: `To:`,
      analytics: "Analytics",
      totalOrders: "Total Orders",
      pendingOrders: "Pending Orders",
      billMeLaterAndUnPaidOrders: "Bill Me Later and Unpaid Orders",
      deliveredOrders: "Delivered Orders",
      cancelledOrders: "Cancelled Orders",
      shippedOrders: "Shipped Orders",
      acceptedNotShippedOrders: "Accepted/Not Shipped Orders",
      addCreditCard: "Add Credit Card",
      addBankAccount: "Add Bank Account",
      creditCardDetails: "Credit Card Details",
      changeCard: "Change Card",
      bankDetails: "Bank Details",
      changeAccount: "Change Account ",
      allOrders: "All Orders",
      searchByOrderNoOfficeName: "Search by Order No. or Office Name",
      payment: "Payment",
      salesRepOrder: "Sales Rep Name",
      exportOrderShipment: "Export Order/Shipment",
      browserPopUpSupportMessage:
        "Your browser prevented this site from opening a pop-up window. You can allow the pop-up from Browser Settings.",
      maximumImages: "Maximum of 500 images can be uploaded together",
      createNewShipment: "Create New Shipment",
      notShipped: "Not Shipped",
      InvoiceNo: "Invoice No.",
      allItems: "All Items",
      newShipments: "New Shipments",
      itemName: "Item Name",
      sKUNo: "SKU No.",
      qtyShipped: "Qty Shipped",
      totalPrice: "Total Price",
      exportShipmentDetails: "Export Shipment Details",
      viewTrackingDetails: "View Tracking Details",
      viewTrackingTitles: "Tracking Details",
      doYouWantToAcceptThisOrder: "Do you want to accept this order?",
      acceptAll: "Accept All",
      acceptPartially: "Accept Partially",
      declineAll: "Decline All",
      selectItemsYouWantToAccept: "Select Items You Want to Accept",
      selectItemsYouWantToAcceptDesc:
        "Selecting items will be marked as accepted and will be ready for shipment.",
      selectItemsYouWantToAccepNote:
        "The items which you don’t select will be considered as cancel and you cannot change it afterwards.",
      selectAll: "Select All",
      selectQty: "Select Qty",
      orderItem: "Order Item",
      qtyRemaining: "Qty Remaining",
      totalQty: "Total Qty",
      markedAsShipped: "Marked as Shipped",
      cancelItems: "Cancel Items ",
      sendNewShipment: "Send New Shipment ",
      cancelTheseItems: "Cancel item(s)",
      cancelTheseItemsDesc: "You have selected the following items to Cancel: ",
      cancelTheseItemsDesc2:
        "If you cancel the Items, the cancellation charges will be deducted from your account. Are you sure you want to cancel? ",
      selectAdditionalItemsToShip: "Select Additional Items to Ship",
      qty: "Oty",
      totalRefund: "Total Refund",
      refundTotalCancelledItemsAndQuantities:
        "Refund Total (Cancelled Items and Quantities)",
      qtyCancelled: "Qty Cancelled",
      name: "Name",
      markAsResolved: "Mark as Resolved",
      generated: "Generated",
      inviteCustomersTitleDesc:
        "Help your customers to join Miraxis by inviting them and start ordering their items from here.",
      noOrderForSelection: "No Orders Available for Selection",
      orderCancelAlltitle: "Cancel All Order",
      orderCancelAllDesc:
        "Cancelling the entire order would mean that all the quantities of the items placed will be canceled. Are you sure you want to cancel the entire order?",
      AcceptAllOrder: "Accept All Order",
      AcceptAllOrderDes:
        "Accepting the entire order would mean that all the quantities of the items will be accepted. If you later cancel the accepted items, the cancellation charges will be deducted from your account. Are you sure you want to accept the entire order?",
      minOrderError: "The quantity cannot be less than 1",
      maxOrderError:
        "The accepted quantity cannot be more than the quantity ordered",
      assingOrderNumber: "Assign Order Number",
      searchbyorderNumber: "search by order number",
      orderNumber: "Order Number",
      selectOrder: "Select Order",
      noOrderNumberSelected: "No Order Selected",
      remainingCreditLimit: "Remaining Credit Limit:",
      totalCreditLimit: "Total Credit Limit:",
      itemTotal: "Item Total",
      promocode: "Promo Code",
      taxes: "Taxes",
      grandTotal: "Grand Total",
      cad: "CAD",
      itemAmount: "Item Amount",
      totalRefundableAmount: "Total Refundable Amount",
      addShipmentDetails: "Add Shipment Details ",
      addDetails: "Add details",
      detailPlaceholder: "E.g. Tracking number, date/time of shipment, etc.",
      alertShipping: "The information added here cannot be edited later.",
      topUpPurchasedSuccessfully: "Top-Up Purchased Successfully",
      goToPromotions: "Go to Promotions",
      topUpPurchasedFailed: "Top-Up Purchased Failed",
      manageSubscription: "Manage Subscription",
      changeSubscription: "Change Subscription",
      manageCards: "Manage Cards",
      terminateSubscription: "Terminate Subscription",
      currentSubscription: "Current Subscription",
      vendorCharges: "Vendor Charges",
      salesRepCharges: "Sales Rep Charges",
      creditCards: "Credit Cards",
      terminateSubscriptionWarning:
        "Are you sure you want to terminate your subscription? You will not be able to add products to catalog or receive an order for the buyer",
      sureBtn: "Yes I am sure. Terminate my account Immediately",
      notSureBtn: "No, I do not want to terminate my account",
      ManageBankDetails: "Manage Bank Details",
      GotoStripe: "Go to Stripe",
      ManageBankDetailContent:
        "Your bank account details are set up in Stripe.  You will need to login to the Stripe application and change your bank information there.",
      chooseSubscription: "Choose Subscription",
      enterpriseSubscription: "Enterprise Subscription",
      professionalSubscription: "Professional Subscription",
      contactSales: "Contact Sales",
      largeVendorrSupplying:
        "Ideal for large vendors supplying in multiple cities",
      contactUs: "Contact Us",
      purchasePlan: "Purchase Plan",
      customPlan: "To Build a Custom Plan",
      enterprisePlan: "Enterprise Plan",
      pleaseContactSales:
        "Please contact our sales team to receive the information about Enterprise Subscription and Pricing option. Our team will provide a customized subscription plan that fits your organization structure. We will also support you in setting up all accounts for your offices and staff.",
      close: "Close",
      emailAddress: "Email Address",
      phoneNumber: "Phone Number",
      emailAddressDetail: "info@miraxis.com",
      phoneNumberDetail: "1 (877) 747-3615",
      vendorFreeTrialHeading: "Start Your Free Trial Now!",
      freeTrialInfo:
        "The free trial account will automatically be upgraded to a paid subscription after the expiry of the trial subscription. You can cancel this upgrade anytime before the expiry.",
      nosubscription: "No Subscription",
      vendorBilling: "Billing",
      paySubscription: "Pay Subscription",
      professionalAlert:
        "The Professional subscription cannot be terminated for one year.",
      confirmSubScription: "Confirm Subscription",

      StepsToImportCatalog: "Steps to Import Catalog:",
      StepsCatalog1: 'Click on "Export Sample File".',
      StepsCatalog2:
        "Open the exported file, and fill in the details of the items to be uploaded.",
      StepsCatalog3:
        "While adding the details of the products in the exported file, follow the below mentioned rules:",
      StepsCatalog3a:
        'The <strong>"ProductCategoryId"</strong> in the exported file are mentioned in Sheet-3 called "Category". You can review the category ID and add it under the "ProductCategoryId" field in the sheet.',
      StepsCatalog3b:
        'The <strong>"VendorTaxId"</strong> in the exported file are mentioned in Sheet-2 called "Tax". You can review the Tax ID and add it under the "VendorTaxId" field in the sheet.',
      StepsCatalog3c:
        'While adding the <strong>"ImageName"</strong>, make sure to add the name of the image and the image type. <strong>For Example:</strong> If you want to upload an image that has the name <strong>"Equipment"</strong> and the image is a <strong>png</strong> image, in the exported excel, add the name <strong>Equipment.png</strong>',
      StepsCatalog3d:
        "While adding the delivery days for different locations, the minimum and maximum days are separated using a comma. <strong>For Example:</strong> If for a product, the delivery days are between 3 to 7 days, add 3,7 in Delivery_Date column.",

      rulesForImportingImages: "Rules for Importing Images:",
      importingImage1:
        "To upload the images, first import the product list by adding the product details as explained above.",
      importingImage2: 'Click on "Upload Images" button on Manage Catalogue.',
      importingImage3:
        "Select the images with the same name as added in the file. You can select multiple images up to 500.",
      importingImage4:
        "The image that matches with the same image name as in the imported file will be added in the product details.",
      importingImage5:
        "While uploading the image, the image size should be less than 5 MB.",
      one: "1.",
      two: "2.",
      three: "3.",
      four: "4.",
      five: "5.",
      a: "a.",
      b: "b.",
      c: "c.",
      d: "d.",
    },
    questionnaire: {
      questionText: "{{questionOrder}}. {{questionText}}",
      newPatient: "New Patient ",
      existingPatient: "Existing Patient ",
      toothache: "Toothache",
      emergency: "Emergency",
      routineCheckup: "Routine Checkup",
      hygiene: "Hygiene ",
      followup: "Follow-up",
      suboptions: "{{count}} Sub-options",
      select: "Select",
      addYourAnswerHere: "Add your answer here",
      pendingWorksFromLastVisit: "Pending works from last visit",
      newPatientFullEvaluation: "New patient - full evaluation",
      newPatientFullEvaluationHygiene:
        "New patient - full evaluation + hygiene",
      errorMessage: "This field is mandatory.",
      appointmentTime: "{{timeRequired}} min",
      successMessage: "Submitted successfully",
    },
    superAdminVendorManagement: {
      manageVendors: "Vendors",
      allMembers: "All Members",
      vendorName: "Vendor Name",
      emailAddress: "Email Address",
      contactNo: "Contact No.",
      status: "Status",
      null: "",
      orderHistory: "ORDER HISTORY",
      salesRep: "SALES REP",
      allPaymentStatus: "All Payment Status",
      orderNo: "Order No.",
      orderDate: "Order Date",
      customerName: "Customer Name",
      officeName: "Office Name",
      accountOwnerName: "Account Owner Name",
      amount: "Amount",
      paymentStatus: "Payment Status",
      name: "Name",
      viewVendorDetails: "View Vendor Details",
      vendorsDetails: "Vendor's Details",
      searchBySalesRepName: "Search by Sales Rep. Name",
      vendorProfile: "Vendor Profile",
      currentActivePlan: "Current Active Plan",
      viewSubscriptionDetail: "View Subscription Detail",
      viewTransactionHistory: "View Transaction History",
      subscriptionName: "Subscription Name",
      totalSubscriptionPrice: "Total Subscription Price",
      startDate: "Start Date",
      expireDate: "Expire Date",
      previousInvoices: "Previous Invoices",
      vendorTransactionHistory: "Vendor Transaction History",
      description: "Description",
      dateTime: "Date & Time",
      transactionStatus: "Status",
      transactionAmount: "Amount",
      mySubscription: "My Subscription",
      vendorSubscriptionDetails: "Vendor Subscription Details",
      employmentDate: "Employment Date",
    },
    superAdminVendorSubscription: {
      creditCardToggleHeadingText: "Credit Card Payment (Auto-Billing)",
      creditCardToggleSubHeadingText:
        "Payments for this account is currently being processed automatically using the saved credit card.",
      offlinePaymentToggleHeadingText: "Offline Payment",
      offlinePaymentToggleSubHeadingText:
        "Credit card billing is disabled. Payments must be made manually via bank transfer, cheque, or other offline methods.",
      changeSubscriptionModalHeading: "Change Payment Method?",
      changeSubscriptionUpdateSuccessfullyToOffline:
        "Successfully changed the payment method to offline payment.",
      changeSubscriptionUpdateSuccessfullyToCreditCard:
        "Successfully changed the payment method to credit card payment.",
      changeSubscriptionFirstOfflineModalSubHeading:
        "Are you sure you want to change the payment method to offline payment?",
      changeSubscriptionFirstOnlineModalSubHeading:
        "Are you sure you want to change the payment method to Credit Card Payment?",
      changeSubscriptionSecondModalSubHeading:
        "Changing this setting will affect how future subscription payments are processed for this account.",
      creditCard: "Credit Card",
      creditCardDescription: "Auto-billing continues as scheduled.",
      offlinePayment: "Offline Payment",
      offlinePaymentDescription:
        "Manual payment required; auto-billing will be paused.",
      modalConfirmation: "Please confirm you wish to proceed.",
      trialSubscriptionForVendors: "Trial Subscription for Vendors",
      vendorCharges: "Vendor Charges",
      salesRepCharges: "Sales Rep Charges",
      editSubscription: "Edit Subscription",
      professionalSubscriptionForVendors: "{{field}} Subscription for Vendors",
      enterpriseSubscriptionForVendors: "Enterprise Subscription for Vendors",
      enterprisePlanSubscription: "Enterprise Plan Subscription",
      packageName: "Package Name",
      addNewPlan: "Add New Plan",
      searchPlans: "Search Plans",
      enterpriseExclusiveForVendors: "Enterprise Exclusive for Vendors",
      name: "Name",
      emailAddress: "Email Address",
      addNewVendor: "Add New Vendor",
      editNewVendor: "Edit Vendor",
      vendorName: "Vendor Name",
      currentActivePlan: "Current Active Plan",
      vendorEmailAddress: "Vendor Email Address ",
      currentSubscription: "Current Subscription",
      searchBySalesRepNameEmail: "Search by Name/Email",
      vendorProfile: "Vendor Profile",
      searchByOrderNo: "Search by Order No.",
      endDateOfTrial: "End Date of Trial Account",
    },
    superAdminCategories: {
      manageCategories: "Manage Categories",
      addNewCategory: "Add New Category",
      editCategory: "Edit Category",
      searchByName: "Search by Name",
      name: "Name",
      status: "Status",
      edit: " ",
      deactivate: " ",
      categoryName: "Category Name",
      save: "Save",
      editNewCategory: "Edit Category",
    },
    superAdminTax: {
      taxManagement: "Tax Management",
      addTaxDetails: "Add Tax Details",
      searchByName: "Search by Name",
      taxName: "Tax Name",
      taxType: "Tax Type",
      viewDetails: "View Details",
      edit: "Edit",
      addNewTax: "Add New Tax",
      oneTax: "One Tax",
      provinceWiseTax: "Province Wise Tax",
      alberta: "Alberta",
      britishColumbia: "British Columbia",
      manitoba: "Manitoba",
      newBrunswick: "New Brunswick",
      newfoundlandAndLabrador: "Newfoundland and Labrador",
      setPercent: "Set Percentage",
      taxPercentage: "Tax percentage",
      percent: "Percentage",
      provinceStates: "Province/States",
      editTax: "Edit Tax",
      taxDetails: "Tax Details",
    },
    superAdminSales: {
      manageSalesRep: "Manage Sales Rep.",
      searchByName: "Search by Sales Rep.,Name,Vendor’s Name",
      saleRepName: "Sales Rep. Name",
      emailAddress: "Email Address",
      vendorsName: "Vendor’s Name",
      contactNo: "Contact No.",
      status: "Status",
      action: "",
    },
    superAdminCommissions: {
      manageCommissions: "Commissions",
      searchByName: "Search by Name",
      vendorName: "Vendor Name",
      emailAddress: "Email Address",
      adminCommission: "Admin Commission",
      edit: "",
      editCommission: "Edit Commission",
      editCommissionInPercentage: "Edit Commission (in percentage)",

      commision: "Commission",
      vendorsName: "Vendor’s Name",
      save: "Save",
    },
    superAdminTopUp: {
      manageTopUpPromotions: "Top-Up Promotions",
      addPromotion: "Add Promotion",
      searchByName: "Search by Name",
      allPromotions: "All Promotions",
      topUpName: "Top Up Name",
      noOfPromotions: "No. Of Promotions",
      price: "Price",
      status: "Status",
      edit: "",
      deactivate: " ",
      addTopUpPromotions: "Add Top-Up Promotions",
      topUpPromotionsName: "Top-Up Promotion Name",
      save: "Save",
      editTopUpPromotions: "Edit Top-Up Promotions",
    },
    superAdminSupportHelpDesk: {
      supportHelpdesk: "Support & Helpdesk",
      pending: "Pending",
      resolved: "Resolved",
      inProgress: "In Progress",
      searchbyTicketNo: "Search by Ticket No.",
      allTickets: "All Tickets",
      name: "Name",
      ticketNo: "Ticket No.",
      issuedOn: "Issued on",
      orderNo: "Order No.",
      successMessage: "Submitted successfully",
    },
    familyMembers: {
      addFamilyMember: "Add Family Member",
      editFamilyMember: "Edit Family Member",
      firstName: "First Name",
      lastName: "Last Name",
      gender: "Gender",
      relation: "Relation",
      dateOfBirth: "Date of Birth",
      emailAddress: "Email Address",
      notification:
        "I want to receive the notification for the appointments booked by me for the added family member.",
      confirmation: "Confirmation",
      sure: "Are you sure you want to delete the family member?",
      remove: "Remove yourself as family member",
      registerAccountForAbove18:
        "This family member is older than 18 years old. You need to add his/her email address to register an account.",
      emailInvitaion:
        "The invited family member will receive an email invitation to register and accept the invite. You can only book the appointment once the request is accepted by the invited family member.",
      confirmMsgAbove18:
        "The family member's email cannot be edited once the request is sent. You have added {{emailId}}.",
      confirmMsgBelow18:
        "You can book an appointment for the added family members.",
      sureForAddMember: "Are you sure you want to add the family member?",
      editOption: "Edit",
      deleteOption: "Delete",
      viewOption: "View",
      updateInfoAbove18Msg:
        "Family member's age is above 18 years. Kindly update the details to continue booking appointments.",
      memberRemovedItselfMsg:
        "{{memberName}} has removed himself/herself as your family member",
      deleteModalTitle: "Delete Family Member",
      deleteSubTitleMsg:
        "By deleting the family member, you won't be able to book an appointment for them.",
      sureForDeleteMember: "Are you sure you want to delete the family member?",
      deleteYourSelfModalTitle: "Remove yourself as family member",
      deleteYourSelfModalSubTitle:
        " If you remove yourself as family member, the user will not be able to book appointment for you.",
      sureForRemoveYourself:
        "Are you sure you want to remove yourself as a family member?",
      viewDetails: "Family Members",
      viewDetailSubTitle: "Family Members Details",
      deleteMemberSuccessMsg: "Family Member deleted succesfully.",
      deleteYourselfSuccessMsg: "Family Member deleted succesfully.",
      mySelf: "Myself",
      appointmentBookingMessageForMember:
        "You are booking this appointment for a family member",
      patientName: "Patient Name",
      patientEmailAddress: "Patient Email Address",
      noOneAddedYouAsaFamilyMember: "No one added you as a family member",
      noFamilymembersaddedyet: "No family members added yet",
    },
    pmsMembers: {
      pmsDoctorsAndPatient: "PMS Doctors and Patients",
      doctors: "Doctors",
      patients: "Patients",
      firstName: "First Name",
      lastName: "Last Name",
      emailAddress: "Email Address",
      contactNumber: "Contact Number",
      action: "Action",
      sendInvite: "Send Invite",
      resendInvite: "Resend Invite",
      invitationSent: "Invitation Sent",
      new: "New",
      status: "Status",
      syncDoctorsAndPatient: "Sync Doctors & Patients",
      reSyncDoctorsAndPatient: "Resync Doctors & Patients",
      editToLinkOffice:
        "%s to set up connection with a Patient Management System.",
      connectPms: "Connect with Patient Management System.",
      whatsThis: "What’s this?",
      sikkaOfficeId: "Master Customer ID",
      masterCustomerIdTooltip:
        "Your Master Customer ID is shared with you through email when you complete the registration. You would need to register your practice  first to receive your Master Customer ID. Click here if you have not registered your practice yet.",
      verify: "Verify",
      verified: "Verified",
      sikkaPracticeId: "Practice Key",
      pmsConnectTooltip:
        "This office is successfully integrated with the Patient Management System {{pmsName}} but you will need to initiate the sync for Doctor & Patient records as well so the appointments can automatically be updated.",
      verifyModalMsg:
        "After clicking on Verify, these information will be disabled and you cannot edit them. Are you sure these information are correct and related to office “{{officeName}}”",
      yesConfirm: "Yes, Confirm",
      verifyDetail: "Verify Detail",
      successfulIntegrated: "{{pmsName}} Successfully Integrated",
      modalContent:
        "The PMS {{pmsName}} is successfully integrated with the office record in Miraxis.",
      modalSubContent:
        "To sync the appointments from the PMS {{pmsName}} into Miraxis for this office, you first need to sync the Doctors and the Patients records. Click the buttons below to sync them now or later.",
      pmsNote:
        "Please note that the appointments will be synced once the doctors and patients are successfully synced and invited on Miraxis.",
      skipNowForSync: "Skip Now and I Will Initiate Sync Later",
      invitePmsStaff:
        "To invite the doctors and the patients registered on the Patient Management System to Miraxis, please",
      clickHere: "Click Here",
      staffSyncedMsg:
        "This staff is synced on the PMS {{pmsName}} and Miraxis.",
      syncNow: "Sync Now",
      masterTooltipForAdd:
        "Master Customer ID is shared through email when you register the Practice with linkUrl If you have not registered the practice yet, please click on linkUrl",
      sikkaMiraxisTooltipUrl: "sikkasoft.com/miraxis",
      verifyMasterId: "Please verify Master Customer ID",
      integrateWithPms: "Integrate with Patient Management System",
      selectOffice: `Select Office`,
      verifyIndicator:
        "After entering Master Customer ID, you need to click on the Verify link to validate your identification number.",
      lastUpdatedOn: "Last updated on",
      noRecord: "No Record Found",
      disableModalHeading: "Disable Integration with PMS",
      disableModalContent:
        " If you disable the integration with PMS, the appointment from PMS will not be synced to Miraxis and vice-versa. Moreover, if you later enable the integration with PMS, the past appointments will not be synced. Are you sure you want to disable the office integration with PMS?",
      editOfficeSubHeading:
        'You can also link the office with a PMS by enabling the "Connect with Patient Management System" toggle below.',
      addEmailforSyncAppointment:
        "For syncing the appointments of the patient from the PMS, we recommend adding the email ID of the user.",
      enableNotifications: "Enable Notifications",
      globalNotificationText:
        "Notifications to non-registered patients is {{statusToggle}}.",
      globalNotificationInfoText:
        "Miraxis has the ability to send notifications such as appointment reminders to the patients who are not registered in Miraxis yet. However, when this toggle is off, Miraxis won't send any notifications to such patients. This option will help you manage the roll-out of the integration with your patient management system. You should turn this toggle on eventually when you completed testing the notifications function for a small group of your patients. The test can be performed by going to patients list and selecting the patients and enable the notification for each patient.",
      enableNotificationsTitle: "Enable Notifications",
      disableNotificationsTitle: "Disable Notifications",
      enableNotificationsSubtitle1:
        "Enabling this toggle will send Email and SMS notifications to all non-registered patients for their upcoming appointments. Are you sure you want to enable this option?",
      enableNotificationsSubtitle2:
        "For more information, you can review the details in the info icon.",
      enableLeftBtn: "Enable Notification",
      disableNotificationsSubtitle1:
        "Disabling the notifications will stop sending appointment reminders to non-registered patients. Are you sure you wish to disable this option?",
      disableLeftBtn: "Disable Notification",
      searchByDoctorName: "Search By Doctor Name",
      searchByPatientName: "Search By Patient Name",
      whatsThisTooltip:
        "Miraxis can integrate with your Patient Management System, and provide limited functionality depending on the compatibility of your Patient Management System. By enabling this option, you will be asked to provide more information to initiate the setup.",
      contactSupport: "Contact Support",
      infoModalContent:
        "You are setting up a connection to a Patient Management System that requires additional configuration by Miraxis Technical Support.",
      infoModalSubContent:
        "Please contact Miraxis Technical Support to assist you to complete this configuration.",
      autoInviteText:
        "Auto Invite to non-registered patients is {{inviteStatusToggle}}.",
      autoInviteInfoText:
        "Miraxis has the ability to auto-create the Miraxis patient accounts for all those patients who are not registered on Miraxis yet but their appointment is created on the synced Patient Management System. If this toggle is On, any new patient created on the PMS will receive Miraxis Invitation Email with an auto-generated password. If the toggle is Off, the patient account will not be created on Miraxis until they are manually invited by the account owners.",
      helpDoctorListHeading: "Doctor List",
      helpDoctorListIntro:
        "The Doctors list displays the doctors registered in the connected Patient Management System (PMS). This allows you to view the doctors available in the connected PMS and invite them to join the office in Miraxis.",
      helpInviteADoctor: "Invite a Doctor",
      helpInviteADoctorText:
        "Select Send Invite next to a doctor record to invite them to the office. An invitation email will be sent to the doctor with instructions to accept the invitation and complete the process of joining the office. The doctor must accept the invitation using the instructions provided in the email.",
      helpSyncDoctorsAndPatients: "Sync Doctors and Patients",
      helpSyncDoctorsText:
        "Doctors registered in the connected PMS are synced automatically. If you need to retrieve the latest doctor and patient information before the next automatic sync, select the Sync Doctors and Patients icon on the office tile to manually start the sync.",
      helpPatientListHeading: "Patient List",
      helpPatientListIntro:
        "The Patients list displays the patients registered in the connected Patient Management System (PMS). From this list, you can view the patients available in the connected PMS and manage their access to Miraxis.",
      helpAutoInvitePatients: "Auto-Invite Patients",
      helpAutoInvitePatientsText:
        "Enable the Auto-Invite Patients toggle to automatically create a patient account in Miraxis when a new patient is synced from the connected PMS.",
      helpAutoInvitePatientsDisabledText:
        "If the toggle is disabled, patient accounts will not be created automatically. The owner can instead send an invitation to individual patients manually when required.",
      helpNotificationsToNonRegisteredPatients:
        "Notifications to Non-Registered Patients",
      helpNotificationsToNonRegisteredPatientsText:
        "Miraxis can send appointment reminder notifications to patients who have not yet registered on Miraxis. This is useful if you don't wish your patients to register to Miraxis but you still want them to receive reminders. Enable the Notifications to Non-Registered Patients toggle to allow appointment reminders to be sent to these patients.",
      helpInviteAPatient: "Invite a Patient",
      helpInviteAPatientText:
        "Select Send Invite next to a patient record to invite them to Miraxis. Once the invitation is sent, the patient's account will be automatically created in Miraxis, allowing the patient to complete the registration process and access the platform.",
      helpSyncPatientsText:
        "Patients registered in the connected PMS are synced automatically. If you need to retrieve the latest doctor and patient information before the next automatic sync, select the Sync Doctors and Patients icon on the office tile to manually start the sync.",
    },

    accountPreferences: {
      fiscalYearPlan: "Fiscal Year Duration",
      accountPreferences: "Account Preferences",
      officeConfiguration: "Office Configuration",
      accountSettingAndPreferences: "Account Settings & Preferences",
      accountSettingSubHeading:
        "This section lets you manage settings that apply across your entire organization, not just individual offices. Use it to configure company-wide branding, fiscal year setup, and other account-level preferences.",
      accountSetup: "Account Setup",
      organizationSettings: "Organization Settings",
      companyBranding: "Company-Wide Branding",
      companyBrandingSettings: "Company-Wide Branding Settings",
      policyPreferences: "Policy Preferences",
      policyAcknowledgementTemplate: "Policy Acknowledgement Template",
      companyBrandingSettingsSubHeading:
        "This section allows you to set branding details for your organization or group. These settings are used in cross-office communications, such as when events or notifications involve multiple offices. Use this section to ensure your organization is represented consistently across Miraxis when communicating at the Company level.",
      companyBrandingNote:
        "<strong>Note:</strong> This is different from <strong>Office Branding</strong>, which applies to individual office-specific emails and displays.",
      addMoreElementsToEmail: "Add more elements to the email",
      messageTemplates: "Message Templates",
      addNewMessageTemplate: "Add New Message Template",
      you: "You",
      deleteModalTitle: "Delete Message Template",
      deleteModalContent:
        "Are you sure you want to delete this message template?",
      deleteMsg: "Template deleted successfully.",
      viewTemplate: "View Template",
      messageTitle: "Message Title",
      contentPushNotification: "Content for Push Notifications & SMS",
      contentForEmail: "Content for Emails",
      attachment: "Attachment",
      officePreferences: "Office Preferences",
      patientSchedulingTemplates: "Patient Scheduling Settings",
      download: "Download",
      showingTemplates: "Showing Templates for",
      template: "Template",
      newTemplate: "New Message Template",
      editTemplate: "Edit Message Template",
      templateName: "Message Template Name",
      preview: "Preview",
      attachFile: "Attach File",
      insert: "Insert",
      previewTitleSubject: "Message Title / Email Subject",
      previewForNotification: "Push Notifications & SMS",
      previewForEmail: "Emails",
      previewModalTitle: "Preview for {{previewFor}}",
      done: "Done",
      noPreview: "No Preview Available",
      noAttachment: "No file attached",
      appointmentReminderPlan: "Appointment Reminder Plan",
      appointmentRecallPlan: "Recall Reminder Plan",
      emptyMsg: "No message template available for your selection",
      fiscalYearDuration: "Fiscal Year Duration",
      policyAcknowledgeByStaff: {
        allow: "Allow Policy Acknowledgement by Staff",
        approver: "Approved By",
        selectStaffList: "Select Staff from list",
        addManually: "Add Manually",
        addAnotherApprover: "Add Another Approver",
        includeApprover: "Include Approver",
        deleteMessage: "Are you sure you want to delete the approver?",
        deleteModalTitle: "Delete Approver",
      },
    },

    officeBranding: {
      branding: "Branding",
      brandingMoreElements:
        "Add more elements for the following email communications",
      systemGeneratedEmails:
        "System Generated Emails for your Personnel & Patients",
      websiteLink: "Website Link",
      instagramLink: "Instagram Link",
      facebookLink: "Facebook Link",
      linkedinLink: "Linkedin Link",
      officeEmail: "Office Email",
      officePhoneNumber: "Office Phone Number",
      systemEmailsToPateint:
        "System generated emails to Patient, Owner and Staff",
      patientEmailReminder: "Patient Appointment Email Reminders",
      patientRecallReminder: "Patient Recall Email Reminders",
      PatientAppointmentConfirmation:
        "Patient Appointment Confirmation, Create Appointment and Accept Appointment Emails",
      locationOnMap: "Location on Map",
      addToCalendar: "Add to Calendar",
      preview: "Preview",
      emailUs: "Email us",
      visitOurWebsite: "Visit our website",
      yourAppointmentIsOn: "Your appointment is on",
      tel: "Tel",
      address: "Address",
      appointmentToCalendar: "Click to add this appointment to your calendar.",
      ourLocation: "Our Location",
    },

    // Office Specific Appointments

    patients: {
      thisPatientIsUnavailableToTakeCall:
        "This patient is unavailable to take call.",
      patients: "Patients",
      myPatients: "My Patients",
      otherDoctors: "Other Doctors",
      patientName: "Patient Name",
      emailAddress: "Email Address",
      contactNo: "Contact No.",
      status: "Status",
      action: "Action",
      active: "Active",
      inactive: "Inactive",
      searchBy: "Search By Patient Name",
      patientNote: "Patient Notes",
      markAsActive: "Mark as Active",
      markAsInactive: "Mark as Inactive",
      viewMessageHistory: "View Message History",
      patientInfo:
        "This list of appointments represents only the office patient appointments, if you want to view all of your appointments across different offices, you need to select the menu option under your account photo - top right.",
      notFound: "No patients available for your selection",
      appointmentReminder: "Appointment Reminder Plan",
      recallReminderPlan: "Recall Reminder Plan",
      patientNotes: "Patient Notes",
      addNewNote: "Add New Note",
      date: "Date",
      time: "Time",
      createdBy: "Created By",
      notesNotFound: "No notes available for your selection",
      description: "Description",
      patientNoteDetail: "Patient Note Details",
      viewPatienNote: "View Patient Notes",
      activePatientMsg:
        "This patient is deactivated from other offices as well. Do you want to activate this patient from this office only or all offices?",
      deactivePatientMsg:
        "This patient has booked an appointment in your other offices as well. Do you want to deactivate this patient from this office only or all offices?",
      activeOnlyOffice: "Activate this patient from this office only",
      activeMultiOffice: "Activate this patient from all offices",
      activate: "Activate",
      deactiveOnlyOffice: "Deactivate this patient from this office only",
      deactiveMultiOffice: "Deactivate this patient from all offices",
      deactiveConfirmMsg:
        "Are your sure you want to {{deactivate}} this Patient for this Office ?",
      deactivate: "Deactivate",
      patient: "Patient",
      cancel: "Cancle",
      save: "Save",
    },

    patientAppointmentMembers: {
      patientAppointmentModalHeading:
        "How This Online Booking Availability Works",
      patientInactiveError:
        "Patient is inactive. Please activate the patient to book an appointment.",
      patientAppointmentModalDescription:
        "This screen lets you control the times patients can request appointments with you online. It’s important to know that your availability in Miraxis comes from several factors:",
      patientAppointmentModalFirstBullet: "Busy Timeslots (My Schedule)",
      patientAppointmentModalFirstBulletFirst:
        "You can mark times as Busy in your personal schedule for things like personal time, meetings, or other commitments.",
      patientAppointmentModalFirstBulletSecond:
        "These busy times automatically remove you from being available for booking.",
      patientAppointmentModalSecondBullet: "Events in the Office Scheduler",
      patientAppointmentModalSecondBulletFirst:
        " If you are added to an event and it’s marked “Block for online booking”, patients won’t see you as available during that time.",
      patientAppointmentModalSecondBulletSecond:
        "If it’s not blocked, you remain available even if you are invited to that event.",
      patientAppointmentModalThirdBullet: "Patient Appointments",
      patientAppointmentModalThirdBulletFirst:
        "Confirmed patient appointments block your availability for those times.",
      patientAppointmentModalFourthBullet:
        "This Screen – Online Booking Availability",
      patientAppointmentModalFourthBulletFirst:
        "This is where you can manually block or unblock specific time slots from patient online booking.y",
      patientAppointmentModalFifthBullet: "Click a time to toggle it between",
      patientAppointmentModalFifthBulletFirst:
        "Booked (green) – A confirmed patient booking",
      patientAppointmentModalFifthBulletSecond:
        "Available (white) – Open for online booking",
      patientAppointmentModalFifthBulletThird:
        "Blocked (grey) – Patients cannot book you at this time",
      BlockAvailabilityTooltipText:
        "Block your availability and preview how patients see your calendar when booking online",
      reminderNotFound:
        "No appointment reminder plan available for your selection",
      recallReminderNotFound:
        "No recall reminder plan available for your selection",
      patientAppointments: "Patient Appointments",
      SeeTodayScheduleBtn: "See Today’s Schedule",
      newAppointment: " New Appointment",
      addAppointment: " Add Appointment",
      upcoming: "Upcoming",
      blocked: "Blocked",
      recall: "Recall",
      past: "Past",
      details: "DETAILS",
      notes: "NOTES",
      covidForm: "COVID FORM",
      history: "HISTORY",
      yourAnswer: "Your Answer",
      patientHistory: "Patient’s History",
      DescriptionTreatmentNeeded: "Description/Treatment Needed",
      AddedByYou: "Added by you",
      saveNote: "Save Note",
      cancel: "Cancel",
      notesSmall: "Notes",
      addNote: "AddNote",
      addedBy: "Added by",
      viewSubmittedQuestions: "View Submitted Questions",
      markAsComplete: "Mark as Complete ",
      confirmation: " Confirmation",
      makeItRecurring: "Make it Recurring",
      SelectRecallTime: "Select Recall Time",
      reasonForRejection: "Reason for Rejection",
      theReasonWillBeSentToThePatient:
        "The reason will be sent to the patient.",
      reschedule: "Reschedule",
      reassign: "Reassign",
      pending: "Pending",
      appointmentFor: "Appointment for",
      dateOfAppointment: "Date of Appointment",
      reject: "Reject",
      accept: "Accept",
      patientAppointmentDetails: "Patient Appointment Details",
      urbanDental: "Urban Dental",
      submittedQuestionnaire: "Patient Appointment's Submitted Questionnaire",
      yesConfirm: "Yes, Confirm",
      areYouSureYouWantToCancelNextVisit:
        "Are you sure you want to Cancel Next Visit?",
      cancelAppointment: "Cancel Appointment",
      createAppointment: " Create Appointment",
      available: "Available",
      booked: "Booked",
      SelectTimeslotsAndThenChooseIfYouWantToBlockIt:
        "Select timeslots and then choose if you want to block it.",
      pst: "PST",
      timezone: "Timezone",
      bookingTimeslot: "Booking Timeslot",
      doctorName: "Doctor Name",
      selectDateTime: "Select Date/Time",
      selectNextRecall: "Select Next Recall",
      LinkToNextRecall: "Link to Next Recall",
      createAppointmentForRecall: "Create Appointment for Recall",
      patientAndAppointmentDetails: "Patient and Appointment Details",
      patientName: "Patient Name",
      patientEmailAddress: "Patient’s Email Address",
      doctor: "Doctor",
      clinicName: "Clinic Name",
      messageToPatients: "Message To Patients",
      typeOfAppointment: "Type of Appointment",
      selectType: "Select Type",
      changeType: "Change Type",
      reminderPlan: "Reminder Plan",
      selectReminderPlan: "Select Reminder Plan",
      changeReminderPlan: "Change Reminder Plan",
      addAppointmentReminderPlan: "Add Appointment Reminder Plan",
      apply: "Apply",
      ReminderPlanText:
        "Changing the Reminder Plan will change the entire reminder plan below",
      addNewReminderPlan: "Add New Reminder Plan",
      selectAppointmentReminderPlan: "Select Appointment Reminder Plan",
      delete: "Delete",
      selectMessageTemplate: "Select Message Template",
      save: "Save",
      addNewReminder: "Add New Reminder",
      addNewType: "Add New Type",
      acceptAppointment: "Accept Appointment",
      yesCancel: "Yes, Cancel",
      newTypeHere: "New Type Here",
      appointmentReminderPlanText:
        "This list of appointments represents your own patient appointments across all the offices. If you want to view office specific patient appointments for all doctors, you need to click on the office tile in the main page and select the patient appointments option.",
      reassignUrbanDental: "Urban Dental",
      reassignAppointment: "Reassign Appointment",
      SelectDoctorSchedule:
        "Select the doctors who you want to view their schedules.",
      reassignDoctor: "Doctor",
      reassignTimezone: "Timezone",
      reassignPst: "PST",
      reassignBookingTimeslot: "Booking Timeslot",
      reassignBooked: "Booked",
      reassignAvailable: "Available",
      reassignBlocked: "Blocked",
      reassigncreateAppointment: "Create Appointment",
      reassignCancelBtn: "Cancel",
      reassignUnblockTimeslot: "Unblock Timeslot",
      todayPatientAppointments: `Today's Patient Appointments`,
      seeAllAppointments: "See All Appointment",
      remiderPlanNotFound:
        "No appointment reminder plan available for your selection",
      selectReminderPlanMsg:
        "Please Select A Reminder Plan From Select Reminder Dropdown",
      hours: "Hours",
      days: "Days",
      months: "Months",
      years: "Years",
      beforDueDate: "Before Due Date",
      isEmail: "Email",
      isSms: "SMS",
      isPushNotification: "Notification",
      before: "Before",
      addAppointmnetReminderPlan: "Add Appointment Reminder Plan",
      specifyName: "Specify Reminder Name",
      selectTemplate: "Select Message Template",
      createMessageTemplate: "Create Message Template",
      confirm: "Confirm",
      deleteReminderMsg: "Are you sure you want to delete selected Reminder ?",
      reminderValidation: "Please add at least one reminder.",
      reminderNameValidation: "Please specify the reminder name.",
      reminderBeforeDayValidation:
        "The selected days cannot be more than 365 days.",
      reminderBeforeMonthValidation:
        "The selected months cannot be more than 12 months.",
      reminderBeforeYearValidation:
        "The selected year cannot be more than 1 year.",
      reminderBeforeHourValidation:
        "The selected hours cannot be more than 24 hours.",
      reminderAlreadyExistValidation: "Same reminder already exists.",
      reminderBeforeZeroValidation:
        "The before due date must be greater than 0.",
      reminderBeforeRangeValidation:
        "The before due date must not be greate than 9.",
      reminderMsgTempValidation:
        "Please select the message template for reminders.",
      reminderServiceValidation:
        "Please select atleast one service to create the reminder plan.",
      reminderSameDueDate: "Same due date already exists in current plan.",
      updateReminderMsg:
        "You have made some changes in the reminder template {{templateName}}",
      updateReminderConfirmMsg:
        "Do you want to replace the previously saved template with new one?",
      replace: "Replace",
      applyWithoutSaving: "Apply Without Saving",
      submit: "Submit",
      cancelRequestTitle: "Reason for Cancellation",
      cancelRequestLabel: "The reason will be sent to patient",
      deleteRequestTitle: "Delete Request?",
      deleteRequestMsg:
        "Once deleted, the request will be deleted from the Waiting List. Are you sure you want to delete the request ?",
      confirmationMsg: "Are you sure you want to Confirm Appointment ?",
      confirmationNextVisitMsg: "Are you sure you want to Cancel Next Visit ?",
      newPatient: "New Patient",
      pmsNewPaitensMtd: "PMS New Patients MTD",
      pmsNewPaitensYtd: "PMS New Patients YTD",
      pmsNewPaitens: "PMS New Patients MTD",
      upComingAppointments: "Upcoming Appointments",
      upComingConfirmedAppointments: "Confirmed Appointments",
      upComingUnConfirmedAppointments: "Unconfirmed Appointments",
      upComingCompletedAppointments: "Total Completed Appointments",
      upComingRecallAppointments: "Upcoming Recalls",
      overDueRecallAppointments: "Overdue Recalls",
      convertedeRecallAppointments: "Converted Recalls",
      appointmentDashboard: "Appointment Dashboard",
      cancelNextVisit: "Cancel Next Visit",
      markAsCompeltedToaster: "Appointment Mark as Completed",
      appointmentTypeDeleteMsg:
        "Are you sure you want to delete selected Type ?",
      selectTypeError: "Please select type of appointments",
      messageErro: "Note should be less than 256 characters.",
      noteError: "Please add a note.",
      reasonOfRejection: "Reason of Rejection",
      reasonOfCancellation: "Reason of Cancellation",
      changeDate: "Change Date",
      suboptions: "Sub-options",
      patientPersonalDetail: "Patient personal details",
      viewCovidForm: "View Covid-19 Form",
      contactNo: "Contact No.",
      emailAddress: "Email Address",
      gender: "Gender",
      dateOfBirth: "Date of Birth & Age",
      location: "Location",
      noPhoneNumber: "No Phone number Added",
      notDateOfBirth: "Date of Birth not added",
      noLocation: "No Location added",
      patientAppointmentHisotry: "Patient's Appointment History",
      selectOffice: " Select Office ",
      description: "Description",
      errorMsg:
        "We could not find the patient in our system. Please enter the email address of the patient so we can invite the patient to Miraxis.",
      viewFeedback: "View Feedback",
      feedback: "Feedback",
      addYourComment: "Please add your Comment",
      manageSchedule: "Manage Booking Availability",
      trackScheduleChanges: "Track Schedule Changes",
      appointmentUpdated: "Appointment Updated",
      scheduleUpdated: "Schedule Updated",
      appointment: "Appointment",
      schedule: "Schedule",
      date: "Date",
      time: "Time",
      doneBy: "Done By",
      scheduleUpdatedfor: "Schedule Updated for",
      notAvailable: "No track schedule available for your selection",
      unblockSelectedDate: "Unblock only for selected date",
      repeatUnblock: "Repeat this unblock for all",
      repeatUnblockforAll: "Repeat this unblock for all Future Days - Everyday",
      blockTimeSlot: "Block Time Slot",
      blockSelectedDate: "Block only for selected date",
      repeatblock: "Repeat this block for all",
      repeatblockforAll: "Repeat this block for all Future Days - Everyday",
      name: "Name",
      email: "Email",
      contact: "Contact No",
      faimlyMemberMsg:
        "The contact details of the person who requested this appointment are mentioned below.",
      nextRecall: "Next Recall",
      editRecall: "Edit Recall",
      messageTemPlate: "Message Template",
      appointmentAsAccepted: "Consider appointment as accepted",
      errorTimeSlot: "please Select at least one time slot",
      editRecallPLan: "Edit Recall Plan",
      nextRecallMsg: "Next Recall Update Successfully",
      typeOfNextVisit: "Type to Next Visit*",
      reasonBlock: "Reason should be less than 256 characters.",
      selectOfficeError: "Please Select Office",
      selectedEmptyMsg:
        "The Selected Day is non-working day. Please select another day to manage the schedule",
      selectDoctor: "Select Doctor",
      changeOfficereminder: "Change Office Reminder Plan",
      createOfficeRemidner: "You Created an Office reminder plan",
      wishToChange:
        "Do you wish to change it for all the appointments in the office or for future appointments only ?",
      changeAllAppointments: "Change for all Appointments",
      changeForFutureAppointments: "Change for Future Appointments",
      noMessageHistory: "No message template available for your selection",
      atleastMessage: "At least One Message type must be enabled.",
      atLeastPaitent: "Please Select patient First.",
      didPatientAttend: "Did patient attend the appointment?",
      doYouWantAddNextRecall: "Do you want to add the next Recall due date?",
      reasonofBlockingTimeSLot: "Reason of Blocking Timeslot",
      manageAvailabilityofPatient:
        "Manage Booking Availability For Patient Appointments",
      onlineBookingAvailability: "Online Booking Availability",
      addPatientAppointment: "Add Patient Appointment",
      recallEmptyMsg: "No recalls available for your selection",
      pastAppointmentNotFound:
        "No past appointments available for your selection",
      upcomingAppointmentNotFound:
        "No upcoming appointments available for your selection",
      entireAppointmentNotFound:
        "No appointment type available for your selection",

      appointmentTableHeading: {
        patientName: "Patient Name",
        office: "Office",
        appointmentDate: "Appointment Date",
        preAppointmentDate: "Pre.Appointment Date",
        dueDate: "Due Date",
        recallType: "Recall Type",
        appointmentTime: "Appointment Time",
        appointmentType: "Appointment Type",
        bookedFor: "Booked By",
        status: "Status",
        action: "Action",
      },

      covidFormQuestions: {
        questionOne: "What is your current body temperature?",
        questionTwo: "Do you have any of the following signs or symptoms?",
        questionThree:
          "Have you travelled or have had close contact with anyone who has travelled in the past 14 days outside of Canada?",
        questionFour:
          "Have you had close contact with anyone who has a confirmed or probable/suspected case of COVID-19 in the last 14 days?",
        questionFive:
          "Have you been tested for COVID-19 and still awaiting results?",
        formNotFilled: "Covid Form Not Filled",
      },

      nextRecallHeading: {
        originalAppointmentDate: "Original Appointment Date",
        recallDueDate: "Recall Due Date",
        recallType: "Recall Type",
      },

      paitnetMessageCenter: {
        PatientMessageCenter: "Patient Message Center",
        AddMessage: "Add Message",
      },
    },
    dashBoard: {
      allRoles: "All Roles",
      managerDashBoard: "Manager Dashboard",
      teamDashboard: "Team Dashboard",
      dashboard: "Dashboard",
      notFoundStaff: "Not found",
      teamChat: "Team Chat",
      patientChat: "Patient Chat",
      invitationNotFound: "No invitations available for your selection",
      showDashBoard: "Showing dashboard for",
      notAccessible:
        "This module is not accessible with your current user role",
      notAccessibleModulePleaseSwitchOwner:
        "This module is not accessible with your current user role. Please switch your owner.",
      approvalsNotFound: "No approvals available for your selection",
      schedulerOnly: "Scheduler Only",
      allModules: "All Modules",
      tasks: "Tasks",
      gotoTasks: "Go to Tasks",
      gotoDashBoard: "Go to Dashboard",
      gotoNotes: "Go to Notes",
      gotoMessenger: "Go to Messenger",
      gotoSchedular: "Go to Scheduler",
      mySelf: "Myself",
      AccountOwner: "Account owner",
      SelectFiscalYear: "Select Fiscal Year",
      timeSheetEmplyMsg: "No timesheet report available for your selection",
      pleaseSelectFiscalYear: "Please select fiscal year",
      office: "office",
    },
  },
};
